/* tslint:disable */
/* eslint-disable */
/**
 * Europrocurement API Utilisateur
 * API de gestion des utilisateurs
 *
 * The version of the OpenAPI document: 2.3.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * Returns antennas collection
 * @export
 * @interface AntennesAntenneRead
 */
export interface AntennesAntenneRead {
    /**
     * 
     * @type {number}
     * @memberof AntennesAntenneRead
     */
    'idAntenne'?: number;
    /**
     * 
     * @type {string}
     * @memberof AntennesAntenneRead
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AntennesAntenneRead
     */
    'isDeleted': boolean;
}
/**
 * Updates the selected antenna informations
 * @export
 * @interface AntennesAntenneUpdate
 */
export interface AntennesAntenneUpdate {
    /**
     * 
     * @type {number}
     * @memberof AntennesAntenneUpdate
     */
    'idAntenne'?: number;
    /**
     * 
     * @type {string}
     * @memberof AntennesAntenneUpdate
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AntennesAntenneUpdate
     */
    'isDeleted': boolean;
}
/**
 * Creates a new antenna in the Tbl_Antenne
 * @export
 * @interface AntennesAntenneWrite
 */
export interface AntennesAntenneWrite {
    /**
     * 
     * @type {number}
     * @memberof AntennesAntenneWrite
     */
    'idAntenne'?: number;
    /**
     * 
     * @type {string}
     * @memberof AntennesAntenneWrite
     */
    'libelle'?: string | null;
}
/**
 * Returns antennas collection
 * @export
 * @interface AntennesJsonldAntenneRead
 */
export interface AntennesJsonldAntenneRead {
    /**
     * 
     * @type {AntennesJsonldAntenneReadContext}
     * @memberof AntennesJsonldAntenneRead
     */
    '@context'?: AntennesJsonldAntenneReadContext;
    /**
     * 
     * @type {string}
     * @memberof AntennesJsonldAntenneRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof AntennesJsonldAntenneRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof AntennesJsonldAntenneRead
     */
    'idAntenne'?: number;
    /**
     * 
     * @type {string}
     * @memberof AntennesJsonldAntenneRead
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AntennesJsonldAntenneRead
     */
    'isDeleted': boolean;
}
/**
 * @type AntennesJsonldAntenneReadContext
 * @export
 */
export type AntennesJsonldAntenneReadContext = AntennesJsonldAntenneReadContextOneOf | string;

/**
 * 
 * @export
 * @interface AntennesJsonldAntenneReadContextOneOf
 */
export interface AntennesJsonldAntenneReadContextOneOf {
    [key: string]: any;

    /**
     * 
     * @type {string}
     * @memberof AntennesJsonldAntenneReadContextOneOf
     */
    '@vocab': string;
    /**
     * 
     * @type {string}
     * @memberof AntennesJsonldAntenneReadContextOneOf
     */
    'hydra': AntennesJsonldAntenneReadContextOneOfHydraEnum;
}

export const AntennesJsonldAntenneReadContextOneOfHydraEnum = {
    HttpWwwW3OrgNsHydraCore: 'http://www.w3.org/ns/hydra/core#'
} as const;

export type AntennesJsonldAntenneReadContextOneOfHydraEnum = typeof AntennesJsonldAntenneReadContextOneOfHydraEnum[keyof typeof AntennesJsonldAntenneReadContextOneOfHydraEnum];

/**
 * Updates the selected antenna informations
 * @export
 * @interface AntennesJsonldAntenneUpdate
 */
export interface AntennesJsonldAntenneUpdate {
    /**
     * 
     * @type {AntennesJsonldAntenneReadContext}
     * @memberof AntennesJsonldAntenneUpdate
     */
    '@context'?: AntennesJsonldAntenneReadContext;
    /**
     * 
     * @type {string}
     * @memberof AntennesJsonldAntenneUpdate
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof AntennesJsonldAntenneUpdate
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof AntennesJsonldAntenneUpdate
     */
    'idAntenne'?: number;
    /**
     * 
     * @type {string}
     * @memberof AntennesJsonldAntenneUpdate
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AntennesJsonldAntenneUpdate
     */
    'isDeleted': boolean;
}
/**
 * Creates a new antenna in the Tbl_Antenne
 * @export
 * @interface AntennesJsonldAntenneWrite
 */
export interface AntennesJsonldAntenneWrite {
    /**
     * 
     * @type {AntennesJsonldAntenneReadContext}
     * @memberof AntennesJsonldAntenneWrite
     */
    '@context'?: AntennesJsonldAntenneReadContext;
    /**
     * 
     * @type {string}
     * @memberof AntennesJsonldAntenneWrite
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof AntennesJsonldAntenneWrite
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof AntennesJsonldAntenneWrite
     */
    'idAntenne'?: number;
    /**
     * 
     * @type {string}
     * @memberof AntennesJsonldAntenneWrite
     */
    'libelle'?: string | null;
}
/**
 * Delete the selected antenna
 * @export
 * @interface AntennesJsonldLock
 */
export interface AntennesJsonldLock {
    /**
     * 
     * @type {AntennesJsonldAntenneReadContext}
     * @memberof AntennesJsonldLock
     */
    '@context'?: AntennesJsonldAntenneReadContext;
    /**
     * 
     * @type {string}
     * @memberof AntennesJsonldLock
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof AntennesJsonldLock
     */
    '@type'?: string;
}
/**
 * Get the antenna by id
 * @export
 * @interface AntennesJsonldUtilisateurRead
 */
export interface AntennesJsonldUtilisateurRead {
    /**
     * 
     * @type {AntennesJsonldAntenneReadContext}
     * @memberof AntennesJsonldUtilisateurRead
     */
    '@context'?: AntennesJsonldAntenneReadContext;
    /**
     * 
     * @type {string}
     * @memberof AntennesJsonldUtilisateurRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof AntennesJsonldUtilisateurRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof AntennesJsonldUtilisateurRead
     */
    'idAntenne'?: number;
    /**
     * 
     * @type {string}
     * @memberof AntennesJsonldUtilisateurRead
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AntennesJsonldUtilisateurRead
     */
    'isDeleted': boolean;
}
/**
 * Get the antenna by id
 * @export
 * @interface AntennesJsonldUtilisateurReadDomaineRead
 */
export interface AntennesJsonldUtilisateurReadDomaineRead {
    /**
     * 
     * @type {AntennesJsonldAntenneReadContext}
     * @memberof AntennesJsonldUtilisateurReadDomaineRead
     */
    '@context'?: AntennesJsonldAntenneReadContext;
    /**
     * 
     * @type {string}
     * @memberof AntennesJsonldUtilisateurReadDomaineRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof AntennesJsonldUtilisateurReadDomaineRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof AntennesJsonldUtilisateurReadDomaineRead
     */
    'idAntenne'?: number;
    /**
     * 
     * @type {string}
     * @memberof AntennesJsonldUtilisateurReadDomaineRead
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AntennesJsonldUtilisateurReadDomaineRead
     */
    'isDeleted': boolean;
}
/**
 * Get the antenna by id
 * @export
 * @interface AntennesJsonldWorkgroupReadUtilisateurReadDomaineRead
 */
export interface AntennesJsonldWorkgroupReadUtilisateurReadDomaineRead {
    /**
     * 
     * @type {AntennesJsonldAntenneReadContext}
     * @memberof AntennesJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    '@context'?: AntennesJsonldAntenneReadContext;
    /**
     * 
     * @type {string}
     * @memberof AntennesJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof AntennesJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof AntennesJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    'idAntenne'?: number;
    /**
     * 
     * @type {string}
     * @memberof AntennesJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AntennesJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    'isDeleted': boolean;
}
/**
 * Get the antenna by id
 * @export
 * @interface AntennesUtilisateurRead
 */
export interface AntennesUtilisateurRead {
    /**
     * 
     * @type {number}
     * @memberof AntennesUtilisateurRead
     */
    'idAntenne'?: number;
    /**
     * 
     * @type {string}
     * @memberof AntennesUtilisateurRead
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AntennesUtilisateurRead
     */
    'isDeleted': boolean;
}
/**
 * Get the antenna by id
 * @export
 * @interface AntennesUtilisateurReadDomaineRead
 */
export interface AntennesUtilisateurReadDomaineRead {
    /**
     * 
     * @type {number}
     * @memberof AntennesUtilisateurReadDomaineRead
     */
    'idAntenne'?: number;
    /**
     * 
     * @type {string}
     * @memberof AntennesUtilisateurReadDomaineRead
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AntennesUtilisateurReadDomaineRead
     */
    'isDeleted': boolean;
}
/**
 * Get the antenna by id
 * @export
 * @interface AntennesWorkgroupReadUtilisateurReadDomaineRead
 */
export interface AntennesWorkgroupReadUtilisateurReadDomaineRead {
    /**
     * 
     * @type {number}
     * @memberof AntennesWorkgroupReadUtilisateurReadDomaineRead
     */
    'idAntenne'?: number;
    /**
     * 
     * @type {string}
     * @memberof AntennesWorkgroupReadUtilisateurReadDomaineRead
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AntennesWorkgroupReadUtilisateurReadDomaineRead
     */
    'isDeleted': boolean;
}
/**
 * 
 * @export
 * @interface ApiAntennesGetCollection200Response
 */
export interface ApiAntennesGetCollection200Response {
    /**
     * 
     * @type {Array<AntennesJsonldAntenneRead>}
     * @memberof ApiAntennesGetCollection200Response
     */
    'hydra:member': Array<AntennesJsonldAntenneRead>;
    /**
     * 
     * @type {number}
     * @memberof ApiAntennesGetCollection200Response
     */
    'hydra:totalItems'?: number;
    /**
     * 
     * @type {ApiAntennesGetCollection200ResponseHydraView}
     * @memberof ApiAntennesGetCollection200Response
     */
    'hydra:view'?: ApiAntennesGetCollection200ResponseHydraView;
    /**
     * 
     * @type {ApiAntennesGetCollection200ResponseHydraSearch}
     * @memberof ApiAntennesGetCollection200Response
     */
    'hydra:search'?: ApiAntennesGetCollection200ResponseHydraSearch;
}
/**
 * 
 * @export
 * @interface ApiAntennesGetCollection200ResponseHydraSearch
 */
export interface ApiAntennesGetCollection200ResponseHydraSearch {
    /**
     * 
     * @type {string}
     * @memberof ApiAntennesGetCollection200ResponseHydraSearch
     */
    '@type'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiAntennesGetCollection200ResponseHydraSearch
     */
    'hydra:template'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiAntennesGetCollection200ResponseHydraSearch
     */
    'hydra:variableRepresentation'?: string;
    /**
     * 
     * @type {Array<ApiAntennesGetCollection200ResponseHydraSearchHydraMappingInner>}
     * @memberof ApiAntennesGetCollection200ResponseHydraSearch
     */
    'hydra:mapping'?: Array<ApiAntennesGetCollection200ResponseHydraSearchHydraMappingInner>;
}
/**
 * 
 * @export
 * @interface ApiAntennesGetCollection200ResponseHydraSearchHydraMappingInner
 */
export interface ApiAntennesGetCollection200ResponseHydraSearchHydraMappingInner {
    /**
     * 
     * @type {string}
     * @memberof ApiAntennesGetCollection200ResponseHydraSearchHydraMappingInner
     */
    '@type'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiAntennesGetCollection200ResponseHydraSearchHydraMappingInner
     */
    'variable'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiAntennesGetCollection200ResponseHydraSearchHydraMappingInner
     */
    'property'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAntennesGetCollection200ResponseHydraSearchHydraMappingInner
     */
    'required'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiAntennesGetCollection200ResponseHydraView
 */
export interface ApiAntennesGetCollection200ResponseHydraView {
    /**
     * 
     * @type {string}
     * @memberof ApiAntennesGetCollection200ResponseHydraView
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiAntennesGetCollection200ResponseHydraView
     */
    '@type'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiAntennesGetCollection200ResponseHydraView
     */
    'hydra:first'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiAntennesGetCollection200ResponseHydraView
     */
    'hydra:last'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiAntennesGetCollection200ResponseHydraView
     */
    'hydra:previous'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiAntennesGetCollection200ResponseHydraView
     */
    'hydra:next'?: string;
}
/**
 * 
 * @export
 * @interface ApiAntennesGetCollection401Response
 */
export interface ApiAntennesGetCollection401Response {
    /**
     * 
     * @type {string}
     * @memberof ApiAntennesGetCollection401Response
     */
    'message'?: string;
}
/**
 * 
 * @export
 * @interface ApiAntennesGetCollection403Response
 */
export interface ApiAntennesGetCollection403Response {
    /**
     * 
     * @type {string}
     * @memberof ApiAntennesGetCollection403Response
     */
    'error'?: string;
    /**
     * 
     * @type {ApiAntennesGetCollection403ResponseException}
     * @memberof ApiAntennesGetCollection403Response
     */
    'exception'?: ApiAntennesGetCollection403ResponseException;
}
/**
 * 
 * @export
 * @interface ApiAntennesGetCollection403ResponseException
 */
export interface ApiAntennesGetCollection403ResponseException {
    /**
     * 
     * @type {string}
     * @memberof ApiAntennesGetCollection403ResponseException
     */
    'message'?: string;
    /**
     * 
     * @type {number}
     * @memberof ApiAntennesGetCollection403ResponseException
     */
    'code'?: number;
}
/**
 * 
 * @export
 * @interface ApiAntennesGetCollection404Response
 */
export interface ApiAntennesGetCollection404Response {
    /**
     * 
     * @type {string}
     * @memberof ApiAntennesGetCollection404Response
     */
    'error'?: string;
    /**
     * 
     * @type {ApiAntennesGetCollection404ResponseException}
     * @memberof ApiAntennesGetCollection404Response
     */
    'exception'?: ApiAntennesGetCollection404ResponseException;
}
/**
 * 
 * @export
 * @interface ApiAntennesGetCollection404ResponseException
 */
export interface ApiAntennesGetCollection404ResponseException {
    /**
     * 
     * @type {string}
     * @memberof ApiAntennesGetCollection404ResponseException
     */
    'message'?: string;
    /**
     * 
     * @type {number}
     * @memberof ApiAntennesGetCollection404ResponseException
     */
    'code'?: number;
}
/**
 * 
 * @export
 * @interface ApiAntennesPost400Response
 */
export interface ApiAntennesPost400Response {
    /**
     * 
     * @type {string}
     * @memberof ApiAntennesPost400Response
     */
    'error'?: string;
    /**
     * 
     * @type {ApiAntennesPost400ResponseException}
     * @memberof ApiAntennesPost400Response
     */
    'exception'?: ApiAntennesPost400ResponseException;
}
/**
 * 
 * @export
 * @interface ApiAntennesPost400ResponseException
 */
export interface ApiAntennesPost400ResponseException {
    /**
     * 
     * @type {string}
     * @memberof ApiAntennesPost400ResponseException
     */
    'message'?: string;
    /**
     * 
     * @type {number}
     * @memberof ApiAntennesPost400ResponseException
     */
    'code'?: number;
}
/**
 * 
 * @export
 * @interface ApiDomainesGetCollection200Response
 */
export interface ApiDomainesGetCollection200Response {
    /**
     * 
     * @type {Array<DomaineJsonldDomaineRead>}
     * @memberof ApiDomainesGetCollection200Response
     */
    'hydra:member': Array<DomaineJsonldDomaineRead>;
    /**
     * 
     * @type {number}
     * @memberof ApiDomainesGetCollection200Response
     */
    'hydra:totalItems'?: number;
    /**
     * 
     * @type {ApiAntennesGetCollection200ResponseHydraView}
     * @memberof ApiDomainesGetCollection200Response
     */
    'hydra:view'?: ApiAntennesGetCollection200ResponseHydraView;
    /**
     * 
     * @type {ApiAntennesGetCollection200ResponseHydraSearch}
     * @memberof ApiDomainesGetCollection200Response
     */
    'hydra:search'?: ApiAntennesGetCollection200ResponseHydraSearch;
}
/**
 * 
 * @export
 * @interface ApiDroitGetCollection200Response
 */
export interface ApiDroitGetCollection200Response {
    /**
     * 
     * @type {Array<DroitsJsonldDroitReadCollection>}
     * @memberof ApiDroitGetCollection200Response
     */
    'hydra:member': Array<DroitsJsonldDroitReadCollection>;
    /**
     * 
     * @type {number}
     * @memberof ApiDroitGetCollection200Response
     */
    'hydra:totalItems'?: number;
    /**
     * 
     * @type {ApiAntennesGetCollection200ResponseHydraView}
     * @memberof ApiDroitGetCollection200Response
     */
    'hydra:view'?: ApiAntennesGetCollection200ResponseHydraView;
    /**
     * 
     * @type {ApiAntennesGetCollection200ResponseHydraSearch}
     * @memberof ApiDroitGetCollection200Response
     */
    'hydra:search'?: ApiAntennesGetCollection200ResponseHydraSearch;
}
/**
 * 
 * @export
 * @interface ApiGroupesGetCollection200Response
 */
export interface ApiGroupesGetCollection200Response {
    /**
     * 
     * @type {Array<GroupesJsonldGroupReadCollection>}
     * @memberof ApiGroupesGetCollection200Response
     */
    'hydra:member': Array<GroupesJsonldGroupReadCollection>;
    /**
     * 
     * @type {number}
     * @memberof ApiGroupesGetCollection200Response
     */
    'hydra:totalItems'?: number;
    /**
     * 
     * @type {ApiAntennesGetCollection200ResponseHydraView}
     * @memberof ApiGroupesGetCollection200Response
     */
    'hydra:view'?: ApiAntennesGetCollection200ResponseHydraView;
    /**
     * 
     * @type {ApiAntennesGetCollection200ResponseHydraSearch}
     * @memberof ApiGroupesGetCollection200Response
     */
    'hydra:search'?: ApiAntennesGetCollection200ResponseHydraSearch;
}
/**
 * 
 * @export
 * @interface ApiGroupestravailGetCollection200Response
 */
export interface ApiGroupestravailGetCollection200Response {
    /**
     * 
     * @type {Array<GroupesDeTravailJsonldUtilisateurReadDomaineRead>}
     * @memberof ApiGroupestravailGetCollection200Response
     */
    'hydra:member': Array<GroupesDeTravailJsonldUtilisateurReadDomaineRead>;
    /**
     * 
     * @type {number}
     * @memberof ApiGroupestravailGetCollection200Response
     */
    'hydra:totalItems'?: number;
    /**
     * 
     * @type {ApiAntennesGetCollection200ResponseHydraView}
     * @memberof ApiGroupestravailGetCollection200Response
     */
    'hydra:view'?: ApiAntennesGetCollection200ResponseHydraView;
    /**
     * 
     * @type {ApiAntennesGetCollection200ResponseHydraSearch}
     * @memberof ApiGroupestravailGetCollection200Response
     */
    'hydra:search'?: ApiAntennesGetCollection200ResponseHydraSearch;
}
/**
 * 
 * @export
 * @interface ApiJournauxGetCollection200Response
 */
export interface ApiJournauxGetCollection200Response {
    /**
     * 
     * @type {Array<JournauxJsonldJournauxReadCollection>}
     * @memberof ApiJournauxGetCollection200Response
     */
    'hydra:member': Array<JournauxJsonldJournauxReadCollection>;
    /**
     * 
     * @type {number}
     * @memberof ApiJournauxGetCollection200Response
     */
    'hydra:totalItems'?: number;
    /**
     * 
     * @type {ApiAntennesGetCollection200ResponseHydraView}
     * @memberof ApiJournauxGetCollection200Response
     */
    'hydra:view'?: ApiAntennesGetCollection200ResponseHydraView;
    /**
     * 
     * @type {ApiAntennesGetCollection200ResponseHydraSearch}
     * @memberof ApiJournauxGetCollection200Response
     */
    'hydra:search'?: ApiAntennesGetCollection200ResponseHydraSearch;
}
/**
 * 
 * @export
 * @interface ApiKeycloakUtilisateurssynchronizableGetCollection200Response
 */
export interface ApiKeycloakUtilisateurssynchronizableGetCollection200Response {
    /**
     * 
     * @type {Array<UserJsonldUserRead>}
     * @memberof ApiKeycloakUtilisateurssynchronizableGetCollection200Response
     */
    'hydra:member': Array<UserJsonldUserRead>;
    /**
     * 
     * @type {number}
     * @memberof ApiKeycloakUtilisateurssynchronizableGetCollection200Response
     */
    'hydra:totalItems'?: number;
    /**
     * 
     * @type {ApiAntennesGetCollection200ResponseHydraView}
     * @memberof ApiKeycloakUtilisateurssynchronizableGetCollection200Response
     */
    'hydra:view'?: ApiAntennesGetCollection200ResponseHydraView;
    /**
     * 
     * @type {ApiAntennesGetCollection200ResponseHydraSearch}
     * @memberof ApiKeycloakUtilisateurssynchronizableGetCollection200Response
     */
    'hydra:search'?: ApiAntennesGetCollection200ResponseHydraSearch;
}
/**
 * 
 * @export
 * @interface ApiMarquesGetCollection200Response
 */
export interface ApiMarquesGetCollection200Response {
    /**
     * 
     * @type {Array<MarquesJsonldSocieteMarqueReadCollection>}
     * @memberof ApiMarquesGetCollection200Response
     */
    'hydra:member': Array<MarquesJsonldSocieteMarqueReadCollection>;
    /**
     * 
     * @type {number}
     * @memberof ApiMarquesGetCollection200Response
     */
    'hydra:totalItems'?: number;
    /**
     * 
     * @type {ApiAntennesGetCollection200ResponseHydraView}
     * @memberof ApiMarquesGetCollection200Response
     */
    'hydra:view'?: ApiAntennesGetCollection200ResponseHydraView;
    /**
     * 
     * @type {ApiAntennesGetCollection200ResponseHydraSearch}
     * @memberof ApiMarquesGetCollection200Response
     */
    'hydra:search'?: ApiAntennesGetCollection200ResponseHydraSearch;
}
/**
 * 
 * @export
 * @interface ApiPolesGetCollection200Response
 */
export interface ApiPolesGetCollection200Response {
    /**
     * 
     * @type {Array<PolesJsonldDefPoleReadCollection>}
     * @memberof ApiPolesGetCollection200Response
     */
    'hydra:member': Array<PolesJsonldDefPoleReadCollection>;
    /**
     * 
     * @type {number}
     * @memberof ApiPolesGetCollection200Response
     */
    'hydra:totalItems'?: number;
    /**
     * 
     * @type {ApiAntennesGetCollection200ResponseHydraView}
     * @memberof ApiPolesGetCollection200Response
     */
    'hydra:view'?: ApiAntennesGetCollection200ResponseHydraView;
    /**
     * 
     * @type {ApiAntennesGetCollection200ResponseHydraSearch}
     * @memberof ApiPolesGetCollection200Response
     */
    'hydra:search'?: ApiAntennesGetCollection200ResponseHydraSearch;
}
/**
 * 
 * @export
 * @interface ApiServicesGetCollection200Response
 */
export interface ApiServicesGetCollection200Response {
    /**
     * 
     * @type {Array<ServicesJsonldServiceReadCollection>}
     * @memberof ApiServicesGetCollection200Response
     */
    'hydra:member': Array<ServicesJsonldServiceReadCollection>;
    /**
     * 
     * @type {number}
     * @memberof ApiServicesGetCollection200Response
     */
    'hydra:totalItems'?: number;
    /**
     * 
     * @type {ApiAntennesGetCollection200ResponseHydraView}
     * @memberof ApiServicesGetCollection200Response
     */
    'hydra:view'?: ApiAntennesGetCollection200ResponseHydraView;
    /**
     * 
     * @type {ApiAntennesGetCollection200ResponseHydraSearch}
     * @memberof ApiServicesGetCollection200Response
     */
    'hydra:search'?: ApiAntennesGetCollection200ResponseHydraSearch;
}
/**
 * 
 * @export
 * @interface ApiUtilisateurgroupetravailGetCollection200Response
 */
export interface ApiUtilisateurgroupetravailGetCollection200Response {
    /**
     * 
     * @type {Array<JointureUtilisateurGroupeTravailJsonldUserworkgroupRead>}
     * @memberof ApiUtilisateurgroupetravailGetCollection200Response
     */
    'hydra:member': Array<JointureUtilisateurGroupeTravailJsonldUserworkgroupRead>;
    /**
     * 
     * @type {number}
     * @memberof ApiUtilisateurgroupetravailGetCollection200Response
     */
    'hydra:totalItems'?: number;
    /**
     * 
     * @type {ApiAntennesGetCollection200ResponseHydraView}
     * @memberof ApiUtilisateurgroupetravailGetCollection200Response
     */
    'hydra:view'?: ApiAntennesGetCollection200ResponseHydraView;
    /**
     * 
     * @type {ApiAntennesGetCollection200ResponseHydraSearch}
     * @memberof ApiUtilisateurgroupetravailGetCollection200Response
     */
    'hydra:search'?: ApiAntennesGetCollection200ResponseHydraSearch;
}
/**
 * 
 * @export
 * @interface ApiUtilisateursGetCollection200Response
 */
export interface ApiUtilisateursGetCollection200Response {
    /**
     * 
     * @type {Array<UtilisateursJsonldUtilisateurRead>}
     * @memberof ApiUtilisateursGetCollection200Response
     */
    'hydra:member': Array<UtilisateursJsonldUtilisateurRead>;
    /**
     * 
     * @type {number}
     * @memberof ApiUtilisateursGetCollection200Response
     */
    'hydra:totalItems'?: number;
    /**
     * 
     * @type {ApiAntennesGetCollection200ResponseHydraView}
     * @memberof ApiUtilisateursGetCollection200Response
     */
    'hydra:view'?: ApiAntennesGetCollection200ResponseHydraView;
    /**
     * 
     * @type {ApiAntennesGetCollection200ResponseHydraSearch}
     * @memberof ApiUtilisateursGetCollection200Response
     */
    'hydra:search'?: ApiAntennesGetCollection200ResponseHydraSearch;
}
/**
 * Delete avatar image on S3
 * @export
 * @interface AvatarsJsonldAvatarDelete
 */
export interface AvatarsJsonldAvatarDelete {
    /**
     * 
     * @type {AntennesJsonldAntenneReadContext}
     * @memberof AvatarsJsonldAvatarDelete
     */
    '@context'?: AntennesJsonldAntenneReadContext;
    /**
     * 
     * @type {string}
     * @memberof AvatarsJsonldAvatarDelete
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof AvatarsJsonldAvatarDelete
     */
    '@type'?: string;
}
/**
 * Add avatar image on S3
 * @export
 * @interface AvatarsJsonldAvatarResponse
 */
export interface AvatarsJsonldAvatarResponse {
    /**
     * 
     * @type {AntennesJsonldAntenneReadContext}
     * @memberof AvatarsJsonldAvatarResponse
     */
    '@context'?: AntennesJsonldAntenneReadContext;
    /**
     * 
     * @type {string}
     * @memberof AvatarsJsonldAvatarResponse
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof AvatarsJsonldAvatarResponse
     */
    '@type'?: string;
    /**
     * 
     * @type {string}
     * @memberof AvatarsJsonldAvatarResponse
     */
    'url'?: string | null;
}
/**
 * Returns the id corresponding domaine
 * @export
 * @interface DomaineDomaineRead
 */
export interface DomaineDomaineRead {
    /**
     * 
     * @type {number}
     * @memberof DomaineDomaineRead
     */
    'ddmId'?: number;
    /**
     * 
     * @type {string}
     * @memberof DomaineDomaineRead
     */
    'ddmLibelle'?: string | null;
}
/**
 * Returns the id corresponding domaine
 * @export
 * @interface DomaineJsonldDomaineRead
 */
export interface DomaineJsonldDomaineRead {
    /**
     * 
     * @type {AntennesJsonldAntenneReadContext}
     * @memberof DomaineJsonldDomaineRead
     */
    '@context'?: AntennesJsonldAntenneReadContext;
    /**
     * 
     * @type {string}
     * @memberof DomaineJsonldDomaineRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof DomaineJsonldDomaineRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof DomaineJsonldDomaineRead
     */
    'ddmId'?: number;
    /**
     * 
     * @type {string}
     * @memberof DomaineJsonldDomaineRead
     */
    'ddmLibelle'?: string | null;
}
/**
 * Returns the id corresponding domaine
 * @export
 * @interface DomaineJsonldUtilisateurReadDomaineRead
 */
export interface DomaineJsonldUtilisateurReadDomaineRead {
    /**
     * 
     * @type {AntennesJsonldAntenneReadContext}
     * @memberof DomaineJsonldUtilisateurReadDomaineRead
     */
    '@context'?: AntennesJsonldAntenneReadContext;
    /**
     * 
     * @type {string}
     * @memberof DomaineJsonldUtilisateurReadDomaineRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof DomaineJsonldUtilisateurReadDomaineRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof DomaineJsonldUtilisateurReadDomaineRead
     */
    'ddmId'?: number;
    /**
     * 
     * @type {string}
     * @memberof DomaineJsonldUtilisateurReadDomaineRead
     */
    'ddmLibelle'?: string | null;
}
/**
 * Returns the id corresponding domaine
 * @export
 * @interface DomaineJsonldWorkgroupReadUtilisateurReadDomaineRead
 */
export interface DomaineJsonldWorkgroupReadUtilisateurReadDomaineRead {
    /**
     * 
     * @type {AntennesJsonldAntenneReadContext}
     * @memberof DomaineJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    '@context'?: AntennesJsonldAntenneReadContext;
    /**
     * 
     * @type {string}
     * @memberof DomaineJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof DomaineJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof DomaineJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    'ddmId'?: number;
    /**
     * 
     * @type {string}
     * @memberof DomaineJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    'ddmLibelle'?: string | null;
}
/**
 * Returns the id corresponding domaine
 * @export
 * @interface DomaineUtilisateurReadDomaineRead
 */
export interface DomaineUtilisateurReadDomaineRead {
    /**
     * 
     * @type {number}
     * @memberof DomaineUtilisateurReadDomaineRead
     */
    'ddmId'?: number;
    /**
     * 
     * @type {string}
     * @memberof DomaineUtilisateurReadDomaineRead
     */
    'ddmLibelle'?: string | null;
}
/**
 * Returns the id corresponding domaine
 * @export
 * @interface DomaineWorkgroupReadUtilisateurReadDomaineRead
 */
export interface DomaineWorkgroupReadUtilisateurReadDomaineRead {
    /**
     * 
     * @type {number}
     * @memberof DomaineWorkgroupReadUtilisateurReadDomaineRead
     */
    'ddmId'?: number;
    /**
     * 
     * @type {string}
     * @memberof DomaineWorkgroupReadUtilisateurReadDomaineRead
     */
    'ddmLibelle'?: string | null;
}
/**
 * Returns all resources from Tbl_Utilisateur_Droit
 * @export
 * @interface DroitsDroitReadCollection
 */
export interface DroitsDroitReadCollection {
    /**
     * 
     * @type {number}
     * @memberof DroitsDroitReadCollection
     */
    'usdId'?: number;
    /**
     * 
     * @type {UtilisateursDroitReadCollection}
     * @memberof DroitsDroitReadCollection
     */
    'iduser'?: UtilisateursDroitReadCollection | null;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsDroitReadCollection
     */
    'usdAppsJalgest'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DroitsDroitReadCollection
     */
    'usdAppsJalgestOption'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsDroitReadCollection
     */
    'usdAppsXy'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DroitsDroitReadCollection
     */
    'usdAppsXyOption'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsDroitReadCollection
     */
    'usdAppsMdc'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DroitsDroitReadCollection
     */
    'usdAppsMdcOption'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsDroitReadCollection
     */
    'usdAppsMail'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DroitsDroitReadCollection
     */
    'usdAppsMailOption'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsDroitReadCollection
     */
    'usdAppsAnalytics'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsDroitReadCollection
     */
    'usdAppsAnalyticsOption'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsDroitReadCollection
     */
    'usdAppsAnnuaire'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsDroitReadCollection
     */
    'usdAppsAnnuaireOption'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsDroitReadCollection
     */
    'usdAppsSupport'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsDroitReadCollection
     */
    'usdAppsSupportOption'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsDroitReadCollection
     */
    'usdAppsMdcSpel'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DroitsDroitReadCollection
     */
    'usdAppsMdcSpelOption'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsDroitReadCollection
     */
    'usdAppsDocutech'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DroitsDroitReadCollection
     */
    'usdAppsDocutechOption'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsDroitReadCollection
     */
    'usdAppsDocutechBackoffice'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsDroitReadCollection
     */
    'usdAppsGestAbonnes'?: boolean;
}
/**
 * Returns all resources from Tbl_Utilisateur_Droit
 * @export
 * @interface DroitsJsonldDroitReadCollection
 */
export interface DroitsJsonldDroitReadCollection {
    /**
     * 
     * @type {string}
     * @memberof DroitsJsonldDroitReadCollection
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof DroitsJsonldDroitReadCollection
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof DroitsJsonldDroitReadCollection
     */
    'usdId'?: number;
    /**
     * 
     * @type {UtilisateursJsonldDroitReadCollection}
     * @memberof DroitsJsonldDroitReadCollection
     */
    'iduser'?: UtilisateursJsonldDroitReadCollection | null;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsJsonldDroitReadCollection
     */
    'usdAppsJalgest'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DroitsJsonldDroitReadCollection
     */
    'usdAppsJalgestOption'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsJsonldDroitReadCollection
     */
    'usdAppsXy'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DroitsJsonldDroitReadCollection
     */
    'usdAppsXyOption'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsJsonldDroitReadCollection
     */
    'usdAppsMdc'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DroitsJsonldDroitReadCollection
     */
    'usdAppsMdcOption'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsJsonldDroitReadCollection
     */
    'usdAppsMail'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DroitsJsonldDroitReadCollection
     */
    'usdAppsMailOption'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsJsonldDroitReadCollection
     */
    'usdAppsAnalytics'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsJsonldDroitReadCollection
     */
    'usdAppsAnalyticsOption'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsJsonldDroitReadCollection
     */
    'usdAppsAnnuaire'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsJsonldDroitReadCollection
     */
    'usdAppsAnnuaireOption'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsJsonldDroitReadCollection
     */
    'usdAppsSupport'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsJsonldDroitReadCollection
     */
    'usdAppsSupportOption'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsJsonldDroitReadCollection
     */
    'usdAppsMdcSpel'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DroitsJsonldDroitReadCollection
     */
    'usdAppsMdcSpelOption'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsJsonldDroitReadCollection
     */
    'usdAppsDocutech'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DroitsJsonldDroitReadCollection
     */
    'usdAppsDocutechOption'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsJsonldDroitReadCollection
     */
    'usdAppsDocutechBackoffice'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsJsonldDroitReadCollection
     */
    'usdAppsGestAbonnes'?: boolean;
}
/**
 * Returns a specific id resource from Tbl_Utilisateur_Droit
 * @export
 * @interface DroitsJsonldUtilisateurPatchUtilisateur
 */
export interface DroitsJsonldUtilisateurPatchUtilisateur {
    /**
     * 
     * @type {AntennesJsonldAntenneReadContext}
     * @memberof DroitsJsonldUtilisateurPatchUtilisateur
     */
    '@context'?: AntennesJsonldAntenneReadContext;
    /**
     * 
     * @type {string}
     * @memberof DroitsJsonldUtilisateurPatchUtilisateur
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof DroitsJsonldUtilisateurPatchUtilisateur
     */
    '@type'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsJsonldUtilisateurPatchUtilisateur
     */
    'usdAppsJalgest'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DroitsJsonldUtilisateurPatchUtilisateur
     */
    'usdAppsJalgestOption'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsJsonldUtilisateurPatchUtilisateur
     */
    'usdAppsXy'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DroitsJsonldUtilisateurPatchUtilisateur
     */
    'usdAppsXyOption'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsJsonldUtilisateurPatchUtilisateur
     */
    'usdAppsMdc'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DroitsJsonldUtilisateurPatchUtilisateur
     */
    'usdAppsMdcOption'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsJsonldUtilisateurPatchUtilisateur
     */
    'usdAppsAnnuaire'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsJsonldUtilisateurPatchUtilisateur
     */
    'usdAppsAnnuaireOption'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsJsonldUtilisateurPatchUtilisateur
     */
    'usdAppsSupport'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsJsonldUtilisateurPatchUtilisateur
     */
    'usdAppsSupportOption'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsJsonldUtilisateurPatchUtilisateur
     */
    'usdAppsMdcSpel'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DroitsJsonldUtilisateurPatchUtilisateur
     */
    'usdAppsMdcSpelOption'?: string | null;
}
/**
 * Returns a specific id resource from Tbl_Utilisateur_Droit
 * @export
 * @interface DroitsJsonldUtilisateurRead
 */
export interface DroitsJsonldUtilisateurRead {
    /**
     * 
     * @type {AntennesJsonldAntenneReadContext}
     * @memberof DroitsJsonldUtilisateurRead
     */
    '@context'?: AntennesJsonldAntenneReadContext;
    /**
     * 
     * @type {string}
     * @memberof DroitsJsonldUtilisateurRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof DroitsJsonldUtilisateurRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof DroitsJsonldUtilisateurRead
     */
    'usdId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsJsonldUtilisateurRead
     */
    'usdAppsJalgest'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DroitsJsonldUtilisateurRead
     */
    'usdAppsJalgestOption'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsJsonldUtilisateurRead
     */
    'usdAppsXy'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DroitsJsonldUtilisateurRead
     */
    'usdAppsXyOption'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsJsonldUtilisateurRead
     */
    'usdAppsMdc'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DroitsJsonldUtilisateurRead
     */
    'usdAppsMdcOption'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsJsonldUtilisateurRead
     */
    'usdAppsMail'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DroitsJsonldUtilisateurRead
     */
    'usdAppsMailOption'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsJsonldUtilisateurRead
     */
    'usdAppsAnalytics'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsJsonldUtilisateurRead
     */
    'usdAppsAnalyticsOption'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsJsonldUtilisateurRead
     */
    'usdAppsAnnuaire'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsJsonldUtilisateurRead
     */
    'usdAppsAnnuaireOption'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsJsonldUtilisateurRead
     */
    'usdAppsSupport'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsJsonldUtilisateurRead
     */
    'usdAppsSupportOption'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsJsonldUtilisateurRead
     */
    'usdAppsMdcSpel'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DroitsJsonldUtilisateurRead
     */
    'usdAppsMdcSpelOption'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsJsonldUtilisateurRead
     */
    'usdAppsDocutech'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DroitsJsonldUtilisateurRead
     */
    'usdAppsDocutechOption'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsJsonldUtilisateurRead
     */
    'usdAppsDocutechBackoffice'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsJsonldUtilisateurRead
     */
    'usdAppsGestAbonnes'?: boolean;
}
/**
 * Returns a specific id resource from Tbl_Utilisateur_Droit
 * @export
 * @interface DroitsJsonldUtilisateurReadDomaineRead
 */
export interface DroitsJsonldUtilisateurReadDomaineRead {
    /**
     * 
     * @type {AntennesJsonldAntenneReadContext}
     * @memberof DroitsJsonldUtilisateurReadDomaineRead
     */
    '@context'?: AntennesJsonldAntenneReadContext;
    /**
     * 
     * @type {string}
     * @memberof DroitsJsonldUtilisateurReadDomaineRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof DroitsJsonldUtilisateurReadDomaineRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof DroitsJsonldUtilisateurReadDomaineRead
     */
    'usdId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsJsonldUtilisateurReadDomaineRead
     */
    'usdAppsJalgest'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DroitsJsonldUtilisateurReadDomaineRead
     */
    'usdAppsJalgestOption'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsJsonldUtilisateurReadDomaineRead
     */
    'usdAppsXy'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DroitsJsonldUtilisateurReadDomaineRead
     */
    'usdAppsXyOption'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsJsonldUtilisateurReadDomaineRead
     */
    'usdAppsMdc'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DroitsJsonldUtilisateurReadDomaineRead
     */
    'usdAppsMdcOption'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsJsonldUtilisateurReadDomaineRead
     */
    'usdAppsMail'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DroitsJsonldUtilisateurReadDomaineRead
     */
    'usdAppsMailOption'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsJsonldUtilisateurReadDomaineRead
     */
    'usdAppsAnalytics'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsJsonldUtilisateurReadDomaineRead
     */
    'usdAppsAnalyticsOption'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsJsonldUtilisateurReadDomaineRead
     */
    'usdAppsAnnuaire'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsJsonldUtilisateurReadDomaineRead
     */
    'usdAppsAnnuaireOption'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsJsonldUtilisateurReadDomaineRead
     */
    'usdAppsSupport'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsJsonldUtilisateurReadDomaineRead
     */
    'usdAppsSupportOption'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsJsonldUtilisateurReadDomaineRead
     */
    'usdAppsMdcSpel'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DroitsJsonldUtilisateurReadDomaineRead
     */
    'usdAppsMdcSpelOption'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsJsonldUtilisateurReadDomaineRead
     */
    'usdAppsDocutech'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DroitsJsonldUtilisateurReadDomaineRead
     */
    'usdAppsDocutechOption'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsJsonldUtilisateurReadDomaineRead
     */
    'usdAppsDocutechBackoffice'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsJsonldUtilisateurReadDomaineRead
     */
    'usdAppsGestAbonnes'?: boolean;
}
/**
 * Returns a specific id resource from Tbl_Utilisateur_Droit
 * @export
 * @interface DroitsJsonldUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
 */
export interface DroitsJsonldUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur {
    /**
     * 
     * @type {AntennesJsonldAntenneReadContext}
     * @memberof DroitsJsonldUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
     */
    '@context'?: AntennesJsonldAntenneReadContext;
    /**
     * 
     * @type {string}
     * @memberof DroitsJsonldUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof DroitsJsonldUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
     */
    '@type'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsJsonldUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
     */
    'usdAppsJalgest'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DroitsJsonldUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
     */
    'usdAppsJalgestOption'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsJsonldUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
     */
    'usdAppsXy'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DroitsJsonldUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
     */
    'usdAppsXyOption'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsJsonldUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
     */
    'usdAppsMdc'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DroitsJsonldUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
     */
    'usdAppsMdcOption'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsJsonldUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
     */
    'usdAppsAnnuaire'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsJsonldUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
     */
    'usdAppsAnnuaireOption'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsJsonldUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
     */
    'usdAppsSupport'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsJsonldUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
     */
    'usdAppsSupportOption'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsJsonldUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
     */
    'usdAppsMdcSpel'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DroitsJsonldUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
     */
    'usdAppsMdcSpelOption'?: string | null;
}
/**
 * Returns a specific id resource from Tbl_Utilisateur_Droit
 * @export
 * @interface DroitsJsonldUtilisateurWrite
 */
export interface DroitsJsonldUtilisateurWrite {
    /**
     * 
     * @type {boolean}
     * @memberof DroitsJsonldUtilisateurWrite
     */
    'usdAppsJalgest'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DroitsJsonldUtilisateurWrite
     */
    'usdAppsJalgestOption'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsJsonldUtilisateurWrite
     */
    'usdAppsXy'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DroitsJsonldUtilisateurWrite
     */
    'usdAppsXyOption'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsJsonldUtilisateurWrite
     */
    'usdAppsMdc'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DroitsJsonldUtilisateurWrite
     */
    'usdAppsMdcOption'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsJsonldUtilisateurWrite
     */
    'usdAppsMail'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DroitsJsonldUtilisateurWrite
     */
    'usdAppsMailOption'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsJsonldUtilisateurWrite
     */
    'usdAppsAnalytics'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsJsonldUtilisateurWrite
     */
    'usdAppsAnalyticsOption'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsJsonldUtilisateurWrite
     */
    'usdAppsAnnuaire'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsJsonldUtilisateurWrite
     */
    'usdAppsAnnuaireOption'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsJsonldUtilisateurWrite
     */
    'usdAppsSupport'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsJsonldUtilisateurWrite
     */
    'usdAppsSupportOption'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsJsonldUtilisateurWrite
     */
    'usdAppsMdcSpel'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DroitsJsonldUtilisateurWrite
     */
    'usdAppsMdcSpelOption'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsJsonldUtilisateurWrite
     */
    'usdAppsDocutech'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DroitsJsonldUtilisateurWrite
     */
    'usdAppsDocutechOption'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsJsonldUtilisateurWrite
     */
    'usdAppsDocutechBackoffice'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsJsonldUtilisateurWrite
     */
    'usdAppsGestAbonnes'?: boolean;
}
/**
 * Returns a specific id resource from Tbl_Utilisateur_Droit
 * @export
 * @interface DroitsJsonldUtilisateurWriteUtilisateurPostUtilisateur
 */
export interface DroitsJsonldUtilisateurWriteUtilisateurPostUtilisateur {
    /**
     * 
     * @type {AntennesJsonldAntenneReadContext}
     * @memberof DroitsJsonldUtilisateurWriteUtilisateurPostUtilisateur
     */
    '@context'?: AntennesJsonldAntenneReadContext;
    /**
     * 
     * @type {string}
     * @memberof DroitsJsonldUtilisateurWriteUtilisateurPostUtilisateur
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof DroitsJsonldUtilisateurWriteUtilisateurPostUtilisateur
     */
    '@type'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsJsonldUtilisateurWriteUtilisateurPostUtilisateur
     */
    'usdAppsJalgest'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DroitsJsonldUtilisateurWriteUtilisateurPostUtilisateur
     */
    'usdAppsJalgestOption'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsJsonldUtilisateurWriteUtilisateurPostUtilisateur
     */
    'usdAppsXy'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DroitsJsonldUtilisateurWriteUtilisateurPostUtilisateur
     */
    'usdAppsXyOption'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsJsonldUtilisateurWriteUtilisateurPostUtilisateur
     */
    'usdAppsMdc'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DroitsJsonldUtilisateurWriteUtilisateurPostUtilisateur
     */
    'usdAppsMdcOption'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsJsonldUtilisateurWriteUtilisateurPostUtilisateur
     */
    'usdAppsMail'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DroitsJsonldUtilisateurWriteUtilisateurPostUtilisateur
     */
    'usdAppsMailOption'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsJsonldUtilisateurWriteUtilisateurPostUtilisateur
     */
    'usdAppsAnalytics'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsJsonldUtilisateurWriteUtilisateurPostUtilisateur
     */
    'usdAppsAnalyticsOption'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsJsonldUtilisateurWriteUtilisateurPostUtilisateur
     */
    'usdAppsAnnuaire'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsJsonldUtilisateurWriteUtilisateurPostUtilisateur
     */
    'usdAppsAnnuaireOption'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsJsonldUtilisateurWriteUtilisateurPostUtilisateur
     */
    'usdAppsSupport'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsJsonldUtilisateurWriteUtilisateurPostUtilisateur
     */
    'usdAppsSupportOption'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsJsonldUtilisateurWriteUtilisateurPostUtilisateur
     */
    'usdAppsMdcSpel'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DroitsJsonldUtilisateurWriteUtilisateurPostUtilisateur
     */
    'usdAppsMdcSpelOption'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsJsonldUtilisateurWriteUtilisateurPostUtilisateur
     */
    'usdAppsDocutech'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DroitsJsonldUtilisateurWriteUtilisateurPostUtilisateur
     */
    'usdAppsDocutechOption'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsJsonldUtilisateurWriteUtilisateurPostUtilisateur
     */
    'usdAppsDocutechBackoffice'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsJsonldUtilisateurWriteUtilisateurPostUtilisateur
     */
    'usdAppsGestAbonnes'?: boolean;
}
/**
 * Returns a specific id resource from Tbl_Utilisateur_Droit
 * @export
 * @interface DroitsJsonldWorkgroupReadUtilisateurReadDomaineRead
 */
export interface DroitsJsonldWorkgroupReadUtilisateurReadDomaineRead {
    /**
     * 
     * @type {AntennesJsonldAntenneReadContext}
     * @memberof DroitsJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    '@context'?: AntennesJsonldAntenneReadContext;
    /**
     * 
     * @type {string}
     * @memberof DroitsJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof DroitsJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof DroitsJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    'usdId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    'usdAppsJalgest'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DroitsJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    'usdAppsJalgestOption'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    'usdAppsXy'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DroitsJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    'usdAppsXyOption'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    'usdAppsMdc'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DroitsJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    'usdAppsMdcOption'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    'usdAppsMail'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DroitsJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    'usdAppsMailOption'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    'usdAppsAnalytics'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    'usdAppsAnalyticsOption'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    'usdAppsAnnuaire'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    'usdAppsAnnuaireOption'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    'usdAppsSupport'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    'usdAppsSupportOption'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    'usdAppsMdcSpel'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DroitsJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    'usdAppsMdcSpelOption'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    'usdAppsDocutech'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DroitsJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    'usdAppsDocutechOption'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    'usdAppsDocutechBackoffice'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    'usdAppsGestAbonnes'?: boolean;
}
/**
 * Returns a specific id resource from Tbl_Utilisateur_Droit
 * @export
 * @interface DroitsUtilisateurPatchUtilisateur
 */
export interface DroitsUtilisateurPatchUtilisateur {
    /**
     * 
     * @type {boolean}
     * @memberof DroitsUtilisateurPatchUtilisateur
     */
    'usdAppsJalgest'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DroitsUtilisateurPatchUtilisateur
     */
    'usdAppsJalgestOption'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsUtilisateurPatchUtilisateur
     */
    'usdAppsXy'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DroitsUtilisateurPatchUtilisateur
     */
    'usdAppsXyOption'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsUtilisateurPatchUtilisateur
     */
    'usdAppsMdc'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DroitsUtilisateurPatchUtilisateur
     */
    'usdAppsMdcOption'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsUtilisateurPatchUtilisateur
     */
    'usdAppsAnnuaire'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsUtilisateurPatchUtilisateur
     */
    'usdAppsAnnuaireOption'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsUtilisateurPatchUtilisateur
     */
    'usdAppsSupport'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsUtilisateurPatchUtilisateur
     */
    'usdAppsSupportOption'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsUtilisateurPatchUtilisateur
     */
    'usdAppsMdcSpel'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DroitsUtilisateurPatchUtilisateur
     */
    'usdAppsMdcSpelOption'?: string | null;
}
/**
 * Returns a specific id resource from Tbl_Utilisateur_Droit
 * @export
 * @interface DroitsUtilisateurRead
 */
export interface DroitsUtilisateurRead {
    /**
     * 
     * @type {number}
     * @memberof DroitsUtilisateurRead
     */
    'usdId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsUtilisateurRead
     */
    'usdAppsJalgest'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DroitsUtilisateurRead
     */
    'usdAppsJalgestOption'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsUtilisateurRead
     */
    'usdAppsXy'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DroitsUtilisateurRead
     */
    'usdAppsXyOption'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsUtilisateurRead
     */
    'usdAppsMdc'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DroitsUtilisateurRead
     */
    'usdAppsMdcOption'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsUtilisateurRead
     */
    'usdAppsMail'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DroitsUtilisateurRead
     */
    'usdAppsMailOption'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsUtilisateurRead
     */
    'usdAppsAnalytics'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsUtilisateurRead
     */
    'usdAppsAnalyticsOption'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsUtilisateurRead
     */
    'usdAppsAnnuaire'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsUtilisateurRead
     */
    'usdAppsAnnuaireOption'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsUtilisateurRead
     */
    'usdAppsSupport'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsUtilisateurRead
     */
    'usdAppsSupportOption'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsUtilisateurRead
     */
    'usdAppsMdcSpel'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DroitsUtilisateurRead
     */
    'usdAppsMdcSpelOption'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsUtilisateurRead
     */
    'usdAppsDocutech'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DroitsUtilisateurRead
     */
    'usdAppsDocutechOption'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsUtilisateurRead
     */
    'usdAppsDocutechBackoffice'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsUtilisateurRead
     */
    'usdAppsGestAbonnes'?: boolean;
}
/**
 * Returns a specific id resource from Tbl_Utilisateur_Droit
 * @export
 * @interface DroitsUtilisateurReadDomaineRead
 */
export interface DroitsUtilisateurReadDomaineRead {
    /**
     * 
     * @type {number}
     * @memberof DroitsUtilisateurReadDomaineRead
     */
    'usdId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsUtilisateurReadDomaineRead
     */
    'usdAppsJalgest'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DroitsUtilisateurReadDomaineRead
     */
    'usdAppsJalgestOption'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsUtilisateurReadDomaineRead
     */
    'usdAppsXy'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DroitsUtilisateurReadDomaineRead
     */
    'usdAppsXyOption'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsUtilisateurReadDomaineRead
     */
    'usdAppsMdc'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DroitsUtilisateurReadDomaineRead
     */
    'usdAppsMdcOption'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsUtilisateurReadDomaineRead
     */
    'usdAppsMail'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DroitsUtilisateurReadDomaineRead
     */
    'usdAppsMailOption'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsUtilisateurReadDomaineRead
     */
    'usdAppsAnalytics'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsUtilisateurReadDomaineRead
     */
    'usdAppsAnalyticsOption'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsUtilisateurReadDomaineRead
     */
    'usdAppsAnnuaire'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsUtilisateurReadDomaineRead
     */
    'usdAppsAnnuaireOption'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsUtilisateurReadDomaineRead
     */
    'usdAppsSupport'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsUtilisateurReadDomaineRead
     */
    'usdAppsSupportOption'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsUtilisateurReadDomaineRead
     */
    'usdAppsMdcSpel'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DroitsUtilisateurReadDomaineRead
     */
    'usdAppsMdcSpelOption'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsUtilisateurReadDomaineRead
     */
    'usdAppsDocutech'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DroitsUtilisateurReadDomaineRead
     */
    'usdAppsDocutechOption'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsUtilisateurReadDomaineRead
     */
    'usdAppsDocutechBackoffice'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsUtilisateurReadDomaineRead
     */
    'usdAppsGestAbonnes'?: boolean;
}
/**
 * Returns a specific id resource from Tbl_Utilisateur_Droit
 * @export
 * @interface DroitsUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
 */
export interface DroitsUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur {
    /**
     * 
     * @type {boolean}
     * @memberof DroitsUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
     */
    'usdAppsJalgest'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DroitsUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
     */
    'usdAppsJalgestOption'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
     */
    'usdAppsXy'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DroitsUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
     */
    'usdAppsXyOption'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
     */
    'usdAppsMdc'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DroitsUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
     */
    'usdAppsMdcOption'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
     */
    'usdAppsAnnuaire'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
     */
    'usdAppsAnnuaireOption'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
     */
    'usdAppsSupport'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
     */
    'usdAppsSupportOption'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
     */
    'usdAppsMdcSpel'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DroitsUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
     */
    'usdAppsMdcSpelOption'?: string | null;
}
/**
 * Returns a specific id resource from Tbl_Utilisateur_Droit
 * @export
 * @interface DroitsUtilisateurWrite
 */
export interface DroitsUtilisateurWrite {
    /**
     * 
     * @type {boolean}
     * @memberof DroitsUtilisateurWrite
     */
    'usdAppsJalgest'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DroitsUtilisateurWrite
     */
    'usdAppsJalgestOption'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsUtilisateurWrite
     */
    'usdAppsXy'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DroitsUtilisateurWrite
     */
    'usdAppsXyOption'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsUtilisateurWrite
     */
    'usdAppsMdc'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DroitsUtilisateurWrite
     */
    'usdAppsMdcOption'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsUtilisateurWrite
     */
    'usdAppsMail'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DroitsUtilisateurWrite
     */
    'usdAppsMailOption'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsUtilisateurWrite
     */
    'usdAppsAnalytics'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsUtilisateurWrite
     */
    'usdAppsAnalyticsOption'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsUtilisateurWrite
     */
    'usdAppsAnnuaire'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsUtilisateurWrite
     */
    'usdAppsAnnuaireOption'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsUtilisateurWrite
     */
    'usdAppsSupport'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsUtilisateurWrite
     */
    'usdAppsSupportOption'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsUtilisateurWrite
     */
    'usdAppsMdcSpel'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DroitsUtilisateurWrite
     */
    'usdAppsMdcSpelOption'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsUtilisateurWrite
     */
    'usdAppsDocutech'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DroitsUtilisateurWrite
     */
    'usdAppsDocutechOption'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsUtilisateurWrite
     */
    'usdAppsDocutechBackoffice'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsUtilisateurWrite
     */
    'usdAppsGestAbonnes'?: boolean;
}
/**
 * Returns a specific id resource from Tbl_Utilisateur_Droit
 * @export
 * @interface DroitsUtilisateurWriteUtilisateurPostUtilisateur
 */
export interface DroitsUtilisateurWriteUtilisateurPostUtilisateur {
    /**
     * 
     * @type {boolean}
     * @memberof DroitsUtilisateurWriteUtilisateurPostUtilisateur
     */
    'usdAppsJalgest'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DroitsUtilisateurWriteUtilisateurPostUtilisateur
     */
    'usdAppsJalgestOption'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsUtilisateurWriteUtilisateurPostUtilisateur
     */
    'usdAppsXy'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DroitsUtilisateurWriteUtilisateurPostUtilisateur
     */
    'usdAppsXyOption'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsUtilisateurWriteUtilisateurPostUtilisateur
     */
    'usdAppsMdc'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DroitsUtilisateurWriteUtilisateurPostUtilisateur
     */
    'usdAppsMdcOption'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsUtilisateurWriteUtilisateurPostUtilisateur
     */
    'usdAppsMail'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DroitsUtilisateurWriteUtilisateurPostUtilisateur
     */
    'usdAppsMailOption'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsUtilisateurWriteUtilisateurPostUtilisateur
     */
    'usdAppsAnalytics'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsUtilisateurWriteUtilisateurPostUtilisateur
     */
    'usdAppsAnalyticsOption'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsUtilisateurWriteUtilisateurPostUtilisateur
     */
    'usdAppsAnnuaire'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsUtilisateurWriteUtilisateurPostUtilisateur
     */
    'usdAppsAnnuaireOption'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsUtilisateurWriteUtilisateurPostUtilisateur
     */
    'usdAppsSupport'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsUtilisateurWriteUtilisateurPostUtilisateur
     */
    'usdAppsSupportOption'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsUtilisateurWriteUtilisateurPostUtilisateur
     */
    'usdAppsMdcSpel'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DroitsUtilisateurWriteUtilisateurPostUtilisateur
     */
    'usdAppsMdcSpelOption'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsUtilisateurWriteUtilisateurPostUtilisateur
     */
    'usdAppsDocutech'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DroitsUtilisateurWriteUtilisateurPostUtilisateur
     */
    'usdAppsDocutechOption'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsUtilisateurWriteUtilisateurPostUtilisateur
     */
    'usdAppsDocutechBackoffice'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsUtilisateurWriteUtilisateurPostUtilisateur
     */
    'usdAppsGestAbonnes'?: boolean;
}
/**
 * Returns a specific id resource from Tbl_Utilisateur_Droit
 * @export
 * @interface DroitsWorkgroupReadUtilisateurReadDomaineRead
 */
export interface DroitsWorkgroupReadUtilisateurReadDomaineRead {
    /**
     * 
     * @type {number}
     * @memberof DroitsWorkgroupReadUtilisateurReadDomaineRead
     */
    'usdId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsWorkgroupReadUtilisateurReadDomaineRead
     */
    'usdAppsJalgest'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DroitsWorkgroupReadUtilisateurReadDomaineRead
     */
    'usdAppsJalgestOption'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsWorkgroupReadUtilisateurReadDomaineRead
     */
    'usdAppsXy'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DroitsWorkgroupReadUtilisateurReadDomaineRead
     */
    'usdAppsXyOption'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsWorkgroupReadUtilisateurReadDomaineRead
     */
    'usdAppsMdc'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DroitsWorkgroupReadUtilisateurReadDomaineRead
     */
    'usdAppsMdcOption'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsWorkgroupReadUtilisateurReadDomaineRead
     */
    'usdAppsMail'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DroitsWorkgroupReadUtilisateurReadDomaineRead
     */
    'usdAppsMailOption'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsWorkgroupReadUtilisateurReadDomaineRead
     */
    'usdAppsAnalytics'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsWorkgroupReadUtilisateurReadDomaineRead
     */
    'usdAppsAnalyticsOption'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsWorkgroupReadUtilisateurReadDomaineRead
     */
    'usdAppsAnnuaire'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsWorkgroupReadUtilisateurReadDomaineRead
     */
    'usdAppsAnnuaireOption'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsWorkgroupReadUtilisateurReadDomaineRead
     */
    'usdAppsSupport'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsWorkgroupReadUtilisateurReadDomaineRead
     */
    'usdAppsSupportOption'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsWorkgroupReadUtilisateurReadDomaineRead
     */
    'usdAppsMdcSpel'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DroitsWorkgroupReadUtilisateurReadDomaineRead
     */
    'usdAppsMdcSpelOption'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsWorkgroupReadUtilisateurReadDomaineRead
     */
    'usdAppsDocutech'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DroitsWorkgroupReadUtilisateurReadDomaineRead
     */
    'usdAppsDocutechOption'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsWorkgroupReadUtilisateurReadDomaineRead
     */
    'usdAppsDocutechBackoffice'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DroitsWorkgroupReadUtilisateurReadDomaineRead
     */
    'usdAppsGestAbonnes'?: boolean;
}
/**
 * Creates a new workgroup
 * @export
 * @interface GroupesDeTravail
 */
export interface GroupesDeTravail {
    /**
     * 
     * @type {string}
     * @memberof GroupesDeTravail
     */
    'idGroupeTravail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GroupesDeTravail
     */
    'lib'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupesDeTravail
     */
    'domaine'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GroupesDeTravail
     */
    'fDelete'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof GroupesDeTravail
     */
    'iduserReferent'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupesDeTravail
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GroupesDeTravail
     */
    'phone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GroupesDeTravail
     */
    'dCreation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GroupesDeTravail
     */
    'dCloture'?: string | null;
    /**
     * 
     * @type {Array<GroupesDeTravailInscriptionsInner>}
     * @memberof GroupesDeTravail
     */
    'inscriptions'?: Array<GroupesDeTravailInscriptionsInner>;
}
/**
 * 
 * @export
 * @interface GroupesDeTravailInscriptionsInner
 */
export interface GroupesDeTravailInscriptionsInner {
    /**
     * 
     * @type {number}
     * @memberof GroupesDeTravailInscriptionsInner
     */
    'idUserGroupeTravail'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof GroupesDeTravailInscriptionsInner
     */
    'user'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupesDeTravailInscriptionsInner
     */
    'groupetravail'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GroupesDeTravailInscriptionsInner
     */
    'fDelete'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GroupesDeTravailInscriptionsInner
     */
    'dDebut'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GroupesDeTravailInscriptionsInner
     */
    'dFin'?: string | null;
}
/**
 * Creates a new workgroup
 * @export
 * @interface GroupesDeTravailJsonld
 */
export interface GroupesDeTravailJsonld {
    /**
     * 
     * @type {AntennesJsonldAntenneReadContext}
     * @memberof GroupesDeTravailJsonld
     */
    '@context'?: AntennesJsonldAntenneReadContext;
    /**
     * 
     * @type {string}
     * @memberof GroupesDeTravailJsonld
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupesDeTravailJsonld
     */
    '@type'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupesDeTravailJsonld
     */
    'idGroupeTravail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GroupesDeTravailJsonld
     */
    'lib'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupesDeTravailJsonld
     */
    'domaine'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GroupesDeTravailJsonld
     */
    'fDelete'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof GroupesDeTravailJsonld
     */
    'iduserReferent'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupesDeTravailJsonld
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GroupesDeTravailJsonld
     */
    'phone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GroupesDeTravailJsonld
     */
    'dCreation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GroupesDeTravailJsonld
     */
    'dCloture'?: string | null;
    /**
     * 
     * @type {Array<GroupesDeTravailInscriptionsInner>}
     * @memberof GroupesDeTravailJsonld
     */
    'inscriptions'?: Array<GroupesDeTravailInscriptionsInner>;
}
/**
 * Soft Delete workgroup
 * @export
 * @interface GroupesDeTravailJsonldLock
 */
export interface GroupesDeTravailJsonldLock {
    /**
     * 
     * @type {AntennesJsonldAntenneReadContext}
     * @memberof GroupesDeTravailJsonldLock
     */
    '@context'?: AntennesJsonldAntenneReadContext;
    /**
     * 
     * @type {string}
     * @memberof GroupesDeTravailJsonldLock
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupesDeTravailJsonldLock
     */
    '@type'?: string;
}
/**
 * Returns the id corresponding workgroup
 * @export
 * @interface GroupesDeTravailJsonldUserworkgroupRead
 */
export interface GroupesDeTravailJsonldUserworkgroupRead {
    /**
     * 
     * @type {AntennesJsonldAntenneReadContext}
     * @memberof GroupesDeTravailJsonldUserworkgroupRead
     */
    '@context'?: AntennesJsonldAntenneReadContext;
    /**
     * 
     * @type {string}
     * @memberof GroupesDeTravailJsonldUserworkgroupRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupesDeTravailJsonldUserworkgroupRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof GroupesDeTravailJsonldUserworkgroupRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof GroupesDeTravailJsonldUserworkgroupRead
     */
    'lib': string;
    /**
     * 
     * @type {boolean}
     * @memberof GroupesDeTravailJsonldUserworkgroupRead
     */
    'fDelete'?: boolean;
    /**
     * 
     * @type {UtilisateursJsonldUserworkgroupRead}
     * @memberof GroupesDeTravailJsonldUserworkgroupRead
     */
    'iduserReferent'?: UtilisateursJsonldUserworkgroupRead | null;
    /**
     * 
     * @type {string}
     * @memberof GroupesDeTravailJsonldUserworkgroupRead
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GroupesDeTravailJsonldUserworkgroupRead
     */
    'dCloture'?: string | null;
}
/**
 * Returns the id corresponding workgroup
 * @export
 * @interface GroupesDeTravailJsonldUtilisateurRead
 */
export interface GroupesDeTravailJsonldUtilisateurRead {
    /**
     * 
     * @type {AntennesJsonldAntenneReadContext}
     * @memberof GroupesDeTravailJsonldUtilisateurRead
     */
    '@context'?: AntennesJsonldAntenneReadContext;
    /**
     * 
     * @type {string}
     * @memberof GroupesDeTravailJsonldUtilisateurRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupesDeTravailJsonldUtilisateurRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof GroupesDeTravailJsonldUtilisateurRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof GroupesDeTravailJsonldUtilisateurRead
     */
    'lib': string;
    /**
     * 
     * @type {string}
     * @memberof GroupesDeTravailJsonldUtilisateurRead
     */
    'domaine'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GroupesDeTravailJsonldUtilisateurRead
     */
    'fDelete'?: boolean;
    /**
     * 
     * @type {UtilisateursJsonldUtilisateurRead}
     * @memberof GroupesDeTravailJsonldUtilisateurRead
     */
    'iduserReferent'?: UtilisateursJsonldUtilisateurRead | null;
    /**
     * 
     * @type {string}
     * @memberof GroupesDeTravailJsonldUtilisateurRead
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GroupesDeTravailJsonldUtilisateurRead
     */
    'phone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GroupesDeTravailJsonldUtilisateurRead
     */
    'dCreation'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupesDeTravailJsonldUtilisateurRead
     */
    'dCloture'?: string | null;
}
/**
 * Returns the workgroups collection
 * @export
 * @interface GroupesDeTravailJsonldUtilisateurReadDomaineRead
 */
export interface GroupesDeTravailJsonldUtilisateurReadDomaineRead {
    /**
     * 
     * @type {string}
     * @memberof GroupesDeTravailJsonldUtilisateurReadDomaineRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupesDeTravailJsonldUtilisateurReadDomaineRead
     */
    '@type'?: string;
    /**
     * 
     * @type {AntennesJsonldAntenneReadContext}
     * @memberof GroupesDeTravailJsonldUtilisateurReadDomaineRead
     */
    '@context'?: AntennesJsonldAntenneReadContext;
    /**
     * 
     * @type {number}
     * @memberof GroupesDeTravailJsonldUtilisateurReadDomaineRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof GroupesDeTravailJsonldUtilisateurReadDomaineRead
     */
    'lib': string;
    /**
     * 
     * @type {DomaineJsonldUtilisateurReadDomaineRead}
     * @memberof GroupesDeTravailJsonldUtilisateurReadDomaineRead
     */
    'domaine'?: DomaineJsonldUtilisateurReadDomaineRead | null;
    /**
     * 
     * @type {boolean}
     * @memberof GroupesDeTravailJsonldUtilisateurReadDomaineRead
     */
    'fDelete'?: boolean;
    /**
     * 
     * @type {UtilisateursJsonldUtilisateurReadDomaineRead}
     * @memberof GroupesDeTravailJsonldUtilisateurReadDomaineRead
     */
    'iduserReferent'?: UtilisateursJsonldUtilisateurReadDomaineRead | null;
    /**
     * 
     * @type {string}
     * @memberof GroupesDeTravailJsonldUtilisateurReadDomaineRead
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GroupesDeTravailJsonldUtilisateurReadDomaineRead
     */
    'phone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GroupesDeTravailJsonldUtilisateurReadDomaineRead
     */
    'dCreation'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupesDeTravailJsonldUtilisateurReadDomaineRead
     */
    'dCloture'?: string | null;
}
/**
 * Returns the id corresponding workgroup
 * @export
 * @interface GroupesDeTravailJsonldWorkgroupReadUtilisateurReadDomaineRead
 */
export interface GroupesDeTravailJsonldWorkgroupReadUtilisateurReadDomaineRead {
    /**
     * 
     * @type {AntennesJsonldAntenneReadContext}
     * @memberof GroupesDeTravailJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    '@context'?: AntennesJsonldAntenneReadContext;
    /**
     * 
     * @type {string}
     * @memberof GroupesDeTravailJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupesDeTravailJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof GroupesDeTravailJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof GroupesDeTravailJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    'lib': string;
    /**
     * 
     * @type {DomaineJsonldWorkgroupReadUtilisateurReadDomaineRead}
     * @memberof GroupesDeTravailJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    'domaine'?: DomaineJsonldWorkgroupReadUtilisateurReadDomaineRead | null;
    /**
     * 
     * @type {boolean}
     * @memberof GroupesDeTravailJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    'fDelete'?: boolean;
    /**
     * 
     * @type {UtilisateursJsonldWorkgroupReadUtilisateurReadDomaineRead}
     * @memberof GroupesDeTravailJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    'iduserReferent'?: UtilisateursJsonldWorkgroupReadUtilisateurReadDomaineRead | null;
    /**
     * 
     * @type {string}
     * @memberof GroupesDeTravailJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GroupesDeTravailJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    'phone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GroupesDeTravailJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    'dCreation'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupesDeTravailJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    'dCloture'?: string | null;
    /**
     * 
     * @type {Array<UtilisateursJsonldWorkgroupReadUtilisateurReadDomaineRead>}
     * @memberof GroupesDeTravailJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    'members'?: Array<UtilisateursJsonldWorkgroupReadUtilisateurReadDomaineRead>;
}
/**
 * Returns the id corresponding workgroup
 * @export
 * @interface GroupesDeTravailUserworkgroupRead
 */
export interface GroupesDeTravailUserworkgroupRead {
    /**
     * 
     * @type {number}
     * @memberof GroupesDeTravailUserworkgroupRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof GroupesDeTravailUserworkgroupRead
     */
    'lib': string;
    /**
     * 
     * @type {boolean}
     * @memberof GroupesDeTravailUserworkgroupRead
     */
    'fDelete'?: boolean;
    /**
     * 
     * @type {UtilisateursUserworkgroupRead}
     * @memberof GroupesDeTravailUserworkgroupRead
     */
    'iduserReferent'?: UtilisateursUserworkgroupRead | null;
    /**
     * 
     * @type {string}
     * @memberof GroupesDeTravailUserworkgroupRead
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GroupesDeTravailUserworkgroupRead
     */
    'dCloture'?: string | null;
}
/**
 * Returns the id corresponding workgroup
 * @export
 * @interface GroupesDeTravailUtilisateurRead
 */
export interface GroupesDeTravailUtilisateurRead {
    /**
     * 
     * @type {number}
     * @memberof GroupesDeTravailUtilisateurRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof GroupesDeTravailUtilisateurRead
     */
    'lib': string;
    /**
     * 
     * @type {string}
     * @memberof GroupesDeTravailUtilisateurRead
     */
    'domaine'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GroupesDeTravailUtilisateurRead
     */
    'fDelete'?: boolean;
    /**
     * 
     * @type {UtilisateursUtilisateurRead}
     * @memberof GroupesDeTravailUtilisateurRead
     */
    'iduserReferent'?: UtilisateursUtilisateurRead | null;
    /**
     * 
     * @type {string}
     * @memberof GroupesDeTravailUtilisateurRead
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GroupesDeTravailUtilisateurRead
     */
    'phone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GroupesDeTravailUtilisateurRead
     */
    'dCreation'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupesDeTravailUtilisateurRead
     */
    'dCloture'?: string | null;
}
/**
 * Returns the workgroups collection
 * @export
 * @interface GroupesDeTravailUtilisateurReadDomaineRead
 */
export interface GroupesDeTravailUtilisateurReadDomaineRead {
    /**
     * 
     * @type {number}
     * @memberof GroupesDeTravailUtilisateurReadDomaineRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof GroupesDeTravailUtilisateurReadDomaineRead
     */
    'lib': string;
    /**
     * 
     * @type {DomaineUtilisateurReadDomaineRead}
     * @memberof GroupesDeTravailUtilisateurReadDomaineRead
     */
    'domaine'?: DomaineUtilisateurReadDomaineRead | null;
    /**
     * 
     * @type {boolean}
     * @memberof GroupesDeTravailUtilisateurReadDomaineRead
     */
    'fDelete'?: boolean;
    /**
     * 
     * @type {UtilisateursUtilisateurReadDomaineRead}
     * @memberof GroupesDeTravailUtilisateurReadDomaineRead
     */
    'iduserReferent'?: UtilisateursUtilisateurReadDomaineRead | null;
    /**
     * 
     * @type {string}
     * @memberof GroupesDeTravailUtilisateurReadDomaineRead
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GroupesDeTravailUtilisateurReadDomaineRead
     */
    'phone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GroupesDeTravailUtilisateurReadDomaineRead
     */
    'dCreation'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupesDeTravailUtilisateurReadDomaineRead
     */
    'dCloture'?: string | null;
}
/**
 * Returns the id corresponding workgroup
 * @export
 * @interface GroupesDeTravailWorkgroupReadUtilisateurReadDomaineRead
 */
export interface GroupesDeTravailWorkgroupReadUtilisateurReadDomaineRead {
    /**
     * 
     * @type {number}
     * @memberof GroupesDeTravailWorkgroupReadUtilisateurReadDomaineRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof GroupesDeTravailWorkgroupReadUtilisateurReadDomaineRead
     */
    'lib': string;
    /**
     * 
     * @type {DomaineWorkgroupReadUtilisateurReadDomaineRead}
     * @memberof GroupesDeTravailWorkgroupReadUtilisateurReadDomaineRead
     */
    'domaine'?: DomaineWorkgroupReadUtilisateurReadDomaineRead | null;
    /**
     * 
     * @type {boolean}
     * @memberof GroupesDeTravailWorkgroupReadUtilisateurReadDomaineRead
     */
    'fDelete'?: boolean;
    /**
     * 
     * @type {UtilisateursWorkgroupReadUtilisateurReadDomaineRead}
     * @memberof GroupesDeTravailWorkgroupReadUtilisateurReadDomaineRead
     */
    'iduserReferent'?: UtilisateursWorkgroupReadUtilisateurReadDomaineRead | null;
    /**
     * 
     * @type {string}
     * @memberof GroupesDeTravailWorkgroupReadUtilisateurReadDomaineRead
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GroupesDeTravailWorkgroupReadUtilisateurReadDomaineRead
     */
    'phone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GroupesDeTravailWorkgroupReadUtilisateurReadDomaineRead
     */
    'dCreation'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupesDeTravailWorkgroupReadUtilisateurReadDomaineRead
     */
    'dCloture'?: string | null;
    /**
     * 
     * @type {Array<UtilisateursWorkgroupReadUtilisateurReadDomaineRead>}
     * @memberof GroupesDeTravailWorkgroupReadUtilisateurReadDomaineRead
     */
    'members'?: Array<UtilisateursWorkgroupReadUtilisateurReadDomaineRead>;
}
/**
 * Returns the groups collection
 * @export
 * @interface GroupesGroupReadCollection
 */
export interface GroupesGroupReadCollection {
    /**
     * 
     * @type {number}
     * @memberof GroupesGroupReadCollection
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof GroupesGroupReadCollection
     */
    'groupName'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupesGroupReadCollection
     */
    'note'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GroupesGroupReadCollection
     */
    'flagDelete'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof GroupesGroupReadCollection
     */
    'userMaj'?: number;
    /**
     * 
     * @type {string}
     * @memberof GroupesGroupReadCollection
     */
    'dateMaj'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GroupesGroupReadCollection
     */
    'group'?: number;
}
/**
 * Returns the groups collection
 * @export
 * @interface GroupesJsonldGroupReadCollection
 */
export interface GroupesJsonldGroupReadCollection {
    /**
     * 
     * @type {string}
     * @memberof GroupesJsonldGroupReadCollection
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupesJsonldGroupReadCollection
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof GroupesJsonldGroupReadCollection
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof GroupesJsonldGroupReadCollection
     */
    'groupName'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupesJsonldGroupReadCollection
     */
    'note'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GroupesJsonldGroupReadCollection
     */
    'flagDelete'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof GroupesJsonldGroupReadCollection
     */
    'userMaj'?: number;
    /**
     * 
     * @type {string}
     * @memberof GroupesJsonldGroupReadCollection
     */
    'dateMaj'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GroupesJsonldGroupReadCollection
     */
    'group'?: number;
}
/**
 * 
 * @export
 * @interface GroupesJsonldUtilisateurRead
 */
export interface GroupesJsonldUtilisateurRead {
    /**
     * 
     * @type {AntennesJsonldAntenneReadContext}
     * @memberof GroupesJsonldUtilisateurRead
     */
    '@context'?: AntennesJsonldAntenneReadContext;
    /**
     * 
     * @type {string}
     * @memberof GroupesJsonldUtilisateurRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupesJsonldUtilisateurRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof GroupesJsonldUtilisateurRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof GroupesJsonldUtilisateurRead
     */
    'groupName'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupesJsonldUtilisateurRead
     */
    'note'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GroupesJsonldUtilisateurRead
     */
    'flagDelete'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof GroupesJsonldUtilisateurRead
     */
    'userMaj'?: number;
    /**
     * 
     * @type {string}
     * @memberof GroupesJsonldUtilisateurRead
     */
    'dateMaj'?: string | null;
}
/**
 * 
 * @export
 * @interface GroupesJsonldUtilisateurReadDomaineRead
 */
export interface GroupesJsonldUtilisateurReadDomaineRead {
    /**
     * 
     * @type {AntennesJsonldAntenneReadContext}
     * @memberof GroupesJsonldUtilisateurReadDomaineRead
     */
    '@context'?: AntennesJsonldAntenneReadContext;
    /**
     * 
     * @type {string}
     * @memberof GroupesJsonldUtilisateurReadDomaineRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupesJsonldUtilisateurReadDomaineRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof GroupesJsonldUtilisateurReadDomaineRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof GroupesJsonldUtilisateurReadDomaineRead
     */
    'groupName'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupesJsonldUtilisateurReadDomaineRead
     */
    'note'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GroupesJsonldUtilisateurReadDomaineRead
     */
    'flagDelete'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof GroupesJsonldUtilisateurReadDomaineRead
     */
    'userMaj'?: number;
    /**
     * 
     * @type {string}
     * @memberof GroupesJsonldUtilisateurReadDomaineRead
     */
    'dateMaj'?: string | null;
}
/**
 * 
 * @export
 * @interface GroupesJsonldWorkgroupReadUtilisateurReadDomaineRead
 */
export interface GroupesJsonldWorkgroupReadUtilisateurReadDomaineRead {
    /**
     * 
     * @type {AntennesJsonldAntenneReadContext}
     * @memberof GroupesJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    '@context'?: AntennesJsonldAntenneReadContext;
    /**
     * 
     * @type {string}
     * @memberof GroupesJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupesJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof GroupesJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof GroupesJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    'groupName'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupesJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    'note'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GroupesJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    'flagDelete'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof GroupesJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    'userMaj'?: number;
    /**
     * 
     * @type {string}
     * @memberof GroupesJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    'dateMaj'?: string | null;
}
/**
 * 
 * @export
 * @interface GroupesUtilisateurRead
 */
export interface GroupesUtilisateurRead {
    /**
     * 
     * @type {number}
     * @memberof GroupesUtilisateurRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof GroupesUtilisateurRead
     */
    'groupName'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupesUtilisateurRead
     */
    'note'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GroupesUtilisateurRead
     */
    'flagDelete'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof GroupesUtilisateurRead
     */
    'userMaj'?: number;
    /**
     * 
     * @type {string}
     * @memberof GroupesUtilisateurRead
     */
    'dateMaj'?: string | null;
}
/**
 * 
 * @export
 * @interface GroupesUtilisateurReadDomaineRead
 */
export interface GroupesUtilisateurReadDomaineRead {
    /**
     * 
     * @type {number}
     * @memberof GroupesUtilisateurReadDomaineRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof GroupesUtilisateurReadDomaineRead
     */
    'groupName'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupesUtilisateurReadDomaineRead
     */
    'note'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GroupesUtilisateurReadDomaineRead
     */
    'flagDelete'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof GroupesUtilisateurReadDomaineRead
     */
    'userMaj'?: number;
    /**
     * 
     * @type {string}
     * @memberof GroupesUtilisateurReadDomaineRead
     */
    'dateMaj'?: string | null;
}
/**
 * 
 * @export
 * @interface GroupesWorkgroupReadUtilisateurReadDomaineRead
 */
export interface GroupesWorkgroupReadUtilisateurReadDomaineRead {
    /**
     * 
     * @type {number}
     * @memberof GroupesWorkgroupReadUtilisateurReadDomaineRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof GroupesWorkgroupReadUtilisateurReadDomaineRead
     */
    'groupName'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupesWorkgroupReadUtilisateurReadDomaineRead
     */
    'note'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GroupesWorkgroupReadUtilisateurReadDomaineRead
     */
    'flagDelete'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof GroupesWorkgroupReadUtilisateurReadDomaineRead
     */
    'userMaj'?: number;
    /**
     * 
     * @type {string}
     * @memberof GroupesWorkgroupReadUtilisateurReadDomaineRead
     */
    'dateMaj'?: string | null;
}
/**
 * Get user/workgroup inscription collection
 * @export
 * @interface JointureUtilisateurGroupeTravailJsonldUserworkgroupRead
 */
export interface JointureUtilisateurGroupeTravailJsonldUserworkgroupRead {
    /**
     * 
     * @type {string}
     * @memberof JointureUtilisateurGroupeTravailJsonldUserworkgroupRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof JointureUtilisateurGroupeTravailJsonldUserworkgroupRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof JointureUtilisateurGroupeTravailJsonldUserworkgroupRead
     */
    'id'?: number;
    /**
     * 
     * @type {UtilisateursJsonldUserworkgroupRead}
     * @memberof JointureUtilisateurGroupeTravailJsonldUserworkgroupRead
     */
    'user'?: UtilisateursJsonldUserworkgroupRead | null;
    /**
     * 
     * @type {GroupesDeTravailJsonldUserworkgroupRead}
     * @memberof JointureUtilisateurGroupeTravailJsonldUserworkgroupRead
     */
    'groupetravail'?: GroupesDeTravailJsonldUserworkgroupRead | null;
    /**
     * 
     * @type {boolean}
     * @memberof JointureUtilisateurGroupeTravailJsonldUserworkgroupRead
     */
    'fDelete'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof JointureUtilisateurGroupeTravailJsonldUserworkgroupRead
     */
    'dDebut'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof JointureUtilisateurGroupeTravailJsonldUserworkgroupRead
     */
    'dFin'?: string | null;
}
/**
 * Returns the id corresponding inscription
 * @export
 * @interface JointureUtilisateurGroupeTravailJsonldWorkgroupReadUtilisateurReadDomaineRead
 */
export interface JointureUtilisateurGroupeTravailJsonldWorkgroupReadUtilisateurReadDomaineRead {
    /**
     * 
     * @type {AntennesJsonldAntenneReadContext}
     * @memberof JointureUtilisateurGroupeTravailJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    '@context'?: AntennesJsonldAntenneReadContext;
    /**
     * 
     * @type {string}
     * @memberof JointureUtilisateurGroupeTravailJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof JointureUtilisateurGroupeTravailJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof JointureUtilisateurGroupeTravailJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    'id'?: number;
}
/**
 * Get user/workgroup inscription collection
 * @export
 * @interface JointureUtilisateurGroupeTravailUserworkgroupRead
 */
export interface JointureUtilisateurGroupeTravailUserworkgroupRead {
    /**
     * 
     * @type {number}
     * @memberof JointureUtilisateurGroupeTravailUserworkgroupRead
     */
    'id'?: number;
    /**
     * 
     * @type {UtilisateursUserworkgroupRead}
     * @memberof JointureUtilisateurGroupeTravailUserworkgroupRead
     */
    'user'?: UtilisateursUserworkgroupRead | null;
    /**
     * 
     * @type {GroupesDeTravailUserworkgroupRead}
     * @memberof JointureUtilisateurGroupeTravailUserworkgroupRead
     */
    'groupetravail'?: GroupesDeTravailUserworkgroupRead | null;
    /**
     * 
     * @type {boolean}
     * @memberof JointureUtilisateurGroupeTravailUserworkgroupRead
     */
    'fDelete'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof JointureUtilisateurGroupeTravailUserworkgroupRead
     */
    'dDebut'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof JointureUtilisateurGroupeTravailUserworkgroupRead
     */
    'dFin'?: string | null;
}
/**
 * Returns the id corresponding inscription
 * @export
 * @interface JointureUtilisateurGroupeTravailWorkgroupReadUtilisateurReadDomaineRead
 */
export interface JointureUtilisateurGroupeTravailWorkgroupReadUtilisateurReadDomaineRead {
    /**
     * 
     * @type {number}
     * @memberof JointureUtilisateurGroupeTravailWorkgroupReadUtilisateurReadDomaineRead
     */
    'id'?: number;
}
/**
 * Returns all resources from Tbl_Utilisateur_Journaux
 * @export
 * @interface JournauxJournauxReadCollection
 */
export interface JournauxJournauxReadCollection {
    /**
     * 
     * @type {number}
     * @memberof JournauxJournauxReadCollection
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof JournauxJournauxReadCollection
     */
    'name'?: string | null;
}
/**
 * Returns all resources from Tbl_Utilisateur_Journaux
 * @export
 * @interface JournauxJsonldJournauxReadCollection
 */
export interface JournauxJsonldJournauxReadCollection {
    /**
     * 
     * @type {string}
     * @memberof JournauxJsonldJournauxReadCollection
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof JournauxJsonldJournauxReadCollection
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof JournauxJsonldJournauxReadCollection
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof JournauxJsonldJournauxReadCollection
     */
    'name'?: string | null;
}
/**
 * Returns the society\'s brands list
 * @export
 * @interface MarquesJsonldSocieteMarqueReadCollection
 */
export interface MarquesJsonldSocieteMarqueReadCollection {
    /**
     * 
     * @type {string}
     * @memberof MarquesJsonldSocieteMarqueReadCollection
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof MarquesJsonldSocieteMarqueReadCollection
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof MarquesJsonldSocieteMarqueReadCollection
     */
    'idMarque'?: number;
    /**
     * 
     * @type {number}
     * @memberof MarquesJsonldSocieteMarqueReadCollection
     */
    'idSociete'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MarquesJsonldSocieteMarqueReadCollection
     */
    'libelle'?: string;
    /**
     * 
     * @type {string}
     * @memberof MarquesJsonldSocieteMarqueReadCollection
     */
    'codeMarque'?: string;
    /**
     * 
     * @type {number}
     * @memberof MarquesJsonldSocieteMarqueReadCollection
     */
    'userCreation'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MarquesJsonldSocieteMarqueReadCollection
     */
    'dateCreation'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MarquesJsonldSocieteMarqueReadCollection
     */
    'flagDelete'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof MarquesJsonldSocieteMarqueReadCollection
     */
    'dateDelete'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MarquesJsonldSocieteMarqueReadCollection
     */
    'userDelete'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MarquesJsonldSocieteMarqueReadCollection
     */
    'piedDePage'?: string | null;
}
/**
 * 
 * @export
 * @interface MarquesJsonldUtilisateurRead
 */
export interface MarquesJsonldUtilisateurRead {
    /**
     * 
     * @type {AntennesJsonldAntenneReadContext}
     * @memberof MarquesJsonldUtilisateurRead
     */
    '@context'?: AntennesJsonldAntenneReadContext;
    /**
     * 
     * @type {string}
     * @memberof MarquesJsonldUtilisateurRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof MarquesJsonldUtilisateurRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof MarquesJsonldUtilisateurRead
     */
    'idMarque'?: number;
    /**
     * 
     * @type {number}
     * @memberof MarquesJsonldUtilisateurRead
     */
    'idSociete'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MarquesJsonldUtilisateurRead
     */
    'libelle'?: string;
    /**
     * 
     * @type {string}
     * @memberof MarquesJsonldUtilisateurRead
     */
    'codeMarque'?: string;
    /**
     * 
     * @type {number}
     * @memberof MarquesJsonldUtilisateurRead
     */
    'userCreation'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MarquesJsonldUtilisateurRead
     */
    'dateCreation'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MarquesJsonldUtilisateurRead
     */
    'flagDelete'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof MarquesJsonldUtilisateurRead
     */
    'dateDelete'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MarquesJsonldUtilisateurRead
     */
    'userDelete'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MarquesJsonldUtilisateurRead
     */
    'piedDePage'?: string | null;
}
/**
 * 
 * @export
 * @interface MarquesJsonldUtilisateurReadDomaineRead
 */
export interface MarquesJsonldUtilisateurReadDomaineRead {
    /**
     * 
     * @type {AntennesJsonldAntenneReadContext}
     * @memberof MarquesJsonldUtilisateurReadDomaineRead
     */
    '@context'?: AntennesJsonldAntenneReadContext;
    /**
     * 
     * @type {string}
     * @memberof MarquesJsonldUtilisateurReadDomaineRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof MarquesJsonldUtilisateurReadDomaineRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof MarquesJsonldUtilisateurReadDomaineRead
     */
    'idMarque'?: number;
    /**
     * 
     * @type {number}
     * @memberof MarquesJsonldUtilisateurReadDomaineRead
     */
    'idSociete'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MarquesJsonldUtilisateurReadDomaineRead
     */
    'libelle'?: string;
    /**
     * 
     * @type {string}
     * @memberof MarquesJsonldUtilisateurReadDomaineRead
     */
    'codeMarque'?: string;
    /**
     * 
     * @type {number}
     * @memberof MarquesJsonldUtilisateurReadDomaineRead
     */
    'userCreation'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MarquesJsonldUtilisateurReadDomaineRead
     */
    'dateCreation'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MarquesJsonldUtilisateurReadDomaineRead
     */
    'flagDelete'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof MarquesJsonldUtilisateurReadDomaineRead
     */
    'dateDelete'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MarquesJsonldUtilisateurReadDomaineRead
     */
    'userDelete'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MarquesJsonldUtilisateurReadDomaineRead
     */
    'piedDePage'?: string | null;
}
/**
 * 
 * @export
 * @interface MarquesJsonldWorkgroupReadUtilisateurReadDomaineRead
 */
export interface MarquesJsonldWorkgroupReadUtilisateurReadDomaineRead {
    /**
     * 
     * @type {AntennesJsonldAntenneReadContext}
     * @memberof MarquesJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    '@context'?: AntennesJsonldAntenneReadContext;
    /**
     * 
     * @type {string}
     * @memberof MarquesJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof MarquesJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof MarquesJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    'idMarque'?: number;
    /**
     * 
     * @type {number}
     * @memberof MarquesJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    'idSociete'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MarquesJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    'libelle'?: string;
    /**
     * 
     * @type {string}
     * @memberof MarquesJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    'codeMarque'?: string;
    /**
     * 
     * @type {number}
     * @memberof MarquesJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    'userCreation'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MarquesJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    'dateCreation'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MarquesJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    'flagDelete'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof MarquesJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    'dateDelete'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MarquesJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    'userDelete'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MarquesJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    'piedDePage'?: string | null;
}
/**
 * Returns the society\'s brands list
 * @export
 * @interface MarquesSocieteMarqueReadCollection
 */
export interface MarquesSocieteMarqueReadCollection {
    /**
     * 
     * @type {number}
     * @memberof MarquesSocieteMarqueReadCollection
     */
    'idMarque'?: number;
    /**
     * 
     * @type {number}
     * @memberof MarquesSocieteMarqueReadCollection
     */
    'idSociete'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MarquesSocieteMarqueReadCollection
     */
    'libelle'?: string;
    /**
     * 
     * @type {string}
     * @memberof MarquesSocieteMarqueReadCollection
     */
    'codeMarque'?: string;
    /**
     * 
     * @type {number}
     * @memberof MarquesSocieteMarqueReadCollection
     */
    'userCreation'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MarquesSocieteMarqueReadCollection
     */
    'dateCreation'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MarquesSocieteMarqueReadCollection
     */
    'flagDelete'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof MarquesSocieteMarqueReadCollection
     */
    'dateDelete'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MarquesSocieteMarqueReadCollection
     */
    'userDelete'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MarquesSocieteMarqueReadCollection
     */
    'piedDePage'?: string | null;
}
/**
 * 
 * @export
 * @interface MarquesUtilisateurRead
 */
export interface MarquesUtilisateurRead {
    /**
     * 
     * @type {number}
     * @memberof MarquesUtilisateurRead
     */
    'idMarque'?: number;
    /**
     * 
     * @type {number}
     * @memberof MarquesUtilisateurRead
     */
    'idSociete'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MarquesUtilisateurRead
     */
    'libelle'?: string;
    /**
     * 
     * @type {string}
     * @memberof MarquesUtilisateurRead
     */
    'codeMarque'?: string;
    /**
     * 
     * @type {number}
     * @memberof MarquesUtilisateurRead
     */
    'userCreation'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MarquesUtilisateurRead
     */
    'dateCreation'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MarquesUtilisateurRead
     */
    'flagDelete'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof MarquesUtilisateurRead
     */
    'dateDelete'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MarquesUtilisateurRead
     */
    'userDelete'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MarquesUtilisateurRead
     */
    'piedDePage'?: string | null;
}
/**
 * 
 * @export
 * @interface MarquesUtilisateurReadDomaineRead
 */
export interface MarquesUtilisateurReadDomaineRead {
    /**
     * 
     * @type {number}
     * @memberof MarquesUtilisateurReadDomaineRead
     */
    'idMarque'?: number;
    /**
     * 
     * @type {number}
     * @memberof MarquesUtilisateurReadDomaineRead
     */
    'idSociete'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MarquesUtilisateurReadDomaineRead
     */
    'libelle'?: string;
    /**
     * 
     * @type {string}
     * @memberof MarquesUtilisateurReadDomaineRead
     */
    'codeMarque'?: string;
    /**
     * 
     * @type {number}
     * @memberof MarquesUtilisateurReadDomaineRead
     */
    'userCreation'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MarquesUtilisateurReadDomaineRead
     */
    'dateCreation'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MarquesUtilisateurReadDomaineRead
     */
    'flagDelete'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof MarquesUtilisateurReadDomaineRead
     */
    'dateDelete'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MarquesUtilisateurReadDomaineRead
     */
    'userDelete'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MarquesUtilisateurReadDomaineRead
     */
    'piedDePage'?: string | null;
}
/**
 * 
 * @export
 * @interface MarquesWorkgroupReadUtilisateurReadDomaineRead
 */
export interface MarquesWorkgroupReadUtilisateurReadDomaineRead {
    /**
     * 
     * @type {number}
     * @memberof MarquesWorkgroupReadUtilisateurReadDomaineRead
     */
    'idMarque'?: number;
    /**
     * 
     * @type {number}
     * @memberof MarquesWorkgroupReadUtilisateurReadDomaineRead
     */
    'idSociete'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MarquesWorkgroupReadUtilisateurReadDomaineRead
     */
    'libelle'?: string;
    /**
     * 
     * @type {string}
     * @memberof MarquesWorkgroupReadUtilisateurReadDomaineRead
     */
    'codeMarque'?: string;
    /**
     * 
     * @type {number}
     * @memberof MarquesWorkgroupReadUtilisateurReadDomaineRead
     */
    'userCreation'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MarquesWorkgroupReadUtilisateurReadDomaineRead
     */
    'dateCreation'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MarquesWorkgroupReadUtilisateurReadDomaineRead
     */
    'flagDelete'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof MarquesWorkgroupReadUtilisateurReadDomaineRead
     */
    'dateDelete'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MarquesWorkgroupReadUtilisateurReadDomaineRead
     */
    'userDelete'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MarquesWorkgroupReadUtilisateurReadDomaineRead
     */
    'piedDePage'?: string | null;
}
/**
 * Returns the TBL poles collection
 * @export
 * @interface PolesDefPoleReadCollection
 */
export interface PolesDefPoleReadCollection {
    /**
     * 
     * @type {number}
     * @memberof PolesDefPoleReadCollection
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof PolesDefPoleReadCollection
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PolesDefPoleReadCollection
     */
    'info'?: string | null;
}
/**
 * Returns the TBL poles collection
 * @export
 * @interface PolesJsonldDefPoleReadCollection
 */
export interface PolesJsonldDefPoleReadCollection {
    /**
     * 
     * @type {string}
     * @memberof PolesJsonldDefPoleReadCollection
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof PolesJsonldDefPoleReadCollection
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof PolesJsonldDefPoleReadCollection
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof PolesJsonldDefPoleReadCollection
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PolesJsonldDefPoleReadCollection
     */
    'info'?: string | null;
}
/**
 * 
 * @export
 * @interface PolesJsonldUtilisateurRead
 */
export interface PolesJsonldUtilisateurRead {
    /**
     * 
     * @type {AntennesJsonldAntenneReadContext}
     * @memberof PolesJsonldUtilisateurRead
     */
    '@context'?: AntennesJsonldAntenneReadContext;
    /**
     * 
     * @type {string}
     * @memberof PolesJsonldUtilisateurRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof PolesJsonldUtilisateurRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof PolesJsonldUtilisateurRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof PolesJsonldUtilisateurRead
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PolesJsonldUtilisateurRead
     */
    'info'?: string | null;
}
/**
 * 
 * @export
 * @interface PolesJsonldUtilisateurReadDomaineRead
 */
export interface PolesJsonldUtilisateurReadDomaineRead {
    /**
     * 
     * @type {AntennesJsonldAntenneReadContext}
     * @memberof PolesJsonldUtilisateurReadDomaineRead
     */
    '@context'?: AntennesJsonldAntenneReadContext;
    /**
     * 
     * @type {string}
     * @memberof PolesJsonldUtilisateurReadDomaineRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof PolesJsonldUtilisateurReadDomaineRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof PolesJsonldUtilisateurReadDomaineRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof PolesJsonldUtilisateurReadDomaineRead
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PolesJsonldUtilisateurReadDomaineRead
     */
    'info'?: string | null;
}
/**
 * 
 * @export
 * @interface PolesJsonldWorkgroupReadUtilisateurReadDomaineRead
 */
export interface PolesJsonldWorkgroupReadUtilisateurReadDomaineRead {
    /**
     * 
     * @type {AntennesJsonldAntenneReadContext}
     * @memberof PolesJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    '@context'?: AntennesJsonldAntenneReadContext;
    /**
     * 
     * @type {string}
     * @memberof PolesJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof PolesJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof PolesJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof PolesJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PolesJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    'info'?: string | null;
}
/**
 * 
 * @export
 * @interface PolesUtilisateurRead
 */
export interface PolesUtilisateurRead {
    /**
     * 
     * @type {number}
     * @memberof PolesUtilisateurRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof PolesUtilisateurRead
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PolesUtilisateurRead
     */
    'info'?: string | null;
}
/**
 * 
 * @export
 * @interface PolesUtilisateurReadDomaineRead
 */
export interface PolesUtilisateurReadDomaineRead {
    /**
     * 
     * @type {number}
     * @memberof PolesUtilisateurReadDomaineRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof PolesUtilisateurReadDomaineRead
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PolesUtilisateurReadDomaineRead
     */
    'info'?: string | null;
}
/**
 * 
 * @export
 * @interface PolesWorkgroupReadUtilisateurReadDomaineRead
 */
export interface PolesWorkgroupReadUtilisateurReadDomaineRead {
    /**
     * 
     * @type {number}
     * @memberof PolesWorkgroupReadUtilisateurReadDomaineRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof PolesWorkgroupReadUtilisateurReadDomaineRead
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PolesWorkgroupReadUtilisateurReadDomaineRead
     */
    'info'?: string | null;
}
/**
 * Returns all resources from Tbl_Def_Service
 * @export
 * @interface ServicesJsonldServiceReadCollection
 */
export interface ServicesJsonldServiceReadCollection {
    /**
     * 
     * @type {string}
     * @memberof ServicesJsonldServiceReadCollection
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ServicesJsonldServiceReadCollection
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof ServicesJsonldServiceReadCollection
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ServicesJsonldServiceReadCollection
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServicesJsonldServiceReadCollection
     */
    'info'?: string | null;
}
/**
 * Resources from Tbl_Def_Service
 * @export
 * @interface ServicesJsonldUserworkgroupRead
 */
export interface ServicesJsonldUserworkgroupRead {
    /**
     * 
     * @type {AntennesJsonldAntenneReadContext}
     * @memberof ServicesJsonldUserworkgroupRead
     */
    '@context'?: AntennesJsonldAntenneReadContext;
    /**
     * 
     * @type {string}
     * @memberof ServicesJsonldUserworkgroupRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ServicesJsonldUserworkgroupRead
     */
    '@type'?: string;
    /**
     * 
     * @type {string}
     * @memberof ServicesJsonldUserworkgroupRead
     */
    'libelle'?: string | null;
}
/**
 * Resources from Tbl_Def_Service
 * @export
 * @interface ServicesJsonldUtilisateurRead
 */
export interface ServicesJsonldUtilisateurRead {
    /**
     * 
     * @type {AntennesJsonldAntenneReadContext}
     * @memberof ServicesJsonldUtilisateurRead
     */
    '@context'?: AntennesJsonldAntenneReadContext;
    /**
     * 
     * @type {string}
     * @memberof ServicesJsonldUtilisateurRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ServicesJsonldUtilisateurRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof ServicesJsonldUtilisateurRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ServicesJsonldUtilisateurRead
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServicesJsonldUtilisateurRead
     */
    'info'?: string | null;
}
/**
 * Resources from Tbl_Def_Service
 * @export
 * @interface ServicesJsonldUtilisateurReadDomaineRead
 */
export interface ServicesJsonldUtilisateurReadDomaineRead {
    /**
     * 
     * @type {AntennesJsonldAntenneReadContext}
     * @memberof ServicesJsonldUtilisateurReadDomaineRead
     */
    '@context'?: AntennesJsonldAntenneReadContext;
    /**
     * 
     * @type {string}
     * @memberof ServicesJsonldUtilisateurReadDomaineRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ServicesJsonldUtilisateurReadDomaineRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof ServicesJsonldUtilisateurReadDomaineRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ServicesJsonldUtilisateurReadDomaineRead
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServicesJsonldUtilisateurReadDomaineRead
     */
    'info'?: string | null;
}
/**
 * Resources from Tbl_Def_Service
 * @export
 * @interface ServicesJsonldWorkgroupReadUtilisateurReadDomaineRead
 */
export interface ServicesJsonldWorkgroupReadUtilisateurReadDomaineRead {
    /**
     * 
     * @type {AntennesJsonldAntenneReadContext}
     * @memberof ServicesJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    '@context'?: AntennesJsonldAntenneReadContext;
    /**
     * 
     * @type {string}
     * @memberof ServicesJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ServicesJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof ServicesJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ServicesJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServicesJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    'info'?: string | null;
}
/**
 * Returns all resources from Tbl_Def_Service
 * @export
 * @interface ServicesServiceReadCollection
 */
export interface ServicesServiceReadCollection {
    /**
     * 
     * @type {number}
     * @memberof ServicesServiceReadCollection
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ServicesServiceReadCollection
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServicesServiceReadCollection
     */
    'info'?: string | null;
}
/**
 * Resources from Tbl_Def_Service
 * @export
 * @interface ServicesUserworkgroupRead
 */
export interface ServicesUserworkgroupRead {
    /**
     * 
     * @type {string}
     * @memberof ServicesUserworkgroupRead
     */
    'libelle'?: string | null;
}
/**
 * Resources from Tbl_Def_Service
 * @export
 * @interface ServicesUtilisateurRead
 */
export interface ServicesUtilisateurRead {
    /**
     * 
     * @type {number}
     * @memberof ServicesUtilisateurRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ServicesUtilisateurRead
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServicesUtilisateurRead
     */
    'info'?: string | null;
}
/**
 * Resources from Tbl_Def_Service
 * @export
 * @interface ServicesUtilisateurReadDomaineRead
 */
export interface ServicesUtilisateurReadDomaineRead {
    /**
     * 
     * @type {number}
     * @memberof ServicesUtilisateurReadDomaineRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ServicesUtilisateurReadDomaineRead
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServicesUtilisateurReadDomaineRead
     */
    'info'?: string | null;
}
/**
 * Resources from Tbl_Def_Service
 * @export
 * @interface ServicesWorkgroupReadUtilisateurReadDomaineRead
 */
export interface ServicesWorkgroupReadUtilisateurReadDomaineRead {
    /**
     * 
     * @type {number}
     * @memberof ServicesWorkgroupReadUtilisateurReadDomaineRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ServicesWorkgroupReadUtilisateurReadDomaineRead
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServicesWorkgroupReadUtilisateurReadDomaineRead
     */
    'info'?: string | null;
}
/**
 * 
 * @export
 * @interface User
 */
export interface User {
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'username'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    'enabled'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    'emailVerified'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'firstName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'lastName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'email'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof User
     */
    'idPrescripteur'?: Array<string> | null;
    /**
     * 
     * @type {number}
     * @memberof User
     */
    'idUserGie'?: number | null;
}
/**
 * 
 * @export
 * @interface UserCreateUser
 */
export interface UserCreateUser {
    /**
     * 
     * @type {string}
     * @memberof UserCreateUser
     */
    'username': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserCreateUser
     */
    'enabled': boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserCreateUser
     */
    'emailVerified': boolean | null;
    /**
     * 
     * @type {string}
     * @memberof UserCreateUser
     */
    'firstName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserCreateUser
     */
    'lastName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserCreateUser
     */
    'email': string | null;
    /**
     * 
     * @type {string}
     * @memberof UserCreateUser
     */
    'password': string | null;
    /**
     * 
     * @type {number}
     * @memberof UserCreateUser
     */
    'idPrescripteur': number | null;
}
/**
 * 
 * @export
 * @interface UserCreateUserJsonld
 */
export interface UserCreateUserJsonld {
    /**
     * 
     * @type {string}
     * @memberof UserCreateUserJsonld
     */
    'username': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserCreateUserJsonld
     */
    'enabled': boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserCreateUserJsonld
     */
    'emailVerified': boolean | null;
    /**
     * 
     * @type {string}
     * @memberof UserCreateUserJsonld
     */
    'firstName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserCreateUserJsonld
     */
    'lastName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserCreateUserJsonld
     */
    'email': string | null;
    /**
     * 
     * @type {string}
     * @memberof UserCreateUserJsonld
     */
    'password': string | null;
    /**
     * 
     * @type {number}
     * @memberof UserCreateUserJsonld
     */
    'idPrescripteur': number | null;
}
/**
 * 
 * @export
 * @interface UserJsonld
 */
export interface UserJsonld {
    /**
     * 
     * @type {AntennesJsonldAntenneReadContext}
     * @memberof UserJsonld
     */
    '@context'?: AntennesJsonldAntenneReadContext;
    /**
     * 
     * @type {string}
     * @memberof UserJsonld
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserJsonld
     */
    '@type'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserJsonld
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserJsonld
     */
    'username'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserJsonld
     */
    'enabled'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserJsonld
     */
    'emailVerified'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof UserJsonld
     */
    'firstName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserJsonld
     */
    'lastName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserJsonld
     */
    'email'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserJsonld
     */
    'idPrescripteur'?: Array<string> | null;
    /**
     * 
     * @type {number}
     * @memberof UserJsonld
     */
    'idUserGie'?: number | null;
}
/**
 * Returns the synchronizable users collection
 * @export
 * @interface UserJsonldUserRead
 */
export interface UserJsonldUserRead {
    /**
     * 
     * @type {AntennesJsonldAntenneReadContext}
     * @memberof UserJsonldUserRead
     */
    '@context'?: AntennesJsonldAntenneReadContext;
    /**
     * 
     * @type {string}
     * @memberof UserJsonldUserRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserJsonldUserRead
     */
    '@type'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserJsonldUserRead
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserJsonldUserRead
     */
    'username'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserJsonldUserRead
     */
    'enabled'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserJsonldUserRead
     */
    'emailVerified'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof UserJsonldUserRead
     */
    'firstName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserJsonldUserRead
     */
    'lastName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserJsonldUserRead
     */
    'email'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserJsonldUserRead
     */
    'idPrescripteur'?: Array<string> | null;
    /**
     * 
     * @type {number}
     * @memberof UserJsonldUserRead
     */
    'idUserGie'?: number | null;
}
/**
 * 
 * @export
 * @interface UserUpdateUser
 */
export interface UserUpdateUser {
    /**
     * 
     * @type {boolean}
     * @memberof UserUpdateUser
     */
    'enabled'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserUpdateUser
     */
    'emailVerified'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof UserUpdateUser
     */
    'firstName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserUpdateUser
     */
    'lastName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserUpdateUser
     */
    'email'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserUpdateUser
     */
    'idPrescripteur'?: Array<string> | null;
}
/**
 * Returns the synchronizable users collection
 * @export
 * @interface UserUserRead
 */
export interface UserUserRead {
    /**
     * 
     * @type {string}
     * @memberof UserUserRead
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserUserRead
     */
    'username'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserUserRead
     */
    'enabled'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserUserRead
     */
    'emailVerified'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof UserUserRead
     */
    'firstName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserUserRead
     */
    'lastName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserUserRead
     */
    'email'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserUserRead
     */
    'idPrescripteur'?: Array<string> | null;
    /**
     * 
     * @type {number}
     * @memberof UserUserRead
     */
    'idUserGie'?: number | null;
}
/**
 * Returns the selected user informations
 * @export
 * @interface UtilisateursDroitReadCollection
 */
export interface UtilisateursDroitReadCollection {
    /**
     * 
     * @type {number}
     * @memberof UtilisateursDroitReadCollection
     */
    'id'?: number;
}
/**
 * Returns the selected user informations
 * @export
 * @interface UtilisateursJsonldDroitReadCollection
 */
export interface UtilisateursJsonldDroitReadCollection {
    /**
     * 
     * @type {AntennesJsonldAntenneReadContext}
     * @memberof UtilisateursJsonldDroitReadCollection
     */
    '@context'?: AntennesJsonldAntenneReadContext;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldDroitReadCollection
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldDroitReadCollection
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursJsonldDroitReadCollection
     */
    'id'?: number;
}
/**
 * Delete the user
 * @export
 * @interface UtilisateursJsonldLock
 */
export interface UtilisateursJsonldLock {
    /**
     * 
     * @type {AntennesJsonldAntenneReadContext}
     * @memberof UtilisateursJsonldLock
     */
    '@context'?: AntennesJsonldAntenneReadContext;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldLock
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldLock
     */
    '@type'?: string;
}
/**
 * Returns the selected user informations
 * @export
 * @interface UtilisateursJsonldUserworkgroupRead
 */
export interface UtilisateursJsonldUserworkgroupRead {
    /**
     * 
     * @type {AntennesJsonldAntenneReadContext}
     * @memberof UtilisateursJsonldUserworkgroupRead
     */
    '@context'?: AntennesJsonldAntenneReadContext;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUserworkgroupRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUserworkgroupRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursJsonldUserworkgroupRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUserworkgroupRead
     */
    'nom'?: string;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUserworkgroupRead
     */
    'prenom'?: string;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUserworkgroupRead
     */
    'mail'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursJsonldUserworkgroupRead
     */
    'formalistDroitLectureDossier'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursJsonldUserworkgroupRead
     */
    'isFormalist'?: boolean | null;
    /**
     * 
     * @type {ServicesJsonldUserworkgroupRead}
     * @memberof UtilisateursJsonldUserworkgroupRead
     */
    'service'?: ServicesJsonldUserworkgroupRead | null;
}
/**
 * Updates only the selected informations of the current user
 * @export
 * @interface UtilisateursJsonldUtilisateurPatchUtilisateur
 */
export interface UtilisateursJsonldUtilisateurPatchUtilisateur {
    /**
     * 
     * @type {AntennesJsonldAntenneReadContext}
     * @memberof UtilisateursJsonldUtilisateurPatchUtilisateur
     */
    '@context'?: AntennesJsonldAntenneReadContext;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurPatchUtilisateur
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurPatchUtilisateur
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursJsonldUtilisateurPatchUtilisateur
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurPatchUtilisateur
     */
    'nom'?: string;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurPatchUtilisateur
     */
    'prenom'?: string;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurPatchUtilisateur
     */
    'initiales'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursJsonldUtilisateurPatchUtilisateur
     */
    'isDeleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurPatchUtilisateur
     */
    'user'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurPatchUtilisateur
     */
    'poste'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurPatchUtilisateur
     */
    'ligneDirecte'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurPatchUtilisateur
     */
    'mail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurPatchUtilisateur
     */
    'pc'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursJsonldUtilisateurPatchUtilisateur
     */
    'isEleveur'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursJsonldUtilisateurPatchUtilisateur
     */
    'hasG3Access'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursJsonldUtilisateurPatchUtilisateur
     */
    'formalistDemo'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursJsonldUtilisateurPatchUtilisateur
     */
    'formalistAdmin'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursJsonldUtilisateurPatchUtilisateur
     */
    'formalistDroitModifDossier'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursJsonldUtilisateurPatchUtilisateur
     */
    'formalistDroitLectureDossier'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursJsonldUtilisateurPatchUtilisateur
     */
    'formalistDroitModifGestion'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursJsonldUtilisateurPatchUtilisateur
     */
    'formalistDroitLectureGestion'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursJsonldUtilisateurPatchUtilisateur
     */
    'formalistDroitSupprDossier'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursJsonldUtilisateurPatchUtilisateur
     */
    'isFormalist'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursJsonldUtilisateurPatchUtilisateur
     */
    'idSociete'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurPatchUtilisateur
     */
    'pole'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurPatchUtilisateur
     */
    'service'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursJsonldUtilisateurPatchUtilisateur
     */
    'raccourciG3Id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurPatchUtilisateur
     */
    'portable'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurPatchUtilisateur
     */
    'fonction'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursJsonldUtilisateurPatchUtilisateur
     */
    'hasVpn'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursJsonldUtilisateurPatchUtilisateur
     */
    'isG3Recetteur'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurPatchUtilisateur
     */
    'formalistDroitMultiSociete'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursJsonldUtilisateurPatchUtilisateur
     */
    'idUserG3'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursJsonldUtilisateurPatchUtilisateur
     */
    'hasComptaSoftware'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurPatchUtilisateur
     */
    'dematFacile'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursJsonldUtilisateurPatchUtilisateur
     */
    'idUserDematfacile'?: number;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurPatchUtilisateur
     */
    'marque'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursJsonldUtilisateurPatchUtilisateur
     */
    'hasAccessL2DF'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursJsonldUtilisateurPatchUtilisateur
     */
    'hasAnnuaire'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursJsonldUtilisateurPatchUtilisateur
     */
    'isAdminApps'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurPatchUtilisateur
     */
    'idGroupeGie'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurPatchUtilisateur
     */
    'binome'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursJsonldUtilisateurPatchUtilisateur
     */
    'idSocieteEmployeur'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurPatchUtilisateur
     */
    'antenne'?: string | null;
    /**
     * 
     * @type {DroitsJsonldUtilisateurPatchUtilisateur}
     * @memberof UtilisateursJsonldUtilisateurPatchUtilisateur
     */
    'droitUtilisateur'?: DroitsJsonldUtilisateurPatchUtilisateur | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurPatchUtilisateur
     */
    'userIdentifier'?: string | null;
}
/**
 * Returns the selected user informations
 * @export
 * @interface UtilisateursJsonldUtilisateurRead
 */
export interface UtilisateursJsonldUtilisateurRead {
    /**
     * 
     * @type {AntennesJsonldAntenneReadContext}
     * @memberof UtilisateursJsonldUtilisateurRead
     */
    '@context'?: AntennesJsonldAntenneReadContext;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursJsonldUtilisateurRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurRead
     */
    'nom'?: string;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurRead
     */
    'prenom'?: string;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurRead
     */
    'login'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursJsonldUtilisateurRead
     */
    'userGroupe'?: number;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurRead
     */
    'initiales'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursJsonldUtilisateurRead
     */
    'isDeleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurRead
     */
    'user'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursJsonldUtilisateurRead
     */
    'userKeycloakId'?: number;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurRead
     */
    'dateMaj'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurRead
     */
    'poste'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurRead
     */
    'ligneDirecte'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurRead
     */
    'mail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurRead
     */
    'pc'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursJsonldUtilisateurRead
     */
    'isEleveur'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursJsonldUtilisateurRead
     */
    'hasG3Access'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursJsonldUtilisateurRead
     */
    'formalistDemo'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursJsonldUtilisateurRead
     */
    'formalistAdmin'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursJsonldUtilisateurRead
     */
    'formalistDroitModifDossier'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursJsonldUtilisateurRead
     */
    'formalistDroitLectureDossier'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursJsonldUtilisateurRead
     */
    'formalistDroitModifGestion'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursJsonldUtilisateurRead
     */
    'formalistDroitLectureGestion'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursJsonldUtilisateurRead
     */
    'formalistDroitSupprDossier'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursJsonldUtilisateurRead
     */
    'isFormalist'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursJsonldUtilisateurRead
     */
    'idSociete'?: number | null;
    /**
     * 
     * @type {PolesJsonldUtilisateurRead}
     * @memberof UtilisateursJsonldUtilisateurRead
     */
    'pole'?: PolesJsonldUtilisateurRead | null;
    /**
     * 
     * @type {ServicesJsonldUtilisateurRead}
     * @memberof UtilisateursJsonldUtilisateurRead
     */
    'service'?: ServicesJsonldUtilisateurRead | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursJsonldUtilisateurRead
     */
    'raccourciG3Id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurRead
     */
    'portable'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurRead
     */
    'fonction'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursJsonldUtilisateurRead
     */
    'hasVpn'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursJsonldUtilisateurRead
     */
    'isG3Recetteur'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurRead
     */
    'formalistDroitMultiSociete'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursJsonldUtilisateurRead
     */
    'idUserG3'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursJsonldUtilisateurRead
     */
    'hasComptaSoftware'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurRead
     */
    'dematFacile'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursJsonldUtilisateurRead
     */
    'idUserDematfacile'?: number;
    /**
     * 
     * @type {MarquesJsonldUtilisateurRead}
     * @memberof UtilisateursJsonldUtilisateurRead
     */
    'marque'?: MarquesJsonldUtilisateurRead | null;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursJsonldUtilisateurRead
     */
    'hasAccessL2DF'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursJsonldUtilisateurRead
     */
    'hasAnnuaire'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursJsonldUtilisateurRead
     */
    'isAdminApps'?: boolean;
    /**
     * 
     * @type {GroupesJsonldUtilisateurRead}
     * @memberof UtilisateursJsonldUtilisateurRead
     */
    'idGroupeGie'?: GroupesJsonldUtilisateurRead | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurRead
     */
    'binome'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursJsonldUtilisateurRead
     */
    'idSocieteEmployeur'?: number | null;
    /**
     * 
     * @type {AntennesJsonldUtilisateurRead}
     * @memberof UtilisateursJsonldUtilisateurRead
     */
    'antenne'?: AntennesJsonldUtilisateurRead | null;
    /**
     * 
     * @type {DroitsJsonldUtilisateurRead}
     * @memberof UtilisateursJsonldUtilisateurRead
     */
    'droitUtilisateur'?: DroitsJsonldUtilisateurRead | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurRead
     */
    'libelleSociete'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurRead
     */
    'libelleSocieteEmployeur'?: string | null;
    /**
     * 
     * @type {Array<GroupesDeTravailJsonldUtilisateurRead>}
     * @memberof UtilisateursJsonldUtilisateurRead
     */
    'groupeTravail'?: Array<GroupesDeTravailJsonldUtilisateurRead>;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurRead
     */
    'userIdentifier'?: string | null;
}
/**
 * Returns the selected user informations
 * @export
 * @interface UtilisateursJsonldUtilisateurReadDomaineRead
 */
export interface UtilisateursJsonldUtilisateurReadDomaineRead {
    /**
     * 
     * @type {AntennesJsonldAntenneReadContext}
     * @memberof UtilisateursJsonldUtilisateurReadDomaineRead
     */
    '@context'?: AntennesJsonldAntenneReadContext;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurReadDomaineRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurReadDomaineRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursJsonldUtilisateurReadDomaineRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurReadDomaineRead
     */
    'nom'?: string;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurReadDomaineRead
     */
    'prenom'?: string;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurReadDomaineRead
     */
    'login'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursJsonldUtilisateurReadDomaineRead
     */
    'userGroupe'?: number;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurReadDomaineRead
     */
    'initiales'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursJsonldUtilisateurReadDomaineRead
     */
    'isDeleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurReadDomaineRead
     */
    'user'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursJsonldUtilisateurReadDomaineRead
     */
    'userKeycloakId'?: number;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurReadDomaineRead
     */
    'dateMaj'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurReadDomaineRead
     */
    'poste'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurReadDomaineRead
     */
    'ligneDirecte'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurReadDomaineRead
     */
    'mail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurReadDomaineRead
     */
    'pc'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursJsonldUtilisateurReadDomaineRead
     */
    'isEleveur'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursJsonldUtilisateurReadDomaineRead
     */
    'hasG3Access'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursJsonldUtilisateurReadDomaineRead
     */
    'formalistDemo'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursJsonldUtilisateurReadDomaineRead
     */
    'formalistAdmin'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursJsonldUtilisateurReadDomaineRead
     */
    'formalistDroitModifDossier'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursJsonldUtilisateurReadDomaineRead
     */
    'formalistDroitLectureDossier'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursJsonldUtilisateurReadDomaineRead
     */
    'formalistDroitModifGestion'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursJsonldUtilisateurReadDomaineRead
     */
    'formalistDroitLectureGestion'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursJsonldUtilisateurReadDomaineRead
     */
    'formalistDroitSupprDossier'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursJsonldUtilisateurReadDomaineRead
     */
    'isFormalist'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursJsonldUtilisateurReadDomaineRead
     */
    'idSociete'?: number | null;
    /**
     * 
     * @type {PolesJsonldUtilisateurReadDomaineRead}
     * @memberof UtilisateursJsonldUtilisateurReadDomaineRead
     */
    'pole'?: PolesJsonldUtilisateurReadDomaineRead | null;
    /**
     * 
     * @type {ServicesJsonldUtilisateurReadDomaineRead}
     * @memberof UtilisateursJsonldUtilisateurReadDomaineRead
     */
    'service'?: ServicesJsonldUtilisateurReadDomaineRead | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursJsonldUtilisateurReadDomaineRead
     */
    'raccourciG3Id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurReadDomaineRead
     */
    'portable'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurReadDomaineRead
     */
    'fonction'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursJsonldUtilisateurReadDomaineRead
     */
    'hasVpn'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursJsonldUtilisateurReadDomaineRead
     */
    'isG3Recetteur'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurReadDomaineRead
     */
    'formalistDroitMultiSociete'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursJsonldUtilisateurReadDomaineRead
     */
    'idUserG3'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursJsonldUtilisateurReadDomaineRead
     */
    'hasComptaSoftware'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurReadDomaineRead
     */
    'dematFacile'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursJsonldUtilisateurReadDomaineRead
     */
    'idUserDematfacile'?: number;
    /**
     * 
     * @type {MarquesJsonldUtilisateurReadDomaineRead}
     * @memberof UtilisateursJsonldUtilisateurReadDomaineRead
     */
    'marque'?: MarquesJsonldUtilisateurReadDomaineRead | null;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursJsonldUtilisateurReadDomaineRead
     */
    'hasAccessL2DF'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursJsonldUtilisateurReadDomaineRead
     */
    'hasAnnuaire'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursJsonldUtilisateurReadDomaineRead
     */
    'isAdminApps'?: boolean;
    /**
     * 
     * @type {GroupesJsonldUtilisateurReadDomaineRead}
     * @memberof UtilisateursJsonldUtilisateurReadDomaineRead
     */
    'idGroupeGie'?: GroupesJsonldUtilisateurReadDomaineRead | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurReadDomaineRead
     */
    'binome'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursJsonldUtilisateurReadDomaineRead
     */
    'idSocieteEmployeur'?: number | null;
    /**
     * 
     * @type {AntennesJsonldUtilisateurReadDomaineRead}
     * @memberof UtilisateursJsonldUtilisateurReadDomaineRead
     */
    'antenne'?: AntennesJsonldUtilisateurReadDomaineRead | null;
    /**
     * 
     * @type {DroitsJsonldUtilisateurReadDomaineRead}
     * @memberof UtilisateursJsonldUtilisateurReadDomaineRead
     */
    'droitUtilisateur'?: DroitsJsonldUtilisateurReadDomaineRead | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurReadDomaineRead
     */
    'libelleSociete'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurReadDomaineRead
     */
    'libelleSocieteEmployeur'?: string | null;
    /**
     * 
     * @type {Array<GroupesDeTravailJsonldUtilisateurReadDomaineRead>}
     * @memberof UtilisateursJsonldUtilisateurReadDomaineRead
     */
    'groupeTravail'?: Array<GroupesDeTravailJsonldUtilisateurReadDomaineRead>;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurReadDomaineRead
     */
    'userIdentifier'?: string | null;
}
/**
 * Updates the selected user informations
 * @export
 * @interface UtilisateursJsonldUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
 */
export interface UtilisateursJsonldUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur {
    /**
     * 
     * @type {AntennesJsonldAntenneReadContext}
     * @memberof UtilisateursJsonldUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
     */
    '@context'?: AntennesJsonldAntenneReadContext;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursJsonldUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
     */
    'nom'?: string;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
     */
    'prenom'?: string;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
     */
    'initiales'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursJsonldUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
     */
    'isDeleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
     */
    'user'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
     */
    'poste'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
     */
    'ligneDirecte'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
     */
    'mail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
     */
    'pc'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursJsonldUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
     */
    'isEleveur'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursJsonldUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
     */
    'hasG3Access'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursJsonldUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
     */
    'formalistDemo'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursJsonldUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
     */
    'formalistAdmin'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursJsonldUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
     */
    'formalistDroitModifDossier'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursJsonldUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
     */
    'formalistDroitLectureDossier'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursJsonldUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
     */
    'formalistDroitModifGestion'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursJsonldUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
     */
    'formalistDroitLectureGestion'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursJsonldUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
     */
    'formalistDroitSupprDossier'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursJsonldUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
     */
    'isFormalist'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursJsonldUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
     */
    'idSociete'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
     */
    'pole'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
     */
    'service'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursJsonldUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
     */
    'raccourciG3Id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
     */
    'portable'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
     */
    'fonction'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursJsonldUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
     */
    'hasVpn'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursJsonldUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
     */
    'isG3Recetteur'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
     */
    'formalistDroitMultiSociete'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursJsonldUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
     */
    'idUserG3'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursJsonldUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
     */
    'hasComptaSoftware'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
     */
    'dematFacile'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursJsonldUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
     */
    'idUserDematfacile'?: number;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
     */
    'marque'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursJsonldUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
     */
    'hasAccessL2DF'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursJsonldUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
     */
    'hasAnnuaire'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursJsonldUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
     */
    'isAdminApps'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
     */
    'idGroupeGie'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
     */
    'binome'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursJsonldUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
     */
    'idSocieteEmployeur'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
     */
    'antenne'?: string | null;
    /**
     * 
     * @type {DroitsJsonldUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur}
     * @memberof UtilisateursJsonldUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
     */
    'droitUtilisateur'?: DroitsJsonldUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
     */
    'userIdentifier'?: string | null;
}
/**
 * Create a user
 * @export
 * @interface UtilisateursJsonldUtilisateurWrite
 */
export interface UtilisateursJsonldUtilisateurWrite {
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurWrite
     */
    'nom'?: string;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurWrite
     */
    'prenom'?: string;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurWrite
     */
    'initiales'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurWrite
     */
    'user'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurWrite
     */
    'poste'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurWrite
     */
    'ligneDirecte'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurWrite
     */
    'mail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurWrite
     */
    'pc'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursJsonldUtilisateurWrite
     */
    'isEleveur'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursJsonldUtilisateurWrite
     */
    'hasG3Access'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursJsonldUtilisateurWrite
     */
    'formalistDemo'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursJsonldUtilisateurWrite
     */
    'formalistAdmin'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursJsonldUtilisateurWrite
     */
    'formalistDroitModifDossier'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursJsonldUtilisateurWrite
     */
    'formalistDroitLectureDossier'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursJsonldUtilisateurWrite
     */
    'formalistDroitModifGestion'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursJsonldUtilisateurWrite
     */
    'formalistDroitLectureGestion'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursJsonldUtilisateurWrite
     */
    'formalistDroitSupprDossier'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursJsonldUtilisateurWrite
     */
    'isFormalist'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursJsonldUtilisateurWrite
     */
    'idSociete'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurWrite
     */
    'pole'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurWrite
     */
    'service'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursJsonldUtilisateurWrite
     */
    'raccourciG3Id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurWrite
     */
    'portable'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurWrite
     */
    'fonction'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursJsonldUtilisateurWrite
     */
    'hasVpn'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursJsonldUtilisateurWrite
     */
    'isG3Recetteur'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurWrite
     */
    'formalistDroitMultiSociete'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursJsonldUtilisateurWrite
     */
    'idUserG3'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursJsonldUtilisateurWrite
     */
    'hasComptaSoftware'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurWrite
     */
    'dematFacile'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursJsonldUtilisateurWrite
     */
    'idUserDematfacile'?: number;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurWrite
     */
    'marque'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursJsonldUtilisateurWrite
     */
    'hasAccessL2DF'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursJsonldUtilisateurWrite
     */
    'hasAnnuaire'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursJsonldUtilisateurWrite
     */
    'isAdminApps'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurWrite
     */
    'idGroupeGie'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurWrite
     */
    'binome'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursJsonldUtilisateurWrite
     */
    'idSocieteEmployeur'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurWrite
     */
    'antenne'?: string | null;
    /**
     * 
     * @type {DroitsJsonldUtilisateurWrite}
     * @memberof UtilisateursJsonldUtilisateurWrite
     */
    'droitUtilisateur'?: DroitsJsonldUtilisateurWrite | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurWrite
     */
    'userIdentifier'?: string | null;
}
/**
 * Create a user
 * @export
 * @interface UtilisateursJsonldUtilisateurWriteUtilisateurPostUtilisateur
 */
export interface UtilisateursJsonldUtilisateurWriteUtilisateurPostUtilisateur {
    /**
     * 
     * @type {AntennesJsonldAntenneReadContext}
     * @memberof UtilisateursJsonldUtilisateurWriteUtilisateurPostUtilisateur
     */
    '@context'?: AntennesJsonldAntenneReadContext;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurWriteUtilisateurPostUtilisateur
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurWriteUtilisateurPostUtilisateur
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursJsonldUtilisateurWriteUtilisateurPostUtilisateur
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurWriteUtilisateurPostUtilisateur
     */
    'nom'?: string;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurWriteUtilisateurPostUtilisateur
     */
    'prenom'?: string;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurWriteUtilisateurPostUtilisateur
     */
    'initiales'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurWriteUtilisateurPostUtilisateur
     */
    'user'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurWriteUtilisateurPostUtilisateur
     */
    'poste'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurWriteUtilisateurPostUtilisateur
     */
    'ligneDirecte'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurWriteUtilisateurPostUtilisateur
     */
    'mail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurWriteUtilisateurPostUtilisateur
     */
    'pc'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursJsonldUtilisateurWriteUtilisateurPostUtilisateur
     */
    'isEleveur'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursJsonldUtilisateurWriteUtilisateurPostUtilisateur
     */
    'hasG3Access'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursJsonldUtilisateurWriteUtilisateurPostUtilisateur
     */
    'formalistDemo'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursJsonldUtilisateurWriteUtilisateurPostUtilisateur
     */
    'formalistAdmin'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursJsonldUtilisateurWriteUtilisateurPostUtilisateur
     */
    'formalistDroitModifDossier'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursJsonldUtilisateurWriteUtilisateurPostUtilisateur
     */
    'formalistDroitLectureDossier'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursJsonldUtilisateurWriteUtilisateurPostUtilisateur
     */
    'formalistDroitModifGestion'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursJsonldUtilisateurWriteUtilisateurPostUtilisateur
     */
    'formalistDroitLectureGestion'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursJsonldUtilisateurWriteUtilisateurPostUtilisateur
     */
    'formalistDroitSupprDossier'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursJsonldUtilisateurWriteUtilisateurPostUtilisateur
     */
    'isFormalist'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursJsonldUtilisateurWriteUtilisateurPostUtilisateur
     */
    'idSociete'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurWriteUtilisateurPostUtilisateur
     */
    'pole'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurWriteUtilisateurPostUtilisateur
     */
    'service'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursJsonldUtilisateurWriteUtilisateurPostUtilisateur
     */
    'raccourciG3Id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurWriteUtilisateurPostUtilisateur
     */
    'portable'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurWriteUtilisateurPostUtilisateur
     */
    'fonction'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursJsonldUtilisateurWriteUtilisateurPostUtilisateur
     */
    'hasVpn'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursJsonldUtilisateurWriteUtilisateurPostUtilisateur
     */
    'isG3Recetteur'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurWriteUtilisateurPostUtilisateur
     */
    'formalistDroitMultiSociete'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursJsonldUtilisateurWriteUtilisateurPostUtilisateur
     */
    'idUserG3'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursJsonldUtilisateurWriteUtilisateurPostUtilisateur
     */
    'hasComptaSoftware'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurWriteUtilisateurPostUtilisateur
     */
    'dematFacile'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursJsonldUtilisateurWriteUtilisateurPostUtilisateur
     */
    'idUserDematfacile'?: number;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurWriteUtilisateurPostUtilisateur
     */
    'marque'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursJsonldUtilisateurWriteUtilisateurPostUtilisateur
     */
    'hasAccessL2DF'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursJsonldUtilisateurWriteUtilisateurPostUtilisateur
     */
    'hasAnnuaire'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursJsonldUtilisateurWriteUtilisateurPostUtilisateur
     */
    'isAdminApps'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurWriteUtilisateurPostUtilisateur
     */
    'idGroupeGie'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurWriteUtilisateurPostUtilisateur
     */
    'binome'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursJsonldUtilisateurWriteUtilisateurPostUtilisateur
     */
    'idSocieteEmployeur'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurWriteUtilisateurPostUtilisateur
     */
    'antenne'?: string | null;
    /**
     * 
     * @type {DroitsJsonldUtilisateurWriteUtilisateurPostUtilisateur}
     * @memberof UtilisateursJsonldUtilisateurWriteUtilisateurPostUtilisateur
     */
    'droitUtilisateur'?: DroitsJsonldUtilisateurWriteUtilisateurPostUtilisateur | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldUtilisateurWriteUtilisateurPostUtilisateur
     */
    'userIdentifier'?: string | null;
}
/**
 * Returns the selected user informations
 * @export
 * @interface UtilisateursJsonldWorkgroupReadUtilisateurReadDomaineRead
 */
export interface UtilisateursJsonldWorkgroupReadUtilisateurReadDomaineRead {
    /**
     * 
     * @type {AntennesJsonldAntenneReadContext}
     * @memberof UtilisateursJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    '@context'?: AntennesJsonldAntenneReadContext;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    'nom'?: string;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    'prenom'?: string;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    'login'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    'userGroupe'?: number;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    'initiales'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    'isDeleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    'user'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    'userKeycloakId'?: number;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    'dateMaj'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    'poste'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    'ligneDirecte'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    'mail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    'pc'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    'isEleveur'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    'hasG3Access'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    'formalistDemo'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    'formalistAdmin'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    'formalistDroitModifDossier'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    'formalistDroitLectureDossier'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    'formalistDroitModifGestion'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    'formalistDroitLectureGestion'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    'formalistDroitSupprDossier'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    'isFormalist'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    'idSociete'?: number | null;
    /**
     * 
     * @type {PolesJsonldWorkgroupReadUtilisateurReadDomaineRead}
     * @memberof UtilisateursJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    'pole'?: PolesJsonldWorkgroupReadUtilisateurReadDomaineRead | null;
    /**
     * 
     * @type {ServicesJsonldWorkgroupReadUtilisateurReadDomaineRead}
     * @memberof UtilisateursJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    'service'?: ServicesJsonldWorkgroupReadUtilisateurReadDomaineRead | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    'raccourciG3Id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    'portable'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    'fonction'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    'hasVpn'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    'isG3Recetteur'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    'formalistDroitMultiSociete'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    'idUserG3'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    'hasComptaSoftware'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    'dematFacile'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    'idUserDematfacile'?: number;
    /**
     * 
     * @type {MarquesJsonldWorkgroupReadUtilisateurReadDomaineRead}
     * @memberof UtilisateursJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    'marque'?: MarquesJsonldWorkgroupReadUtilisateurReadDomaineRead | null;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    'hasAccessL2DF'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    'hasAnnuaire'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    'isAdminApps'?: boolean;
    /**
     * 
     * @type {GroupesJsonldWorkgroupReadUtilisateurReadDomaineRead}
     * @memberof UtilisateursJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    'idGroupeGie'?: GroupesJsonldWorkgroupReadUtilisateurReadDomaineRead | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    'binome'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    'idSocieteEmployeur'?: number | null;
    /**
     * 
     * @type {AntennesJsonldWorkgroupReadUtilisateurReadDomaineRead}
     * @memberof UtilisateursJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    'antenne'?: AntennesJsonldWorkgroupReadUtilisateurReadDomaineRead | null;
    /**
     * 
     * @type {DroitsJsonldWorkgroupReadUtilisateurReadDomaineRead}
     * @memberof UtilisateursJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    'droitUtilisateur'?: DroitsJsonldWorkgroupReadUtilisateurReadDomaineRead | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    'libelleSociete'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    'libelleSocieteEmployeur'?: string | null;
    /**
     * 
     * @type {Array<GroupesDeTravailJsonldWorkgroupReadUtilisateurReadDomaineRead>}
     * @memberof UtilisateursJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    'groupeTravail'?: Array<GroupesDeTravailJsonldWorkgroupReadUtilisateurReadDomaineRead>;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursJsonldWorkgroupReadUtilisateurReadDomaineRead
     */
    'userIdentifier'?: string | null;
}
/**
 * Returns the selected user informations
 * @export
 * @interface UtilisateursUserworkgroupRead
 */
export interface UtilisateursUserworkgroupRead {
    /**
     * 
     * @type {number}
     * @memberof UtilisateursUserworkgroupRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursUserworkgroupRead
     */
    'nom'?: string;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursUserworkgroupRead
     */
    'prenom'?: string;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursUserworkgroupRead
     */
    'mail'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursUserworkgroupRead
     */
    'formalistDroitLectureDossier'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursUserworkgroupRead
     */
    'isFormalist'?: boolean | null;
    /**
     * 
     * @type {ServicesUserworkgroupRead}
     * @memberof UtilisateursUserworkgroupRead
     */
    'service'?: ServicesUserworkgroupRead | null;
}
/**
 * Updates only the selected informations of the current user
 * @export
 * @interface UtilisateursUtilisateurPatchUtilisateur
 */
export interface UtilisateursUtilisateurPatchUtilisateur {
    /**
     * 
     * @type {number}
     * @memberof UtilisateursUtilisateurPatchUtilisateur
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursUtilisateurPatchUtilisateur
     */
    'nom'?: string;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursUtilisateurPatchUtilisateur
     */
    'prenom'?: string;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursUtilisateurPatchUtilisateur
     */
    'initiales'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursUtilisateurPatchUtilisateur
     */
    'isDeleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursUtilisateurPatchUtilisateur
     */
    'user'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursUtilisateurPatchUtilisateur
     */
    'poste'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursUtilisateurPatchUtilisateur
     */
    'ligneDirecte'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursUtilisateurPatchUtilisateur
     */
    'mail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursUtilisateurPatchUtilisateur
     */
    'pc'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursUtilisateurPatchUtilisateur
     */
    'isEleveur'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursUtilisateurPatchUtilisateur
     */
    'hasG3Access'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursUtilisateurPatchUtilisateur
     */
    'formalistDemo'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursUtilisateurPatchUtilisateur
     */
    'formalistAdmin'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursUtilisateurPatchUtilisateur
     */
    'formalistDroitModifDossier'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursUtilisateurPatchUtilisateur
     */
    'formalistDroitLectureDossier'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursUtilisateurPatchUtilisateur
     */
    'formalistDroitModifGestion'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursUtilisateurPatchUtilisateur
     */
    'formalistDroitLectureGestion'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursUtilisateurPatchUtilisateur
     */
    'formalistDroitSupprDossier'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursUtilisateurPatchUtilisateur
     */
    'isFormalist'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursUtilisateurPatchUtilisateur
     */
    'idSociete'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursUtilisateurPatchUtilisateur
     */
    'pole'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursUtilisateurPatchUtilisateur
     */
    'service'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursUtilisateurPatchUtilisateur
     */
    'raccourciG3Id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursUtilisateurPatchUtilisateur
     */
    'portable'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursUtilisateurPatchUtilisateur
     */
    'fonction'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursUtilisateurPatchUtilisateur
     */
    'hasVpn'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursUtilisateurPatchUtilisateur
     */
    'isG3Recetteur'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursUtilisateurPatchUtilisateur
     */
    'formalistDroitMultiSociete'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursUtilisateurPatchUtilisateur
     */
    'idUserG3'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursUtilisateurPatchUtilisateur
     */
    'hasComptaSoftware'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursUtilisateurPatchUtilisateur
     */
    'dematFacile'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursUtilisateurPatchUtilisateur
     */
    'idUserDematfacile'?: number;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursUtilisateurPatchUtilisateur
     */
    'marque'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursUtilisateurPatchUtilisateur
     */
    'hasAccessL2DF'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursUtilisateurPatchUtilisateur
     */
    'hasAnnuaire'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursUtilisateurPatchUtilisateur
     */
    'isAdminApps'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursUtilisateurPatchUtilisateur
     */
    'idGroupeGie'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursUtilisateurPatchUtilisateur
     */
    'binome'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursUtilisateurPatchUtilisateur
     */
    'idSocieteEmployeur'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursUtilisateurPatchUtilisateur
     */
    'antenne'?: string | null;
    /**
     * 
     * @type {DroitsUtilisateurPatchUtilisateur}
     * @memberof UtilisateursUtilisateurPatchUtilisateur
     */
    'droitUtilisateur'?: DroitsUtilisateurPatchUtilisateur | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursUtilisateurPatchUtilisateur
     */
    'userIdentifier'?: string | null;
}
/**
 * Returns the selected user informations
 * @export
 * @interface UtilisateursUtilisateurRead
 */
export interface UtilisateursUtilisateurRead {
    /**
     * 
     * @type {number}
     * @memberof UtilisateursUtilisateurRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursUtilisateurRead
     */
    'nom'?: string;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursUtilisateurRead
     */
    'prenom'?: string;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursUtilisateurRead
     */
    'login'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursUtilisateurRead
     */
    'userGroupe'?: number;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursUtilisateurRead
     */
    'initiales'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursUtilisateurRead
     */
    'isDeleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursUtilisateurRead
     */
    'user'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursUtilisateurRead
     */
    'userKeycloakId'?: number;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursUtilisateurRead
     */
    'dateMaj'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursUtilisateurRead
     */
    'poste'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursUtilisateurRead
     */
    'ligneDirecte'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursUtilisateurRead
     */
    'mail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursUtilisateurRead
     */
    'pc'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursUtilisateurRead
     */
    'isEleveur'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursUtilisateurRead
     */
    'hasG3Access'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursUtilisateurRead
     */
    'formalistDemo'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursUtilisateurRead
     */
    'formalistAdmin'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursUtilisateurRead
     */
    'formalistDroitModifDossier'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursUtilisateurRead
     */
    'formalistDroitLectureDossier'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursUtilisateurRead
     */
    'formalistDroitModifGestion'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursUtilisateurRead
     */
    'formalistDroitLectureGestion'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursUtilisateurRead
     */
    'formalistDroitSupprDossier'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursUtilisateurRead
     */
    'isFormalist'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursUtilisateurRead
     */
    'idSociete'?: number | null;
    /**
     * 
     * @type {PolesUtilisateurRead}
     * @memberof UtilisateursUtilisateurRead
     */
    'pole'?: PolesUtilisateurRead | null;
    /**
     * 
     * @type {ServicesUtilisateurRead}
     * @memberof UtilisateursUtilisateurRead
     */
    'service'?: ServicesUtilisateurRead | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursUtilisateurRead
     */
    'raccourciG3Id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursUtilisateurRead
     */
    'portable'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursUtilisateurRead
     */
    'fonction'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursUtilisateurRead
     */
    'hasVpn'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursUtilisateurRead
     */
    'isG3Recetteur'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursUtilisateurRead
     */
    'formalistDroitMultiSociete'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursUtilisateurRead
     */
    'idUserG3'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursUtilisateurRead
     */
    'hasComptaSoftware'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursUtilisateurRead
     */
    'dematFacile'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursUtilisateurRead
     */
    'idUserDematfacile'?: number;
    /**
     * 
     * @type {MarquesUtilisateurRead}
     * @memberof UtilisateursUtilisateurRead
     */
    'marque'?: MarquesUtilisateurRead | null;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursUtilisateurRead
     */
    'hasAccessL2DF'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursUtilisateurRead
     */
    'hasAnnuaire'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursUtilisateurRead
     */
    'isAdminApps'?: boolean;
    /**
     * 
     * @type {GroupesUtilisateurRead}
     * @memberof UtilisateursUtilisateurRead
     */
    'idGroupeGie'?: GroupesUtilisateurRead | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursUtilisateurRead
     */
    'binome'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursUtilisateurRead
     */
    'idSocieteEmployeur'?: number | null;
    /**
     * 
     * @type {AntennesUtilisateurRead}
     * @memberof UtilisateursUtilisateurRead
     */
    'antenne'?: AntennesUtilisateurRead | null;
    /**
     * 
     * @type {DroitsUtilisateurRead}
     * @memberof UtilisateursUtilisateurRead
     */
    'droitUtilisateur'?: DroitsUtilisateurRead | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursUtilisateurRead
     */
    'libelleSociete'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursUtilisateurRead
     */
    'libelleSocieteEmployeur'?: string | null;
    /**
     * 
     * @type {Array<GroupesDeTravailUtilisateurRead>}
     * @memberof UtilisateursUtilisateurRead
     */
    'groupeTravail'?: Array<GroupesDeTravailUtilisateurRead>;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursUtilisateurRead
     */
    'userIdentifier'?: string | null;
}
/**
 * Returns the selected user informations
 * @export
 * @interface UtilisateursUtilisateurReadDomaineRead
 */
export interface UtilisateursUtilisateurReadDomaineRead {
    /**
     * 
     * @type {number}
     * @memberof UtilisateursUtilisateurReadDomaineRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursUtilisateurReadDomaineRead
     */
    'nom'?: string;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursUtilisateurReadDomaineRead
     */
    'prenom'?: string;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursUtilisateurReadDomaineRead
     */
    'login'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursUtilisateurReadDomaineRead
     */
    'userGroupe'?: number;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursUtilisateurReadDomaineRead
     */
    'initiales'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursUtilisateurReadDomaineRead
     */
    'isDeleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursUtilisateurReadDomaineRead
     */
    'user'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursUtilisateurReadDomaineRead
     */
    'userKeycloakId'?: number;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursUtilisateurReadDomaineRead
     */
    'dateMaj'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursUtilisateurReadDomaineRead
     */
    'poste'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursUtilisateurReadDomaineRead
     */
    'ligneDirecte'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursUtilisateurReadDomaineRead
     */
    'mail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursUtilisateurReadDomaineRead
     */
    'pc'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursUtilisateurReadDomaineRead
     */
    'isEleveur'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursUtilisateurReadDomaineRead
     */
    'hasG3Access'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursUtilisateurReadDomaineRead
     */
    'formalistDemo'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursUtilisateurReadDomaineRead
     */
    'formalistAdmin'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursUtilisateurReadDomaineRead
     */
    'formalistDroitModifDossier'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursUtilisateurReadDomaineRead
     */
    'formalistDroitLectureDossier'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursUtilisateurReadDomaineRead
     */
    'formalistDroitModifGestion'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursUtilisateurReadDomaineRead
     */
    'formalistDroitLectureGestion'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursUtilisateurReadDomaineRead
     */
    'formalistDroitSupprDossier'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursUtilisateurReadDomaineRead
     */
    'isFormalist'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursUtilisateurReadDomaineRead
     */
    'idSociete'?: number | null;
    /**
     * 
     * @type {PolesUtilisateurReadDomaineRead}
     * @memberof UtilisateursUtilisateurReadDomaineRead
     */
    'pole'?: PolesUtilisateurReadDomaineRead | null;
    /**
     * 
     * @type {ServicesUtilisateurReadDomaineRead}
     * @memberof UtilisateursUtilisateurReadDomaineRead
     */
    'service'?: ServicesUtilisateurReadDomaineRead | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursUtilisateurReadDomaineRead
     */
    'raccourciG3Id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursUtilisateurReadDomaineRead
     */
    'portable'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursUtilisateurReadDomaineRead
     */
    'fonction'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursUtilisateurReadDomaineRead
     */
    'hasVpn'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursUtilisateurReadDomaineRead
     */
    'isG3Recetteur'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursUtilisateurReadDomaineRead
     */
    'formalistDroitMultiSociete'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursUtilisateurReadDomaineRead
     */
    'idUserG3'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursUtilisateurReadDomaineRead
     */
    'hasComptaSoftware'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursUtilisateurReadDomaineRead
     */
    'dematFacile'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursUtilisateurReadDomaineRead
     */
    'idUserDematfacile'?: number;
    /**
     * 
     * @type {MarquesUtilisateurReadDomaineRead}
     * @memberof UtilisateursUtilisateurReadDomaineRead
     */
    'marque'?: MarquesUtilisateurReadDomaineRead | null;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursUtilisateurReadDomaineRead
     */
    'hasAccessL2DF'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursUtilisateurReadDomaineRead
     */
    'hasAnnuaire'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursUtilisateurReadDomaineRead
     */
    'isAdminApps'?: boolean;
    /**
     * 
     * @type {GroupesUtilisateurReadDomaineRead}
     * @memberof UtilisateursUtilisateurReadDomaineRead
     */
    'idGroupeGie'?: GroupesUtilisateurReadDomaineRead | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursUtilisateurReadDomaineRead
     */
    'binome'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursUtilisateurReadDomaineRead
     */
    'idSocieteEmployeur'?: number | null;
    /**
     * 
     * @type {AntennesUtilisateurReadDomaineRead}
     * @memberof UtilisateursUtilisateurReadDomaineRead
     */
    'antenne'?: AntennesUtilisateurReadDomaineRead | null;
    /**
     * 
     * @type {DroitsUtilisateurReadDomaineRead}
     * @memberof UtilisateursUtilisateurReadDomaineRead
     */
    'droitUtilisateur'?: DroitsUtilisateurReadDomaineRead | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursUtilisateurReadDomaineRead
     */
    'libelleSociete'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursUtilisateurReadDomaineRead
     */
    'libelleSocieteEmployeur'?: string | null;
    /**
     * 
     * @type {Array<GroupesDeTravailUtilisateurReadDomaineRead>}
     * @memberof UtilisateursUtilisateurReadDomaineRead
     */
    'groupeTravail'?: Array<GroupesDeTravailUtilisateurReadDomaineRead>;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursUtilisateurReadDomaineRead
     */
    'userIdentifier'?: string | null;
}
/**
 * Synchronize the user with his keycloak account
 * @export
 * @interface UtilisateursUtilisateurSyncUtilisateur
 */
export interface UtilisateursUtilisateurSyncUtilisateur {
    /**
     * 
     * @type {number}
     * @memberof UtilisateursUtilisateurSyncUtilisateur
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursUtilisateurSyncUtilisateur
     */
    'userIdentifier'?: string | null;
}
/**
 * Updates only the selected informations of the current user
 * @export
 * @interface UtilisateursUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
 */
export interface UtilisateursUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur {
    /**
     * 
     * @type {number}
     * @memberof UtilisateursUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
     */
    'nom'?: string;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
     */
    'prenom'?: string;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
     */
    'initiales'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
     */
    'isDeleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
     */
    'user'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
     */
    'poste'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
     */
    'ligneDirecte'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
     */
    'mail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
     */
    'pc'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
     */
    'isEleveur'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
     */
    'hasG3Access'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
     */
    'formalistDemo'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
     */
    'formalistAdmin'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
     */
    'formalistDroitModifDossier'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
     */
    'formalistDroitLectureDossier'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
     */
    'formalistDroitModifGestion'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
     */
    'formalistDroitLectureGestion'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
     */
    'formalistDroitSupprDossier'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
     */
    'isFormalist'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
     */
    'idSociete'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
     */
    'pole'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
     */
    'service'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
     */
    'raccourciG3Id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
     */
    'portable'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
     */
    'fonction'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
     */
    'hasVpn'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
     */
    'isG3Recetteur'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
     */
    'formalistDroitMultiSociete'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
     */
    'idUserG3'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
     */
    'hasComptaSoftware'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
     */
    'dematFacile'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
     */
    'idUserDematfacile'?: number;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
     */
    'marque'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
     */
    'hasAccessL2DF'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
     */
    'hasAnnuaire'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
     */
    'isAdminApps'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
     */
    'idGroupeGie'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
     */
    'binome'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
     */
    'idSocieteEmployeur'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
     */
    'antenne'?: string | null;
    /**
     * 
     * @type {DroitsUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur}
     * @memberof UtilisateursUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
     */
    'droitUtilisateur'?: DroitsUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
     */
    'userIdentifier'?: string | null;
}
/**
 * Create a user
 * @export
 * @interface UtilisateursUtilisateurWrite
 */
export interface UtilisateursUtilisateurWrite {
    /**
     * 
     * @type {string}
     * @memberof UtilisateursUtilisateurWrite
     */
    'nom'?: string;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursUtilisateurWrite
     */
    'prenom'?: string;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursUtilisateurWrite
     */
    'initiales'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursUtilisateurWrite
     */
    'user'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursUtilisateurWrite
     */
    'poste'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursUtilisateurWrite
     */
    'ligneDirecte'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursUtilisateurWrite
     */
    'mail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursUtilisateurWrite
     */
    'pc'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursUtilisateurWrite
     */
    'isEleveur'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursUtilisateurWrite
     */
    'hasG3Access'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursUtilisateurWrite
     */
    'formalistDemo'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursUtilisateurWrite
     */
    'formalistAdmin'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursUtilisateurWrite
     */
    'formalistDroitModifDossier'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursUtilisateurWrite
     */
    'formalistDroitLectureDossier'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursUtilisateurWrite
     */
    'formalistDroitModifGestion'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursUtilisateurWrite
     */
    'formalistDroitLectureGestion'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursUtilisateurWrite
     */
    'formalistDroitSupprDossier'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursUtilisateurWrite
     */
    'isFormalist'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursUtilisateurWrite
     */
    'idSociete'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursUtilisateurWrite
     */
    'pole'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursUtilisateurWrite
     */
    'service'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursUtilisateurWrite
     */
    'raccourciG3Id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursUtilisateurWrite
     */
    'portable'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursUtilisateurWrite
     */
    'fonction'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursUtilisateurWrite
     */
    'hasVpn'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursUtilisateurWrite
     */
    'isG3Recetteur'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursUtilisateurWrite
     */
    'formalistDroitMultiSociete'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursUtilisateurWrite
     */
    'idUserG3'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursUtilisateurWrite
     */
    'hasComptaSoftware'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursUtilisateurWrite
     */
    'dematFacile'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursUtilisateurWrite
     */
    'idUserDematfacile'?: number;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursUtilisateurWrite
     */
    'marque'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursUtilisateurWrite
     */
    'hasAccessL2DF'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursUtilisateurWrite
     */
    'hasAnnuaire'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursUtilisateurWrite
     */
    'isAdminApps'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursUtilisateurWrite
     */
    'idGroupeGie'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursUtilisateurWrite
     */
    'binome'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursUtilisateurWrite
     */
    'idSocieteEmployeur'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursUtilisateurWrite
     */
    'antenne'?: string | null;
    /**
     * 
     * @type {DroitsUtilisateurWrite}
     * @memberof UtilisateursUtilisateurWrite
     */
    'droitUtilisateur'?: DroitsUtilisateurWrite | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursUtilisateurWrite
     */
    'userIdentifier'?: string | null;
}
/**
 * Create a user
 * @export
 * @interface UtilisateursUtilisateurWriteUtilisateurPostUtilisateur
 */
export interface UtilisateursUtilisateurWriteUtilisateurPostUtilisateur {
    /**
     * 
     * @type {number}
     * @memberof UtilisateursUtilisateurWriteUtilisateurPostUtilisateur
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursUtilisateurWriteUtilisateurPostUtilisateur
     */
    'nom'?: string;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursUtilisateurWriteUtilisateurPostUtilisateur
     */
    'prenom'?: string;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursUtilisateurWriteUtilisateurPostUtilisateur
     */
    'initiales'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursUtilisateurWriteUtilisateurPostUtilisateur
     */
    'user'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursUtilisateurWriteUtilisateurPostUtilisateur
     */
    'poste'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursUtilisateurWriteUtilisateurPostUtilisateur
     */
    'ligneDirecte'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursUtilisateurWriteUtilisateurPostUtilisateur
     */
    'mail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursUtilisateurWriteUtilisateurPostUtilisateur
     */
    'pc'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursUtilisateurWriteUtilisateurPostUtilisateur
     */
    'isEleveur'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursUtilisateurWriteUtilisateurPostUtilisateur
     */
    'hasG3Access'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursUtilisateurWriteUtilisateurPostUtilisateur
     */
    'formalistDemo'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursUtilisateurWriteUtilisateurPostUtilisateur
     */
    'formalistAdmin'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursUtilisateurWriteUtilisateurPostUtilisateur
     */
    'formalistDroitModifDossier'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursUtilisateurWriteUtilisateurPostUtilisateur
     */
    'formalistDroitLectureDossier'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursUtilisateurWriteUtilisateurPostUtilisateur
     */
    'formalistDroitModifGestion'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursUtilisateurWriteUtilisateurPostUtilisateur
     */
    'formalistDroitLectureGestion'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursUtilisateurWriteUtilisateurPostUtilisateur
     */
    'formalistDroitSupprDossier'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursUtilisateurWriteUtilisateurPostUtilisateur
     */
    'isFormalist'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursUtilisateurWriteUtilisateurPostUtilisateur
     */
    'idSociete'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursUtilisateurWriteUtilisateurPostUtilisateur
     */
    'pole'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursUtilisateurWriteUtilisateurPostUtilisateur
     */
    'service'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursUtilisateurWriteUtilisateurPostUtilisateur
     */
    'raccourciG3Id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursUtilisateurWriteUtilisateurPostUtilisateur
     */
    'portable'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursUtilisateurWriteUtilisateurPostUtilisateur
     */
    'fonction'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursUtilisateurWriteUtilisateurPostUtilisateur
     */
    'hasVpn'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursUtilisateurWriteUtilisateurPostUtilisateur
     */
    'isG3Recetteur'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursUtilisateurWriteUtilisateurPostUtilisateur
     */
    'formalistDroitMultiSociete'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursUtilisateurWriteUtilisateurPostUtilisateur
     */
    'idUserG3'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursUtilisateurWriteUtilisateurPostUtilisateur
     */
    'hasComptaSoftware'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursUtilisateurWriteUtilisateurPostUtilisateur
     */
    'dematFacile'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursUtilisateurWriteUtilisateurPostUtilisateur
     */
    'idUserDematfacile'?: number;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursUtilisateurWriteUtilisateurPostUtilisateur
     */
    'marque'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursUtilisateurWriteUtilisateurPostUtilisateur
     */
    'hasAccessL2DF'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursUtilisateurWriteUtilisateurPostUtilisateur
     */
    'hasAnnuaire'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursUtilisateurWriteUtilisateurPostUtilisateur
     */
    'isAdminApps'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursUtilisateurWriteUtilisateurPostUtilisateur
     */
    'idGroupeGie'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursUtilisateurWriteUtilisateurPostUtilisateur
     */
    'binome'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursUtilisateurWriteUtilisateurPostUtilisateur
     */
    'idSocieteEmployeur'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursUtilisateurWriteUtilisateurPostUtilisateur
     */
    'antenne'?: string | null;
    /**
     * 
     * @type {DroitsUtilisateurWriteUtilisateurPostUtilisateur}
     * @memberof UtilisateursUtilisateurWriteUtilisateurPostUtilisateur
     */
    'droitUtilisateur'?: DroitsUtilisateurWriteUtilisateurPostUtilisateur | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursUtilisateurWriteUtilisateurPostUtilisateur
     */
    'userIdentifier'?: string | null;
}
/**
 * Returns the selected user informations
 * @export
 * @interface UtilisateursWorkgroupReadUtilisateurReadDomaineRead
 */
export interface UtilisateursWorkgroupReadUtilisateurReadDomaineRead {
    /**
     * 
     * @type {number}
     * @memberof UtilisateursWorkgroupReadUtilisateurReadDomaineRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursWorkgroupReadUtilisateurReadDomaineRead
     */
    'nom'?: string;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursWorkgroupReadUtilisateurReadDomaineRead
     */
    'prenom'?: string;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursWorkgroupReadUtilisateurReadDomaineRead
     */
    'login'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursWorkgroupReadUtilisateurReadDomaineRead
     */
    'userGroupe'?: number;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursWorkgroupReadUtilisateurReadDomaineRead
     */
    'initiales'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursWorkgroupReadUtilisateurReadDomaineRead
     */
    'isDeleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursWorkgroupReadUtilisateurReadDomaineRead
     */
    'user'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursWorkgroupReadUtilisateurReadDomaineRead
     */
    'userKeycloakId'?: number;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursWorkgroupReadUtilisateurReadDomaineRead
     */
    'dateMaj'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursWorkgroupReadUtilisateurReadDomaineRead
     */
    'poste'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursWorkgroupReadUtilisateurReadDomaineRead
     */
    'ligneDirecte'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursWorkgroupReadUtilisateurReadDomaineRead
     */
    'mail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursWorkgroupReadUtilisateurReadDomaineRead
     */
    'pc'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursWorkgroupReadUtilisateurReadDomaineRead
     */
    'isEleveur'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursWorkgroupReadUtilisateurReadDomaineRead
     */
    'hasG3Access'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursWorkgroupReadUtilisateurReadDomaineRead
     */
    'formalistDemo'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursWorkgroupReadUtilisateurReadDomaineRead
     */
    'formalistAdmin'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursWorkgroupReadUtilisateurReadDomaineRead
     */
    'formalistDroitModifDossier'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursWorkgroupReadUtilisateurReadDomaineRead
     */
    'formalistDroitLectureDossier'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursWorkgroupReadUtilisateurReadDomaineRead
     */
    'formalistDroitModifGestion'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursWorkgroupReadUtilisateurReadDomaineRead
     */
    'formalistDroitLectureGestion'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursWorkgroupReadUtilisateurReadDomaineRead
     */
    'formalistDroitSupprDossier'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursWorkgroupReadUtilisateurReadDomaineRead
     */
    'isFormalist'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursWorkgroupReadUtilisateurReadDomaineRead
     */
    'idSociete'?: number | null;
    /**
     * 
     * @type {PolesWorkgroupReadUtilisateurReadDomaineRead}
     * @memberof UtilisateursWorkgroupReadUtilisateurReadDomaineRead
     */
    'pole'?: PolesWorkgroupReadUtilisateurReadDomaineRead | null;
    /**
     * 
     * @type {ServicesWorkgroupReadUtilisateurReadDomaineRead}
     * @memberof UtilisateursWorkgroupReadUtilisateurReadDomaineRead
     */
    'service'?: ServicesWorkgroupReadUtilisateurReadDomaineRead | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursWorkgroupReadUtilisateurReadDomaineRead
     */
    'raccourciG3Id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursWorkgroupReadUtilisateurReadDomaineRead
     */
    'portable'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursWorkgroupReadUtilisateurReadDomaineRead
     */
    'fonction'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursWorkgroupReadUtilisateurReadDomaineRead
     */
    'hasVpn'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursWorkgroupReadUtilisateurReadDomaineRead
     */
    'isG3Recetteur'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursWorkgroupReadUtilisateurReadDomaineRead
     */
    'formalistDroitMultiSociete'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursWorkgroupReadUtilisateurReadDomaineRead
     */
    'idUserG3'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursWorkgroupReadUtilisateurReadDomaineRead
     */
    'hasComptaSoftware'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursWorkgroupReadUtilisateurReadDomaineRead
     */
    'dematFacile'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursWorkgroupReadUtilisateurReadDomaineRead
     */
    'idUserDematfacile'?: number;
    /**
     * 
     * @type {MarquesWorkgroupReadUtilisateurReadDomaineRead}
     * @memberof UtilisateursWorkgroupReadUtilisateurReadDomaineRead
     */
    'marque'?: MarquesWorkgroupReadUtilisateurReadDomaineRead | null;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursWorkgroupReadUtilisateurReadDomaineRead
     */
    'hasAccessL2DF'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursWorkgroupReadUtilisateurReadDomaineRead
     */
    'hasAnnuaire'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursWorkgroupReadUtilisateurReadDomaineRead
     */
    'isAdminApps'?: boolean;
    /**
     * 
     * @type {GroupesWorkgroupReadUtilisateurReadDomaineRead}
     * @memberof UtilisateursWorkgroupReadUtilisateurReadDomaineRead
     */
    'idGroupeGie'?: GroupesWorkgroupReadUtilisateurReadDomaineRead | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursWorkgroupReadUtilisateurReadDomaineRead
     */
    'binome'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UtilisateursWorkgroupReadUtilisateurReadDomaineRead
     */
    'idSocieteEmployeur'?: number | null;
    /**
     * 
     * @type {AntennesWorkgroupReadUtilisateurReadDomaineRead}
     * @memberof UtilisateursWorkgroupReadUtilisateurReadDomaineRead
     */
    'antenne'?: AntennesWorkgroupReadUtilisateurReadDomaineRead | null;
    /**
     * 
     * @type {DroitsWorkgroupReadUtilisateurReadDomaineRead}
     * @memberof UtilisateursWorkgroupReadUtilisateurReadDomaineRead
     */
    'droitUtilisateur'?: DroitsWorkgroupReadUtilisateurReadDomaineRead | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursWorkgroupReadUtilisateurReadDomaineRead
     */
    'libelleSociete'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursWorkgroupReadUtilisateurReadDomaineRead
     */
    'libelleSocieteEmployeur'?: string | null;
    /**
     * 
     * @type {Array<GroupesDeTravailWorkgroupReadUtilisateurReadDomaineRead>}
     * @memberof UtilisateursWorkgroupReadUtilisateurReadDomaineRead
     */
    'groupeTravail'?: Array<GroupesDeTravailWorkgroupReadUtilisateurReadDomaineRead>;
    /**
     * 
     * @type {string}
     * @memberof UtilisateursWorkgroupReadUtilisateurReadDomaineRead
     */
    'userIdentifier'?: string | null;
}

/**
 * AntennesApi - axios parameter creator
 * @export
 */
export const AntennesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns antennas collection
         * @summary Returns antennas collection
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {boolean} [isDeleted] 
         * @param {ApiAntennesGetCollectionOrderIdAntenneEnum} [orderIdAntenne] 
         * @param {ApiAntennesGetCollectionOrderLibelleEnum} [orderLibelle] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAntennesGetCollection: async (page?: number, itemsPerPage?: number, isDeleted?: boolean, orderIdAntenne?: ApiAntennesGetCollectionOrderIdAntenneEnum, orderLibelle?: ApiAntennesGetCollectionOrderLibelleEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/utilisateur/antennes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }

            if (isDeleted !== undefined) {
                localVarQueryParameter['isDeleted'] = isDeleted;
            }

            if (orderIdAntenne !== undefined) {
                localVarQueryParameter['order[idAntenne]'] = orderIdAntenne;
            }

            if (orderLibelle !== undefined) {
                localVarQueryParameter['order[libelle]'] = orderLibelle;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete the selected antenna
         * @summary Delete the selected antenna
         * @param {string} idAntenne Antennes identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAntennesIdAntenneDelete: async (idAntenne: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idAntenne' is not null or undefined
            assertParamExists('apiAntennesIdAntenneDelete', 'idAntenne', idAntenne)
            const localVarPath = `/utilisateur/antennes/{idAntenne}`
                .replace(`{${"idAntenne"}}`, encodeURIComponent(String(idAntenne)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the antenna by id
         * @summary Get the antenna by id
         * @param {string} idAntenne Antennes identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAntennesIdAntenneGet: async (idAntenne: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idAntenne' is not null or undefined
            assertParamExists('apiAntennesIdAntenneGet', 'idAntenne', idAntenne)
            const localVarPath = `/utilisateur/antennes/{idAntenne}`
                .replace(`{${"idAntenne"}}`, encodeURIComponent(String(idAntenne)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates the selected antenna informations
         * @summary Updates the selected antenna informations
         * @param {string} idAntenne Antennes identifier
         * @param {AntennesAntenneUpdate} antennesAntenneUpdate The updated Antennes resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAntennesIdAntennePatch: async (idAntenne: string, antennesAntenneUpdate: AntennesAntenneUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idAntenne' is not null or undefined
            assertParamExists('apiAntennesIdAntennePatch', 'idAntenne', idAntenne)
            // verify required parameter 'antennesAntenneUpdate' is not null or undefined
            assertParamExists('apiAntennesIdAntennePatch', 'antennesAntenneUpdate', antennesAntenneUpdate)
            const localVarPath = `/utilisateur/antennes/{idAntenne}`
                .replace(`{${"idAntenne"}}`, encodeURIComponent(String(idAntenne)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/merge-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(antennesAntenneUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a new antenna in the Tbl_Antenne
         * @summary Creates a new antenna in the Tbl_Antenne
         * @param {AntennesJsonldAntenneWrite} antennesJsonldAntenneWrite The new Antennes resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAntennesPost: async (antennesJsonldAntenneWrite: AntennesJsonldAntenneWrite, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'antennesJsonldAntenneWrite' is not null or undefined
            assertParamExists('apiAntennesPost', 'antennesJsonldAntenneWrite', antennesJsonldAntenneWrite)
            const localVarPath = `/utilisateur/antennes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(antennesJsonldAntenneWrite, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AntennesApi - functional programming interface
 * @export
 */
export const AntennesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AntennesApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns antennas collection
         * @summary Returns antennas collection
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {boolean} [isDeleted] 
         * @param {ApiAntennesGetCollectionOrderIdAntenneEnum} [orderIdAntenne] 
         * @param {ApiAntennesGetCollectionOrderLibelleEnum} [orderLibelle] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAntennesGetCollection(page?: number, itemsPerPage?: number, isDeleted?: boolean, orderIdAntenne?: ApiAntennesGetCollectionOrderIdAntenneEnum, orderLibelle?: ApiAntennesGetCollectionOrderLibelleEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiAntennesGetCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAntennesGetCollection(page, itemsPerPage, isDeleted, orderIdAntenne, orderLibelle, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AntennesApi.apiAntennesGetCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete the selected antenna
         * @summary Delete the selected antenna
         * @param {string} idAntenne Antennes identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAntennesIdAntenneDelete(idAntenne: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAntennesIdAntenneDelete(idAntenne, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AntennesApi.apiAntennesIdAntenneDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get the antenna by id
         * @summary Get the antenna by id
         * @param {string} idAntenne Antennes identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAntennesIdAntenneGet(idAntenne: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AntennesJsonldAntenneRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAntennesIdAntenneGet(idAntenne, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AntennesApi.apiAntennesIdAntenneGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates the selected antenna informations
         * @summary Updates the selected antenna informations
         * @param {string} idAntenne Antennes identifier
         * @param {AntennesAntenneUpdate} antennesAntenneUpdate The updated Antennes resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAntennesIdAntennePatch(idAntenne: string, antennesAntenneUpdate: AntennesAntenneUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AntennesJsonldAntenneUpdate>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAntennesIdAntennePatch(idAntenne, antennesAntenneUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AntennesApi.apiAntennesIdAntennePatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates a new antenna in the Tbl_Antenne
         * @summary Creates a new antenna in the Tbl_Antenne
         * @param {AntennesJsonldAntenneWrite} antennesJsonldAntenneWrite The new Antennes resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAntennesPost(antennesJsonldAntenneWrite: AntennesJsonldAntenneWrite, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AntennesJsonldAntenneWrite>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAntennesPost(antennesJsonldAntenneWrite, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AntennesApi.apiAntennesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AntennesApi - factory interface
 * @export
 */
export const AntennesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AntennesApiFp(configuration)
    return {
        /**
         * Returns antennas collection
         * @summary Returns antennas collection
         * @param {AntennesApiApiAntennesGetCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAntennesGetCollection(requestParameters: AntennesApiApiAntennesGetCollectionRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ApiAntennesGetCollection200Response> {
            return localVarFp.apiAntennesGetCollection(requestParameters.page, requestParameters.itemsPerPage, requestParameters.isDeleted, requestParameters.orderIdAntenne, requestParameters.orderLibelle, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete the selected antenna
         * @summary Delete the selected antenna
         * @param {AntennesApiApiAntennesIdAntenneDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAntennesIdAntenneDelete(requestParameters: AntennesApiApiAntennesIdAntenneDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiAntennesIdAntenneDelete(requestParameters.idAntenne, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the antenna by id
         * @summary Get the antenna by id
         * @param {AntennesApiApiAntennesIdAntenneGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAntennesIdAntenneGet(requestParameters: AntennesApiApiAntennesIdAntenneGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<AntennesJsonldAntenneRead> {
            return localVarFp.apiAntennesIdAntenneGet(requestParameters.idAntenne, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates the selected antenna informations
         * @summary Updates the selected antenna informations
         * @param {AntennesApiApiAntennesIdAntennePatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAntennesIdAntennePatch(requestParameters: AntennesApiApiAntennesIdAntennePatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<AntennesJsonldAntenneUpdate> {
            return localVarFp.apiAntennesIdAntennePatch(requestParameters.idAntenne, requestParameters.antennesAntenneUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a new antenna in the Tbl_Antenne
         * @summary Creates a new antenna in the Tbl_Antenne
         * @param {AntennesApiApiAntennesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAntennesPost(requestParameters: AntennesApiApiAntennesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<AntennesJsonldAntenneWrite> {
            return localVarFp.apiAntennesPost(requestParameters.antennesJsonldAntenneWrite, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiAntennesGetCollection operation in AntennesApi.
 * @export
 * @interface AntennesApiApiAntennesGetCollectionRequest
 */
export interface AntennesApiApiAntennesGetCollectionRequest {
    /**
     * The collection page number
     * @type {number}
     * @memberof AntennesApiApiAntennesGetCollection
     */
    readonly page?: number

    /**
     * The number of items per page
     * @type {number}
     * @memberof AntennesApiApiAntennesGetCollection
     */
    readonly itemsPerPage?: number

    /**
     * 
     * @type {boolean}
     * @memberof AntennesApiApiAntennesGetCollection
     */
    readonly isDeleted?: boolean

    /**
     * 
     * @type {'asc' | 'desc'}
     * @memberof AntennesApiApiAntennesGetCollection
     */
    readonly orderIdAntenne?: ApiAntennesGetCollectionOrderIdAntenneEnum

    /**
     * 
     * @type {'asc' | 'desc'}
     * @memberof AntennesApiApiAntennesGetCollection
     */
    readonly orderLibelle?: ApiAntennesGetCollectionOrderLibelleEnum
}

/**
 * Request parameters for apiAntennesIdAntenneDelete operation in AntennesApi.
 * @export
 * @interface AntennesApiApiAntennesIdAntenneDeleteRequest
 */
export interface AntennesApiApiAntennesIdAntenneDeleteRequest {
    /**
     * Antennes identifier
     * @type {string}
     * @memberof AntennesApiApiAntennesIdAntenneDelete
     */
    readonly idAntenne: string
}

/**
 * Request parameters for apiAntennesIdAntenneGet operation in AntennesApi.
 * @export
 * @interface AntennesApiApiAntennesIdAntenneGetRequest
 */
export interface AntennesApiApiAntennesIdAntenneGetRequest {
    /**
     * Antennes identifier
     * @type {string}
     * @memberof AntennesApiApiAntennesIdAntenneGet
     */
    readonly idAntenne: string
}

/**
 * Request parameters for apiAntennesIdAntennePatch operation in AntennesApi.
 * @export
 * @interface AntennesApiApiAntennesIdAntennePatchRequest
 */
export interface AntennesApiApiAntennesIdAntennePatchRequest {
    /**
     * Antennes identifier
     * @type {string}
     * @memberof AntennesApiApiAntennesIdAntennePatch
     */
    readonly idAntenne: string

    /**
     * The updated Antennes resource
     * @type {AntennesAntenneUpdate}
     * @memberof AntennesApiApiAntennesIdAntennePatch
     */
    readonly antennesAntenneUpdate: AntennesAntenneUpdate
}

/**
 * Request parameters for apiAntennesPost operation in AntennesApi.
 * @export
 * @interface AntennesApiApiAntennesPostRequest
 */
export interface AntennesApiApiAntennesPostRequest {
    /**
     * The new Antennes resource
     * @type {AntennesJsonldAntenneWrite}
     * @memberof AntennesApiApiAntennesPost
     */
    readonly antennesJsonldAntenneWrite: AntennesJsonldAntenneWrite
}

/**
 * AntennesApi - object-oriented interface
 * @export
 * @class AntennesApi
 * @extends {BaseAPI}
 */
export class AntennesApi extends BaseAPI {
    /**
     * Returns antennas collection
     * @summary Returns antennas collection
     * @param {AntennesApiApiAntennesGetCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AntennesApi
     */
    public apiAntennesGetCollection(requestParameters: AntennesApiApiAntennesGetCollectionRequest = {}, options?: RawAxiosRequestConfig) {
        return AntennesApiFp(this.configuration).apiAntennesGetCollection(requestParameters.page, requestParameters.itemsPerPage, requestParameters.isDeleted, requestParameters.orderIdAntenne, requestParameters.orderLibelle, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete the selected antenna
     * @summary Delete the selected antenna
     * @param {AntennesApiApiAntennesIdAntenneDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AntennesApi
     */
    public apiAntennesIdAntenneDelete(requestParameters: AntennesApiApiAntennesIdAntenneDeleteRequest, options?: RawAxiosRequestConfig) {
        return AntennesApiFp(this.configuration).apiAntennesIdAntenneDelete(requestParameters.idAntenne, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the antenna by id
     * @summary Get the antenna by id
     * @param {AntennesApiApiAntennesIdAntenneGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AntennesApi
     */
    public apiAntennesIdAntenneGet(requestParameters: AntennesApiApiAntennesIdAntenneGetRequest, options?: RawAxiosRequestConfig) {
        return AntennesApiFp(this.configuration).apiAntennesIdAntenneGet(requestParameters.idAntenne, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates the selected antenna informations
     * @summary Updates the selected antenna informations
     * @param {AntennesApiApiAntennesIdAntennePatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AntennesApi
     */
    public apiAntennesIdAntennePatch(requestParameters: AntennesApiApiAntennesIdAntennePatchRequest, options?: RawAxiosRequestConfig) {
        return AntennesApiFp(this.configuration).apiAntennesIdAntennePatch(requestParameters.idAntenne, requestParameters.antennesAntenneUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a new antenna in the Tbl_Antenne
     * @summary Creates a new antenna in the Tbl_Antenne
     * @param {AntennesApiApiAntennesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AntennesApi
     */
    public apiAntennesPost(requestParameters: AntennesApiApiAntennesPostRequest, options?: RawAxiosRequestConfig) {
        return AntennesApiFp(this.configuration).apiAntennesPost(requestParameters.antennesJsonldAntenneWrite, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ApiAntennesGetCollectionOrderIdAntenneEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type ApiAntennesGetCollectionOrderIdAntenneEnum = typeof ApiAntennesGetCollectionOrderIdAntenneEnum[keyof typeof ApiAntennesGetCollectionOrderIdAntenneEnum];
/**
 * @export
 */
export const ApiAntennesGetCollectionOrderLibelleEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type ApiAntennesGetCollectionOrderLibelleEnum = typeof ApiAntennesGetCollectionOrderLibelleEnum[keyof typeof ApiAntennesGetCollectionOrderLibelleEnum];


/**
 * AvatarsApi - axios parameter creator
 * @export
 */
export const AvatarsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add avatar image on S3
         * @summary Add avatar image on S3
         * @param {File} avatar Image de l\\\&#39;avatar (taille max : 300 Ko). Tous les formats d\\\&#39;images
         * @param {string} userIdentifier user_identifier Keycloak
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAvatarsPost: async (avatar: File, userIdentifier: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'avatar' is not null or undefined
            assertParamExists('apiAvatarsPost', 'avatar', avatar)
            // verify required parameter 'userIdentifier' is not null or undefined
            assertParamExists('apiAvatarsPost', 'userIdentifier', userIdentifier)
            const localVarPath = `/utilisateur/avatars`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


            if (avatar !== undefined) { 
                localVarFormParams.append('avatar', avatar as any);
            }
    
            if (userIdentifier !== undefined) { 
                localVarFormParams.append('user_identifier', userIdentifier as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete avatar image on S3
         * @summary Delete avatar image on S3
         * @param {string} title Avatars identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAvatarsTitleDelete: async (title: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'title' is not null or undefined
            assertParamExists('apiAvatarsTitleDelete', 'title', title)
            const localVarPath = `/utilisateur/avatars/{title}`
                .replace(`{${"title"}}`, encodeURIComponent(String(title)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AvatarsApi - functional programming interface
 * @export
 */
export const AvatarsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AvatarsApiAxiosParamCreator(configuration)
    return {
        /**
         * Add avatar image on S3
         * @summary Add avatar image on S3
         * @param {File} avatar Image de l\\\&#39;avatar (taille max : 300 Ko). Tous les formats d\\\&#39;images
         * @param {string} userIdentifier user_identifier Keycloak
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAvatarsPost(avatar: File, userIdentifier: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AvatarsJsonldAvatarResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAvatarsPost(avatar, userIdentifier, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AvatarsApi.apiAvatarsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete avatar image on S3
         * @summary Delete avatar image on S3
         * @param {string} title Avatars identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAvatarsTitleDelete(title: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAvatarsTitleDelete(title, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AvatarsApi.apiAvatarsTitleDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AvatarsApi - factory interface
 * @export
 */
export const AvatarsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AvatarsApiFp(configuration)
    return {
        /**
         * Add avatar image on S3
         * @summary Add avatar image on S3
         * @param {AvatarsApiApiAvatarsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAvatarsPost(requestParameters: AvatarsApiApiAvatarsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<AvatarsJsonldAvatarResponse> {
            return localVarFp.apiAvatarsPost(requestParameters.avatar, requestParameters.userIdentifier, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete avatar image on S3
         * @summary Delete avatar image on S3
         * @param {AvatarsApiApiAvatarsTitleDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAvatarsTitleDelete(requestParameters: AvatarsApiApiAvatarsTitleDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiAvatarsTitleDelete(requestParameters.title, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiAvatarsPost operation in AvatarsApi.
 * @export
 * @interface AvatarsApiApiAvatarsPostRequest
 */
export interface AvatarsApiApiAvatarsPostRequest {
    /**
     * Image de l\\\&#39;avatar (taille max : 300 Ko). Tous les formats d\\\&#39;images
     * @type {File}
     * @memberof AvatarsApiApiAvatarsPost
     */
    readonly avatar: File

    /**
     * user_identifier Keycloak
     * @type {string}
     * @memberof AvatarsApiApiAvatarsPost
     */
    readonly userIdentifier: string
}

/**
 * Request parameters for apiAvatarsTitleDelete operation in AvatarsApi.
 * @export
 * @interface AvatarsApiApiAvatarsTitleDeleteRequest
 */
export interface AvatarsApiApiAvatarsTitleDeleteRequest {
    /**
     * Avatars identifier
     * @type {string}
     * @memberof AvatarsApiApiAvatarsTitleDelete
     */
    readonly title: string
}

/**
 * AvatarsApi - object-oriented interface
 * @export
 * @class AvatarsApi
 * @extends {BaseAPI}
 */
export class AvatarsApi extends BaseAPI {
    /**
     * Add avatar image on S3
     * @summary Add avatar image on S3
     * @param {AvatarsApiApiAvatarsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AvatarsApi
     */
    public apiAvatarsPost(requestParameters: AvatarsApiApiAvatarsPostRequest, options?: RawAxiosRequestConfig) {
        return AvatarsApiFp(this.configuration).apiAvatarsPost(requestParameters.avatar, requestParameters.userIdentifier, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete avatar image on S3
     * @summary Delete avatar image on S3
     * @param {AvatarsApiApiAvatarsTitleDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AvatarsApi
     */
    public apiAvatarsTitleDelete(requestParameters: AvatarsApiApiAvatarsTitleDeleteRequest, options?: RawAxiosRequestConfig) {
        return AvatarsApiFp(this.configuration).apiAvatarsTitleDelete(requestParameters.title, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DomaineApi - axios parameter creator
 * @export
 */
export const DomaineApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieves a Domaine resource.
         * @summary Retrieves a Domaine resource.
         * @param {string} ddmId Domaine identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDomainesDdmIdGet: async (ddmId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ddmId' is not null or undefined
            assertParamExists('apiDomainesDdmIdGet', 'ddmId', ddmId)
            const localVarPath = `/utilisateur/domaines/{ddmId}`
                .replace(`{${"ddmId"}}`, encodeURIComponent(String(ddmId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the collection of Domaine resources.
         * @summary Retrieves the collection of Domaine resources.
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDomainesGetCollection: async (page?: number, itemsPerPage?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/utilisateur/domaines`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DomaineApi - functional programming interface
 * @export
 */
export const DomaineApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DomaineApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieves a Domaine resource.
         * @summary Retrieves a Domaine resource.
         * @param {string} ddmId Domaine identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDomainesDdmIdGet(ddmId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DomaineJsonldDomaineRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDomainesDdmIdGet(ddmId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DomaineApi.apiDomainesDdmIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves the collection of Domaine resources.
         * @summary Retrieves the collection of Domaine resources.
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDomainesGetCollection(page?: number, itemsPerPage?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiDomainesGetCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDomainesGetCollection(page, itemsPerPage, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DomaineApi.apiDomainesGetCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DomaineApi - factory interface
 * @export
 */
export const DomaineApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DomaineApiFp(configuration)
    return {
        /**
         * Retrieves a Domaine resource.
         * @summary Retrieves a Domaine resource.
         * @param {DomaineApiApiDomainesDdmIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDomainesDdmIdGet(requestParameters: DomaineApiApiDomainesDdmIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<DomaineJsonldDomaineRead> {
            return localVarFp.apiDomainesDdmIdGet(requestParameters.ddmId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the collection of Domaine resources.
         * @summary Retrieves the collection of Domaine resources.
         * @param {DomaineApiApiDomainesGetCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDomainesGetCollection(requestParameters: DomaineApiApiDomainesGetCollectionRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ApiDomainesGetCollection200Response> {
            return localVarFp.apiDomainesGetCollection(requestParameters.page, requestParameters.itemsPerPage, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiDomainesDdmIdGet operation in DomaineApi.
 * @export
 * @interface DomaineApiApiDomainesDdmIdGetRequest
 */
export interface DomaineApiApiDomainesDdmIdGetRequest {
    /**
     * Domaine identifier
     * @type {string}
     * @memberof DomaineApiApiDomainesDdmIdGet
     */
    readonly ddmId: string
}

/**
 * Request parameters for apiDomainesGetCollection operation in DomaineApi.
 * @export
 * @interface DomaineApiApiDomainesGetCollectionRequest
 */
export interface DomaineApiApiDomainesGetCollectionRequest {
    /**
     * The collection page number
     * @type {number}
     * @memberof DomaineApiApiDomainesGetCollection
     */
    readonly page?: number

    /**
     * The number of items per page
     * @type {number}
     * @memberof DomaineApiApiDomainesGetCollection
     */
    readonly itemsPerPage?: number
}

/**
 * DomaineApi - object-oriented interface
 * @export
 * @class DomaineApi
 * @extends {BaseAPI}
 */
export class DomaineApi extends BaseAPI {
    /**
     * Retrieves a Domaine resource.
     * @summary Retrieves a Domaine resource.
     * @param {DomaineApiApiDomainesDdmIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DomaineApi
     */
    public apiDomainesDdmIdGet(requestParameters: DomaineApiApiDomainesDdmIdGetRequest, options?: RawAxiosRequestConfig) {
        return DomaineApiFp(this.configuration).apiDomainesDdmIdGet(requestParameters.ddmId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the collection of Domaine resources.
     * @summary Retrieves the collection of Domaine resources.
     * @param {DomaineApiApiDomainesGetCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DomaineApi
     */
    public apiDomainesGetCollection(requestParameters: DomaineApiApiDomainesGetCollectionRequest = {}, options?: RawAxiosRequestConfig) {
        return DomaineApiFp(this.configuration).apiDomainesGetCollection(requestParameters.page, requestParameters.itemsPerPage, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DroitsApi - axios parameter creator
 * @export
 */
export const DroitsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns all resources from Tbl_Utilisateur_Droit
         * @summary Returns all resources from Tbl_Utilisateur_Droit
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {boolean} [pagination] Enable or disable pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDroitGetCollection: async (page?: number, itemsPerPage?: number, pagination?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/utilisateur/droit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }

            if (pagination !== undefined) {
                localVarQueryParameter['pagination'] = pagination;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DroitsApi - functional programming interface
 * @export
 */
export const DroitsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DroitsApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns all resources from Tbl_Utilisateur_Droit
         * @summary Returns all resources from Tbl_Utilisateur_Droit
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {boolean} [pagination] Enable or disable pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDroitGetCollection(page?: number, itemsPerPage?: number, pagination?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiDroitGetCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDroitGetCollection(page, itemsPerPage, pagination, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DroitsApi.apiDroitGetCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DroitsApi - factory interface
 * @export
 */
export const DroitsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DroitsApiFp(configuration)
    return {
        /**
         * Returns all resources from Tbl_Utilisateur_Droit
         * @summary Returns all resources from Tbl_Utilisateur_Droit
         * @param {DroitsApiApiDroitGetCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDroitGetCollection(requestParameters: DroitsApiApiDroitGetCollectionRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ApiDroitGetCollection200Response> {
            return localVarFp.apiDroitGetCollection(requestParameters.page, requestParameters.itemsPerPage, requestParameters.pagination, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiDroitGetCollection operation in DroitsApi.
 * @export
 * @interface DroitsApiApiDroitGetCollectionRequest
 */
export interface DroitsApiApiDroitGetCollectionRequest {
    /**
     * The collection page number
     * @type {number}
     * @memberof DroitsApiApiDroitGetCollection
     */
    readonly page?: number

    /**
     * The number of items per page
     * @type {number}
     * @memberof DroitsApiApiDroitGetCollection
     */
    readonly itemsPerPage?: number

    /**
     * Enable or disable pagination
     * @type {boolean}
     * @memberof DroitsApiApiDroitGetCollection
     */
    readonly pagination?: boolean
}

/**
 * DroitsApi - object-oriented interface
 * @export
 * @class DroitsApi
 * @extends {BaseAPI}
 */
export class DroitsApi extends BaseAPI {
    /**
     * Returns all resources from Tbl_Utilisateur_Droit
     * @summary Returns all resources from Tbl_Utilisateur_Droit
     * @param {DroitsApiApiDroitGetCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DroitsApi
     */
    public apiDroitGetCollection(requestParameters: DroitsApiApiDroitGetCollectionRequest = {}, options?: RawAxiosRequestConfig) {
        return DroitsApiFp(this.configuration).apiDroitGetCollection(requestParameters.page, requestParameters.itemsPerPage, requestParameters.pagination, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * GroupesApi - axios parameter creator
 * @export
 */
export const GroupesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns the groups collection.
         * @summary Returns the groups collection.
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {boolean} [flagDelete] 
         * @param {boolean} [gieGroup] Filter by group id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGroupesGetCollection: async (page?: number, itemsPerPage?: number, flagDelete?: boolean, gieGroup?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/utilisateur/groupes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }

            if (flagDelete !== undefined) {
                localVarQueryParameter['flagDelete'] = flagDelete;
            }

            if (gieGroup !== undefined) {
                localVarQueryParameter['gieGroup'] = gieGroup;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GroupesApi - functional programming interface
 * @export
 */
export const GroupesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GroupesApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns the groups collection.
         * @summary Returns the groups collection.
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {boolean} [flagDelete] 
         * @param {boolean} [gieGroup] Filter by group id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiGroupesGetCollection(page?: number, itemsPerPage?: number, flagDelete?: boolean, gieGroup?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiGroupesGetCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiGroupesGetCollection(page, itemsPerPage, flagDelete, gieGroup, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GroupesApi.apiGroupesGetCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * GroupesApi - factory interface
 * @export
 */
export const GroupesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GroupesApiFp(configuration)
    return {
        /**
         * Returns the groups collection.
         * @summary Returns the groups collection.
         * @param {GroupesApiApiGroupesGetCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGroupesGetCollection(requestParameters: GroupesApiApiGroupesGetCollectionRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ApiGroupesGetCollection200Response> {
            return localVarFp.apiGroupesGetCollection(requestParameters.page, requestParameters.itemsPerPage, requestParameters.flagDelete, requestParameters.gieGroup, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiGroupesGetCollection operation in GroupesApi.
 * @export
 * @interface GroupesApiApiGroupesGetCollectionRequest
 */
export interface GroupesApiApiGroupesGetCollectionRequest {
    /**
     * The collection page number
     * @type {number}
     * @memberof GroupesApiApiGroupesGetCollection
     */
    readonly page?: number

    /**
     * The number of items per page
     * @type {number}
     * @memberof GroupesApiApiGroupesGetCollection
     */
    readonly itemsPerPage?: number

    /**
     * 
     * @type {boolean}
     * @memberof GroupesApiApiGroupesGetCollection
     */
    readonly flagDelete?: boolean

    /**
     * Filter by group id
     * @type {boolean}
     * @memberof GroupesApiApiGroupesGetCollection
     */
    readonly gieGroup?: boolean
}

/**
 * GroupesApi - object-oriented interface
 * @export
 * @class GroupesApi
 * @extends {BaseAPI}
 */
export class GroupesApi extends BaseAPI {
    /**
     * Returns the groups collection.
     * @summary Returns the groups collection.
     * @param {GroupesApiApiGroupesGetCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupesApi
     */
    public apiGroupesGetCollection(requestParameters: GroupesApiApiGroupesGetCollectionRequest = {}, options?: RawAxiosRequestConfig) {
        return GroupesApiFp(this.configuration).apiGroupesGetCollection(requestParameters.page, requestParameters.itemsPerPage, requestParameters.flagDelete, requestParameters.gieGroup, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * GroupesDeTravailApi - axios parameter creator
 * @export
 */
export const GroupesDeTravailApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns the workgroups collection
         * @summary Returns the workgroups collection
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {string} [domaineDdmLibelle] 
         * @param {string} [lib] 
         * @param {string} [iduserReferent] 
         * @param {Array<string>} [iduserReferent2] 
         * @param {ApiGroupestravailGetCollectionOrderDomaineDdmLibelleEnum} [orderDomaineDdmLibelle] 
         * @param {ApiGroupestravailGetCollectionOrderLibEnum} [orderLib] 
         * @param {ApiGroupestravailGetCollectionOrderDCreationEnum} [orderDCreation] 
         * @param {string} [multiFieldSearch] Partial search in chosen fields
         * @param {boolean} [fDeleteStatus] filter active or all workgroups
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGroupestravailGetCollection: async (page?: number, itemsPerPage?: number, domaineDdmLibelle?: string, lib?: string, iduserReferent?: string, iduserReferent2?: Array<string>, orderDomaineDdmLibelle?: ApiGroupestravailGetCollectionOrderDomaineDdmLibelleEnum, orderLib?: ApiGroupestravailGetCollectionOrderLibEnum, orderDCreation?: ApiGroupestravailGetCollectionOrderDCreationEnum, multiFieldSearch?: string, fDeleteStatus?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/utilisateur/groupestravail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }

            if (domaineDdmLibelle !== undefined) {
                localVarQueryParameter['domaine.ddmLibelle'] = domaineDdmLibelle;
            }

            if (lib !== undefined) {
                localVarQueryParameter['lib'] = lib;
            }

            if (iduserReferent !== undefined) {
                localVarQueryParameter['iduserReferent'] = iduserReferent;
            }

            if (iduserReferent2) {
                localVarQueryParameter['iduserReferent[]'] = iduserReferent2;
            }

            if (orderDomaineDdmLibelle !== undefined) {
                localVarQueryParameter['order[domaine.ddmLibelle]'] = orderDomaineDdmLibelle;
            }

            if (orderLib !== undefined) {
                localVarQueryParameter['order[lib]'] = orderLib;
            }

            if (orderDCreation !== undefined) {
                localVarQueryParameter['order[dCreation]'] = orderDCreation;
            }

            if (multiFieldSearch !== undefined) {
                localVarQueryParameter['MultiFieldSearch'] = multiFieldSearch;
            }

            if (fDeleteStatus !== undefined) {
                localVarQueryParameter['fDeleteStatus'] = fDeleteStatus;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deactivate workgroup 
         * @summary Soft Delete Workgroup and cascading relation
         * @param {string} id Groupes de travail identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGroupestravailIdDelete: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiGroupestravailIdDelete', 'id', id)
            const localVarPath = `/utilisateur/groupestravail/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a Groupes de travail resource.
         * @summary Retrieves a Groupes de travail resource.
         * @param {string} id Groupes de travail identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGroupestravailIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiGroupestravailIdGet', 'id', id)
            const localVarPath = `/utilisateur/groupestravail/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates a workgroup
         * @summary Updates a workgroup
         * @param {string} idGroupeTravail Groupes de travail identifier
         * @param {string} status Groupes de travail identifier
         * @param {GroupesDeTravail} groupesDeTravail The updated Groupes de travail resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGroupestravailIdGroupeTravailStatusPatch: async (idGroupeTravail: string, status: string, groupesDeTravail: GroupesDeTravail, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idGroupeTravail' is not null or undefined
            assertParamExists('apiGroupestravailIdGroupeTravailStatusPatch', 'idGroupeTravail', idGroupeTravail)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('apiGroupestravailIdGroupeTravailStatusPatch', 'status', status)
            // verify required parameter 'groupesDeTravail' is not null or undefined
            assertParamExists('apiGroupestravailIdGroupeTravailStatusPatch', 'groupesDeTravail', groupesDeTravail)
            const localVarPath = `/utilisateur/groupestravail/{idGroupeTravail}/{status}`
                .replace(`{${"idGroupeTravail"}}`, encodeURIComponent(String(idGroupeTravail)))
                .replace(`{${"status"}}`, encodeURIComponent(String(status)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/merge-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(groupesDeTravail, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a new workgroup
         * @summary Creates a new workgroup
         * @param {GroupesDeTravailJsonld} groupesDeTravailJsonld The new Groupes de travail resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGroupestravailPost: async (groupesDeTravailJsonld: GroupesDeTravailJsonld, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupesDeTravailJsonld' is not null or undefined
            assertParamExists('apiGroupestravailPost', 'groupesDeTravailJsonld', groupesDeTravailJsonld)
            const localVarPath = `/utilisateur/groupestravail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(groupesDeTravailJsonld, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GroupesDeTravailApi - functional programming interface
 * @export
 */
export const GroupesDeTravailApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GroupesDeTravailApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns the workgroups collection
         * @summary Returns the workgroups collection
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {string} [domaineDdmLibelle] 
         * @param {string} [lib] 
         * @param {string} [iduserReferent] 
         * @param {Array<string>} [iduserReferent2] 
         * @param {ApiGroupestravailGetCollectionOrderDomaineDdmLibelleEnum} [orderDomaineDdmLibelle] 
         * @param {ApiGroupestravailGetCollectionOrderLibEnum} [orderLib] 
         * @param {ApiGroupestravailGetCollectionOrderDCreationEnum} [orderDCreation] 
         * @param {string} [multiFieldSearch] Partial search in chosen fields
         * @param {boolean} [fDeleteStatus] filter active or all workgroups
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiGroupestravailGetCollection(page?: number, itemsPerPage?: number, domaineDdmLibelle?: string, lib?: string, iduserReferent?: string, iduserReferent2?: Array<string>, orderDomaineDdmLibelle?: ApiGroupestravailGetCollectionOrderDomaineDdmLibelleEnum, orderLib?: ApiGroupestravailGetCollectionOrderLibEnum, orderDCreation?: ApiGroupestravailGetCollectionOrderDCreationEnum, multiFieldSearch?: string, fDeleteStatus?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiGroupestravailGetCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiGroupestravailGetCollection(page, itemsPerPage, domaineDdmLibelle, lib, iduserReferent, iduserReferent2, orderDomaineDdmLibelle, orderLib, orderDCreation, multiFieldSearch, fDeleteStatus, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GroupesDeTravailApi.apiGroupestravailGetCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Deactivate workgroup 
         * @summary Soft Delete Workgroup and cascading relation
         * @param {string} id Groupes de travail identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiGroupestravailIdDelete(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiGroupestravailIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GroupesDeTravailApi.apiGroupestravailIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves a Groupes de travail resource.
         * @summary Retrieves a Groupes de travail resource.
         * @param {string} id Groupes de travail identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiGroupestravailIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GroupesDeTravailJsonldWorkgroupReadUtilisateurReadDomaineRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiGroupestravailIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GroupesDeTravailApi.apiGroupestravailIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates a workgroup
         * @summary Updates a workgroup
         * @param {string} idGroupeTravail Groupes de travail identifier
         * @param {string} status Groupes de travail identifier
         * @param {GroupesDeTravail} groupesDeTravail The updated Groupes de travail resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiGroupestravailIdGroupeTravailStatusPatch(idGroupeTravail: string, status: string, groupesDeTravail: GroupesDeTravail, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GroupesDeTravailJsonld>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiGroupestravailIdGroupeTravailStatusPatch(idGroupeTravail, status, groupesDeTravail, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GroupesDeTravailApi.apiGroupestravailIdGroupeTravailStatusPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates a new workgroup
         * @summary Creates a new workgroup
         * @param {GroupesDeTravailJsonld} groupesDeTravailJsonld The new Groupes de travail resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiGroupestravailPost(groupesDeTravailJsonld: GroupesDeTravailJsonld, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GroupesDeTravailJsonld>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiGroupestravailPost(groupesDeTravailJsonld, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GroupesDeTravailApi.apiGroupestravailPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * GroupesDeTravailApi - factory interface
 * @export
 */
export const GroupesDeTravailApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GroupesDeTravailApiFp(configuration)
    return {
        /**
         * Returns the workgroups collection
         * @summary Returns the workgroups collection
         * @param {GroupesDeTravailApiApiGroupestravailGetCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGroupestravailGetCollection(requestParameters: GroupesDeTravailApiApiGroupestravailGetCollectionRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ApiGroupestravailGetCollection200Response> {
            return localVarFp.apiGroupestravailGetCollection(requestParameters.page, requestParameters.itemsPerPage, requestParameters.domaineDdmLibelle, requestParameters.lib, requestParameters.iduserReferent, requestParameters.iduserReferent2, requestParameters.orderDomaineDdmLibelle, requestParameters.orderLib, requestParameters.orderDCreation, requestParameters.multiFieldSearch, requestParameters.fDeleteStatus, options).then((request) => request(axios, basePath));
        },
        /**
         * Deactivate workgroup 
         * @summary Soft Delete Workgroup and cascading relation
         * @param {GroupesDeTravailApiApiGroupestravailIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGroupestravailIdDelete(requestParameters: GroupesDeTravailApiApiGroupestravailIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiGroupestravailIdDelete(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a Groupes de travail resource.
         * @summary Retrieves a Groupes de travail resource.
         * @param {GroupesDeTravailApiApiGroupestravailIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGroupestravailIdGet(requestParameters: GroupesDeTravailApiApiGroupestravailIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<GroupesDeTravailJsonldWorkgroupReadUtilisateurReadDomaineRead> {
            return localVarFp.apiGroupestravailIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates a workgroup
         * @summary Updates a workgroup
         * @param {GroupesDeTravailApiApiGroupestravailIdGroupeTravailStatusPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGroupestravailIdGroupeTravailStatusPatch(requestParameters: GroupesDeTravailApiApiGroupestravailIdGroupeTravailStatusPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<GroupesDeTravailJsonld> {
            return localVarFp.apiGroupestravailIdGroupeTravailStatusPatch(requestParameters.idGroupeTravail, requestParameters.status, requestParameters.groupesDeTravail, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a new workgroup
         * @summary Creates a new workgroup
         * @param {GroupesDeTravailApiApiGroupestravailPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGroupestravailPost(requestParameters: GroupesDeTravailApiApiGroupestravailPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<GroupesDeTravailJsonld> {
            return localVarFp.apiGroupestravailPost(requestParameters.groupesDeTravailJsonld, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiGroupestravailGetCollection operation in GroupesDeTravailApi.
 * @export
 * @interface GroupesDeTravailApiApiGroupestravailGetCollectionRequest
 */
export interface GroupesDeTravailApiApiGroupestravailGetCollectionRequest {
    /**
     * The collection page number
     * @type {number}
     * @memberof GroupesDeTravailApiApiGroupestravailGetCollection
     */
    readonly page?: number

    /**
     * The number of items per page
     * @type {number}
     * @memberof GroupesDeTravailApiApiGroupestravailGetCollection
     */
    readonly itemsPerPage?: number

    /**
     * 
     * @type {string}
     * @memberof GroupesDeTravailApiApiGroupestravailGetCollection
     */
    readonly domaineDdmLibelle?: string

    /**
     * 
     * @type {string}
     * @memberof GroupesDeTravailApiApiGroupestravailGetCollection
     */
    readonly lib?: string

    /**
     * 
     * @type {string}
     * @memberof GroupesDeTravailApiApiGroupestravailGetCollection
     */
    readonly iduserReferent?: string

    /**
     * 
     * @type {Array<string>}
     * @memberof GroupesDeTravailApiApiGroupestravailGetCollection
     */
    readonly iduserReferent2?: Array<string>

    /**
     * 
     * @type {'asc' | 'desc'}
     * @memberof GroupesDeTravailApiApiGroupestravailGetCollection
     */
    readonly orderDomaineDdmLibelle?: ApiGroupestravailGetCollectionOrderDomaineDdmLibelleEnum

    /**
     * 
     * @type {'asc' | 'desc'}
     * @memberof GroupesDeTravailApiApiGroupestravailGetCollection
     */
    readonly orderLib?: ApiGroupestravailGetCollectionOrderLibEnum

    /**
     * 
     * @type {'asc' | 'desc'}
     * @memberof GroupesDeTravailApiApiGroupestravailGetCollection
     */
    readonly orderDCreation?: ApiGroupestravailGetCollectionOrderDCreationEnum

    /**
     * Partial search in chosen fields
     * @type {string}
     * @memberof GroupesDeTravailApiApiGroupestravailGetCollection
     */
    readonly multiFieldSearch?: string

    /**
     * filter active or all workgroups
     * @type {boolean}
     * @memberof GroupesDeTravailApiApiGroupestravailGetCollection
     */
    readonly fDeleteStatus?: boolean
}

/**
 * Request parameters for apiGroupestravailIdDelete operation in GroupesDeTravailApi.
 * @export
 * @interface GroupesDeTravailApiApiGroupestravailIdDeleteRequest
 */
export interface GroupesDeTravailApiApiGroupestravailIdDeleteRequest {
    /**
     * Groupes de travail identifier
     * @type {string}
     * @memberof GroupesDeTravailApiApiGroupestravailIdDelete
     */
    readonly id: string
}

/**
 * Request parameters for apiGroupestravailIdGet operation in GroupesDeTravailApi.
 * @export
 * @interface GroupesDeTravailApiApiGroupestravailIdGetRequest
 */
export interface GroupesDeTravailApiApiGroupestravailIdGetRequest {
    /**
     * Groupes de travail identifier
     * @type {string}
     * @memberof GroupesDeTravailApiApiGroupestravailIdGet
     */
    readonly id: string
}

/**
 * Request parameters for apiGroupestravailIdGroupeTravailStatusPatch operation in GroupesDeTravailApi.
 * @export
 * @interface GroupesDeTravailApiApiGroupestravailIdGroupeTravailStatusPatchRequest
 */
export interface GroupesDeTravailApiApiGroupestravailIdGroupeTravailStatusPatchRequest {
    /**
     * Groupes de travail identifier
     * @type {string}
     * @memberof GroupesDeTravailApiApiGroupestravailIdGroupeTravailStatusPatch
     */
    readonly idGroupeTravail: string

    /**
     * Groupes de travail identifier
     * @type {string}
     * @memberof GroupesDeTravailApiApiGroupestravailIdGroupeTravailStatusPatch
     */
    readonly status: string

    /**
     * The updated Groupes de travail resource
     * @type {GroupesDeTravail}
     * @memberof GroupesDeTravailApiApiGroupestravailIdGroupeTravailStatusPatch
     */
    readonly groupesDeTravail: GroupesDeTravail
}

/**
 * Request parameters for apiGroupestravailPost operation in GroupesDeTravailApi.
 * @export
 * @interface GroupesDeTravailApiApiGroupestravailPostRequest
 */
export interface GroupesDeTravailApiApiGroupestravailPostRequest {
    /**
     * The new Groupes de travail resource
     * @type {GroupesDeTravailJsonld}
     * @memberof GroupesDeTravailApiApiGroupestravailPost
     */
    readonly groupesDeTravailJsonld: GroupesDeTravailJsonld
}

/**
 * GroupesDeTravailApi - object-oriented interface
 * @export
 * @class GroupesDeTravailApi
 * @extends {BaseAPI}
 */
export class GroupesDeTravailApi extends BaseAPI {
    /**
     * Returns the workgroups collection
     * @summary Returns the workgroups collection
     * @param {GroupesDeTravailApiApiGroupestravailGetCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupesDeTravailApi
     */
    public apiGroupestravailGetCollection(requestParameters: GroupesDeTravailApiApiGroupestravailGetCollectionRequest = {}, options?: RawAxiosRequestConfig) {
        return GroupesDeTravailApiFp(this.configuration).apiGroupestravailGetCollection(requestParameters.page, requestParameters.itemsPerPage, requestParameters.domaineDdmLibelle, requestParameters.lib, requestParameters.iduserReferent, requestParameters.iduserReferent2, requestParameters.orderDomaineDdmLibelle, requestParameters.orderLib, requestParameters.orderDCreation, requestParameters.multiFieldSearch, requestParameters.fDeleteStatus, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deactivate workgroup 
     * @summary Soft Delete Workgroup and cascading relation
     * @param {GroupesDeTravailApiApiGroupestravailIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupesDeTravailApi
     */
    public apiGroupestravailIdDelete(requestParameters: GroupesDeTravailApiApiGroupestravailIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return GroupesDeTravailApiFp(this.configuration).apiGroupestravailIdDelete(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a Groupes de travail resource.
     * @summary Retrieves a Groupes de travail resource.
     * @param {GroupesDeTravailApiApiGroupestravailIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupesDeTravailApi
     */
    public apiGroupestravailIdGet(requestParameters: GroupesDeTravailApiApiGroupestravailIdGetRequest, options?: RawAxiosRequestConfig) {
        return GroupesDeTravailApiFp(this.configuration).apiGroupestravailIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates a workgroup
     * @summary Updates a workgroup
     * @param {GroupesDeTravailApiApiGroupestravailIdGroupeTravailStatusPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupesDeTravailApi
     */
    public apiGroupestravailIdGroupeTravailStatusPatch(requestParameters: GroupesDeTravailApiApiGroupestravailIdGroupeTravailStatusPatchRequest, options?: RawAxiosRequestConfig) {
        return GroupesDeTravailApiFp(this.configuration).apiGroupestravailIdGroupeTravailStatusPatch(requestParameters.idGroupeTravail, requestParameters.status, requestParameters.groupesDeTravail, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a new workgroup
     * @summary Creates a new workgroup
     * @param {GroupesDeTravailApiApiGroupestravailPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupesDeTravailApi
     */
    public apiGroupestravailPost(requestParameters: GroupesDeTravailApiApiGroupestravailPostRequest, options?: RawAxiosRequestConfig) {
        return GroupesDeTravailApiFp(this.configuration).apiGroupestravailPost(requestParameters.groupesDeTravailJsonld, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ApiGroupestravailGetCollectionOrderDomaineDdmLibelleEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type ApiGroupestravailGetCollectionOrderDomaineDdmLibelleEnum = typeof ApiGroupestravailGetCollectionOrderDomaineDdmLibelleEnum[keyof typeof ApiGroupestravailGetCollectionOrderDomaineDdmLibelleEnum];
/**
 * @export
 */
export const ApiGroupestravailGetCollectionOrderLibEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type ApiGroupestravailGetCollectionOrderLibEnum = typeof ApiGroupestravailGetCollectionOrderLibEnum[keyof typeof ApiGroupestravailGetCollectionOrderLibEnum];
/**
 * @export
 */
export const ApiGroupestravailGetCollectionOrderDCreationEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type ApiGroupestravailGetCollectionOrderDCreationEnum = typeof ApiGroupestravailGetCollectionOrderDCreationEnum[keyof typeof ApiGroupestravailGetCollectionOrderDCreationEnum];


/**
 * JointureUtilisateurGroupeTravailApi - axios parameter creator
 * @export
 */
export const JointureUtilisateurGroupeTravailApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns all relations between users and workgroups
         * @summary Returns all relations between users and workgroups
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {string} [groupetravail] 
         * @param {Array<string>} [groupetravail2] 
         * @param {string} [user] 
         * @param {Array<string>} [user2] 
         * @param {boolean} [historicInscription] Active or deleted/ended status of inscription
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUtilisateurgroupetravailGetCollection: async (page?: number, itemsPerPage?: number, groupetravail?: string, groupetravail2?: Array<string>, user?: string, user2?: Array<string>, historicInscription?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/utilisateur/utilisateurgroupetravail/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }

            if (groupetravail !== undefined) {
                localVarQueryParameter['groupetravail'] = groupetravail;
            }

            if (groupetravail2) {
                localVarQueryParameter['groupetravail[]'] = groupetravail2;
            }

            if (user !== undefined) {
                localVarQueryParameter['user'] = user;
            }

            if (user2) {
                localVarQueryParameter['user[]'] = user2;
            }

            if (historicInscription !== undefined) {
                localVarQueryParameter['historicInscription'] = historicInscription;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a Jointure Utilisateur / Groupe Travail resource.
         * @summary Retrieves a Jointure Utilisateur / Groupe Travail resource.
         * @param {string} id Jointure Utilisateur / Groupe Travail identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUtilisateurgroupetravailIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiUtilisateurgroupetravailIdGet', 'id', id)
            const localVarPath = `/utilisateur/utilisateurgroupetravail/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * JointureUtilisateurGroupeTravailApi - functional programming interface
 * @export
 */
export const JointureUtilisateurGroupeTravailApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = JointureUtilisateurGroupeTravailApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns all relations between users and workgroups
         * @summary Returns all relations between users and workgroups
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {string} [groupetravail] 
         * @param {Array<string>} [groupetravail2] 
         * @param {string} [user] 
         * @param {Array<string>} [user2] 
         * @param {boolean} [historicInscription] Active or deleted/ended status of inscription
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUtilisateurgroupetravailGetCollection(page?: number, itemsPerPage?: number, groupetravail?: string, groupetravail2?: Array<string>, user?: string, user2?: Array<string>, historicInscription?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiUtilisateurgroupetravailGetCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUtilisateurgroupetravailGetCollection(page, itemsPerPage, groupetravail, groupetravail2, user, user2, historicInscription, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JointureUtilisateurGroupeTravailApi.apiUtilisateurgroupetravailGetCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves a Jointure Utilisateur / Groupe Travail resource.
         * @summary Retrieves a Jointure Utilisateur / Groupe Travail resource.
         * @param {string} id Jointure Utilisateur / Groupe Travail identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUtilisateurgroupetravailIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JointureUtilisateurGroupeTravailJsonldWorkgroupReadUtilisateurReadDomaineRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUtilisateurgroupetravailIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JointureUtilisateurGroupeTravailApi.apiUtilisateurgroupetravailIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * JointureUtilisateurGroupeTravailApi - factory interface
 * @export
 */
export const JointureUtilisateurGroupeTravailApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = JointureUtilisateurGroupeTravailApiFp(configuration)
    return {
        /**
         * Returns all relations between users and workgroups
         * @summary Returns all relations between users and workgroups
         * @param {JointureUtilisateurGroupeTravailApiApiUtilisateurgroupetravailGetCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUtilisateurgroupetravailGetCollection(requestParameters: JointureUtilisateurGroupeTravailApiApiUtilisateurgroupetravailGetCollectionRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ApiUtilisateurgroupetravailGetCollection200Response> {
            return localVarFp.apiUtilisateurgroupetravailGetCollection(requestParameters.page, requestParameters.itemsPerPage, requestParameters.groupetravail, requestParameters.groupetravail2, requestParameters.user, requestParameters.user2, requestParameters.historicInscription, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a Jointure Utilisateur / Groupe Travail resource.
         * @summary Retrieves a Jointure Utilisateur / Groupe Travail resource.
         * @param {JointureUtilisateurGroupeTravailApiApiUtilisateurgroupetravailIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUtilisateurgroupetravailIdGet(requestParameters: JointureUtilisateurGroupeTravailApiApiUtilisateurgroupetravailIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<JointureUtilisateurGroupeTravailJsonldWorkgroupReadUtilisateurReadDomaineRead> {
            return localVarFp.apiUtilisateurgroupetravailIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiUtilisateurgroupetravailGetCollection operation in JointureUtilisateurGroupeTravailApi.
 * @export
 * @interface JointureUtilisateurGroupeTravailApiApiUtilisateurgroupetravailGetCollectionRequest
 */
export interface JointureUtilisateurGroupeTravailApiApiUtilisateurgroupetravailGetCollectionRequest {
    /**
     * The collection page number
     * @type {number}
     * @memberof JointureUtilisateurGroupeTravailApiApiUtilisateurgroupetravailGetCollection
     */
    readonly page?: number

    /**
     * The number of items per page
     * @type {number}
     * @memberof JointureUtilisateurGroupeTravailApiApiUtilisateurgroupetravailGetCollection
     */
    readonly itemsPerPage?: number

    /**
     * 
     * @type {string}
     * @memberof JointureUtilisateurGroupeTravailApiApiUtilisateurgroupetravailGetCollection
     */
    readonly groupetravail?: string

    /**
     * 
     * @type {Array<string>}
     * @memberof JointureUtilisateurGroupeTravailApiApiUtilisateurgroupetravailGetCollection
     */
    readonly groupetravail2?: Array<string>

    /**
     * 
     * @type {string}
     * @memberof JointureUtilisateurGroupeTravailApiApiUtilisateurgroupetravailGetCollection
     */
    readonly user?: string

    /**
     * 
     * @type {Array<string>}
     * @memberof JointureUtilisateurGroupeTravailApiApiUtilisateurgroupetravailGetCollection
     */
    readonly user2?: Array<string>

    /**
     * Active or deleted/ended status of inscription
     * @type {boolean}
     * @memberof JointureUtilisateurGroupeTravailApiApiUtilisateurgroupetravailGetCollection
     */
    readonly historicInscription?: boolean
}

/**
 * Request parameters for apiUtilisateurgroupetravailIdGet operation in JointureUtilisateurGroupeTravailApi.
 * @export
 * @interface JointureUtilisateurGroupeTravailApiApiUtilisateurgroupetravailIdGetRequest
 */
export interface JointureUtilisateurGroupeTravailApiApiUtilisateurgroupetravailIdGetRequest {
    /**
     * Jointure Utilisateur / Groupe Travail identifier
     * @type {string}
     * @memberof JointureUtilisateurGroupeTravailApiApiUtilisateurgroupetravailIdGet
     */
    readonly id: string
}

/**
 * JointureUtilisateurGroupeTravailApi - object-oriented interface
 * @export
 * @class JointureUtilisateurGroupeTravailApi
 * @extends {BaseAPI}
 */
export class JointureUtilisateurGroupeTravailApi extends BaseAPI {
    /**
     * Returns all relations between users and workgroups
     * @summary Returns all relations between users and workgroups
     * @param {JointureUtilisateurGroupeTravailApiApiUtilisateurgroupetravailGetCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JointureUtilisateurGroupeTravailApi
     */
    public apiUtilisateurgroupetravailGetCollection(requestParameters: JointureUtilisateurGroupeTravailApiApiUtilisateurgroupetravailGetCollectionRequest = {}, options?: RawAxiosRequestConfig) {
        return JointureUtilisateurGroupeTravailApiFp(this.configuration).apiUtilisateurgroupetravailGetCollection(requestParameters.page, requestParameters.itemsPerPage, requestParameters.groupetravail, requestParameters.groupetravail2, requestParameters.user, requestParameters.user2, requestParameters.historicInscription, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a Jointure Utilisateur / Groupe Travail resource.
     * @summary Retrieves a Jointure Utilisateur / Groupe Travail resource.
     * @param {JointureUtilisateurGroupeTravailApiApiUtilisateurgroupetravailIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JointureUtilisateurGroupeTravailApi
     */
    public apiUtilisateurgroupetravailIdGet(requestParameters: JointureUtilisateurGroupeTravailApiApiUtilisateurgroupetravailIdGetRequest, options?: RawAxiosRequestConfig) {
        return JointureUtilisateurGroupeTravailApiFp(this.configuration).apiUtilisateurgroupetravailIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * JournauxApi - axios parameter creator
 * @export
 */
export const JournauxApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns all resources from Tbl_Utilisateur_Journaux
         * @summary Returns all resources from Tbl_Utilisateur_Journaux
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {boolean} [pagination] Enable or disable pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiJournauxGetCollection: async (page?: number, itemsPerPage?: number, pagination?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/utilisateur/journaux`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }

            if (pagination !== undefined) {
                localVarQueryParameter['pagination'] = pagination;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * JournauxApi - functional programming interface
 * @export
 */
export const JournauxApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = JournauxApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns all resources from Tbl_Utilisateur_Journaux
         * @summary Returns all resources from Tbl_Utilisateur_Journaux
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {boolean} [pagination] Enable or disable pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiJournauxGetCollection(page?: number, itemsPerPage?: number, pagination?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiJournauxGetCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiJournauxGetCollection(page, itemsPerPage, pagination, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JournauxApi.apiJournauxGetCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * JournauxApi - factory interface
 * @export
 */
export const JournauxApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = JournauxApiFp(configuration)
    return {
        /**
         * Returns all resources from Tbl_Utilisateur_Journaux
         * @summary Returns all resources from Tbl_Utilisateur_Journaux
         * @param {JournauxApiApiJournauxGetCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiJournauxGetCollection(requestParameters: JournauxApiApiJournauxGetCollectionRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ApiJournauxGetCollection200Response> {
            return localVarFp.apiJournauxGetCollection(requestParameters.page, requestParameters.itemsPerPage, requestParameters.pagination, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiJournauxGetCollection operation in JournauxApi.
 * @export
 * @interface JournauxApiApiJournauxGetCollectionRequest
 */
export interface JournauxApiApiJournauxGetCollectionRequest {
    /**
     * The collection page number
     * @type {number}
     * @memberof JournauxApiApiJournauxGetCollection
     */
    readonly page?: number

    /**
     * The number of items per page
     * @type {number}
     * @memberof JournauxApiApiJournauxGetCollection
     */
    readonly itemsPerPage?: number

    /**
     * Enable or disable pagination
     * @type {boolean}
     * @memberof JournauxApiApiJournauxGetCollection
     */
    readonly pagination?: boolean
}

/**
 * JournauxApi - object-oriented interface
 * @export
 * @class JournauxApi
 * @extends {BaseAPI}
 */
export class JournauxApi extends BaseAPI {
    /**
     * Returns all resources from Tbl_Utilisateur_Journaux
     * @summary Returns all resources from Tbl_Utilisateur_Journaux
     * @param {JournauxApiApiJournauxGetCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JournauxApi
     */
    public apiJournauxGetCollection(requestParameters: JournauxApiApiJournauxGetCollectionRequest = {}, options?: RawAxiosRequestConfig) {
        return JournauxApiFp(this.configuration).apiJournauxGetCollection(requestParameters.page, requestParameters.itemsPerPage, requestParameters.pagination, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MarquesApi - axios parameter creator
 * @export
 */
export const MarquesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns the society\'s brands list.
         * @summary Returns the society\'s brands list.
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {boolean} [flagDelete] 
         * @param {ApiMarquesGetCollectionOrderLibelleEnum} [orderLibelle] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMarquesGetCollection: async (page?: number, itemsPerPage?: number, flagDelete?: boolean, orderLibelle?: ApiMarquesGetCollectionOrderLibelleEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/utilisateur/marques`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }

            if (flagDelete !== undefined) {
                localVarQueryParameter['flagDelete'] = flagDelete;
            }

            if (orderLibelle !== undefined) {
                localVarQueryParameter['order[libelle]'] = orderLibelle;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MarquesApi - functional programming interface
 * @export
 */
export const MarquesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MarquesApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns the society\'s brands list.
         * @summary Returns the society\'s brands list.
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {boolean} [flagDelete] 
         * @param {ApiMarquesGetCollectionOrderLibelleEnum} [orderLibelle] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMarquesGetCollection(page?: number, itemsPerPage?: number, flagDelete?: boolean, orderLibelle?: ApiMarquesGetCollectionOrderLibelleEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiMarquesGetCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMarquesGetCollection(page, itemsPerPage, flagDelete, orderLibelle, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MarquesApi.apiMarquesGetCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MarquesApi - factory interface
 * @export
 */
export const MarquesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MarquesApiFp(configuration)
    return {
        /**
         * Returns the society\'s brands list.
         * @summary Returns the society\'s brands list.
         * @param {MarquesApiApiMarquesGetCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMarquesGetCollection(requestParameters: MarquesApiApiMarquesGetCollectionRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ApiMarquesGetCollection200Response> {
            return localVarFp.apiMarquesGetCollection(requestParameters.page, requestParameters.itemsPerPage, requestParameters.flagDelete, requestParameters.orderLibelle, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiMarquesGetCollection operation in MarquesApi.
 * @export
 * @interface MarquesApiApiMarquesGetCollectionRequest
 */
export interface MarquesApiApiMarquesGetCollectionRequest {
    /**
     * The collection page number
     * @type {number}
     * @memberof MarquesApiApiMarquesGetCollection
     */
    readonly page?: number

    /**
     * The number of items per page
     * @type {number}
     * @memberof MarquesApiApiMarquesGetCollection
     */
    readonly itemsPerPage?: number

    /**
     * 
     * @type {boolean}
     * @memberof MarquesApiApiMarquesGetCollection
     */
    readonly flagDelete?: boolean

    /**
     * 
     * @type {'asc' | 'desc'}
     * @memberof MarquesApiApiMarquesGetCollection
     */
    readonly orderLibelle?: ApiMarquesGetCollectionOrderLibelleEnum
}

/**
 * MarquesApi - object-oriented interface
 * @export
 * @class MarquesApi
 * @extends {BaseAPI}
 */
export class MarquesApi extends BaseAPI {
    /**
     * Returns the society\'s brands list.
     * @summary Returns the society\'s brands list.
     * @param {MarquesApiApiMarquesGetCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarquesApi
     */
    public apiMarquesGetCollection(requestParameters: MarquesApiApiMarquesGetCollectionRequest = {}, options?: RawAxiosRequestConfig) {
        return MarquesApiFp(this.configuration).apiMarquesGetCollection(requestParameters.page, requestParameters.itemsPerPage, requestParameters.flagDelete, requestParameters.orderLibelle, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ApiMarquesGetCollectionOrderLibelleEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type ApiMarquesGetCollectionOrderLibelleEnum = typeof ApiMarquesGetCollectionOrderLibelleEnum[keyof typeof ApiMarquesGetCollectionOrderLibelleEnum];


/**
 * PolesApi - axios parameter creator
 * @export
 */
export const PolesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns the TBL poles collection.
         * @summary Returns the TBL poles collection.
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {ApiPolesGetCollectionOrderLibelleEnum} [orderLibelle] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPolesGetCollection: async (page?: number, itemsPerPage?: number, orderLibelle?: ApiPolesGetCollectionOrderLibelleEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/utilisateur/poles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }

            if (orderLibelle !== undefined) {
                localVarQueryParameter['order[libelle]'] = orderLibelle;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PolesApi - functional programming interface
 * @export
 */
export const PolesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PolesApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns the TBL poles collection.
         * @summary Returns the TBL poles collection.
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {ApiPolesGetCollectionOrderLibelleEnum} [orderLibelle] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPolesGetCollection(page?: number, itemsPerPage?: number, orderLibelle?: ApiPolesGetCollectionOrderLibelleEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiPolesGetCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPolesGetCollection(page, itemsPerPage, orderLibelle, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PolesApi.apiPolesGetCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PolesApi - factory interface
 * @export
 */
export const PolesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PolesApiFp(configuration)
    return {
        /**
         * Returns the TBL poles collection.
         * @summary Returns the TBL poles collection.
         * @param {PolesApiApiPolesGetCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPolesGetCollection(requestParameters: PolesApiApiPolesGetCollectionRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ApiPolesGetCollection200Response> {
            return localVarFp.apiPolesGetCollection(requestParameters.page, requestParameters.itemsPerPage, requestParameters.orderLibelle, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiPolesGetCollection operation in PolesApi.
 * @export
 * @interface PolesApiApiPolesGetCollectionRequest
 */
export interface PolesApiApiPolesGetCollectionRequest {
    /**
     * The collection page number
     * @type {number}
     * @memberof PolesApiApiPolesGetCollection
     */
    readonly page?: number

    /**
     * The number of items per page
     * @type {number}
     * @memberof PolesApiApiPolesGetCollection
     */
    readonly itemsPerPage?: number

    /**
     * 
     * @type {'asc' | 'desc'}
     * @memberof PolesApiApiPolesGetCollection
     */
    readonly orderLibelle?: ApiPolesGetCollectionOrderLibelleEnum
}

/**
 * PolesApi - object-oriented interface
 * @export
 * @class PolesApi
 * @extends {BaseAPI}
 */
export class PolesApi extends BaseAPI {
    /**
     * Returns the TBL poles collection.
     * @summary Returns the TBL poles collection.
     * @param {PolesApiApiPolesGetCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolesApi
     */
    public apiPolesGetCollection(requestParameters: PolesApiApiPolesGetCollectionRequest = {}, options?: RawAxiosRequestConfig) {
        return PolesApiFp(this.configuration).apiPolesGetCollection(requestParameters.page, requestParameters.itemsPerPage, requestParameters.orderLibelle, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ApiPolesGetCollectionOrderLibelleEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type ApiPolesGetCollectionOrderLibelleEnum = typeof ApiPolesGetCollectionOrderLibelleEnum[keyof typeof ApiPolesGetCollectionOrderLibelleEnum];


/**
 * ServicesApi - axios parameter creator
 * @export
 */
export const ServicesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns all resources from Tbl_Def_Service
         * @summary Returns all resources from Tbl_Def_Service
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {boolean} [pagination] Enable or disable pagination
         * @param {boolean} [assignable] dsv_id 0 and 999 filter
         * @param {ApiServicesGetCollectionOrderLibelleEnum} [orderLibelle] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiServicesGetCollection: async (page?: number, itemsPerPage?: number, pagination?: boolean, assignable?: boolean, orderLibelle?: ApiServicesGetCollectionOrderLibelleEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/utilisateur/services`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }

            if (pagination !== undefined) {
                localVarQueryParameter['pagination'] = pagination;
            }

            if (assignable !== undefined) {
                localVarQueryParameter['assignable'] = assignable;
            }

            if (orderLibelle !== undefined) {
                localVarQueryParameter['order[libelle]'] = orderLibelle;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ServicesApi - functional programming interface
 * @export
 */
export const ServicesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ServicesApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns all resources from Tbl_Def_Service
         * @summary Returns all resources from Tbl_Def_Service
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {boolean} [pagination] Enable or disable pagination
         * @param {boolean} [assignable] dsv_id 0 and 999 filter
         * @param {ApiServicesGetCollectionOrderLibelleEnum} [orderLibelle] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiServicesGetCollection(page?: number, itemsPerPage?: number, pagination?: boolean, assignable?: boolean, orderLibelle?: ApiServicesGetCollectionOrderLibelleEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiServicesGetCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiServicesGetCollection(page, itemsPerPage, pagination, assignable, orderLibelle, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServicesApi.apiServicesGetCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ServicesApi - factory interface
 * @export
 */
export const ServicesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ServicesApiFp(configuration)
    return {
        /**
         * Returns all resources from Tbl_Def_Service
         * @summary Returns all resources from Tbl_Def_Service
         * @param {ServicesApiApiServicesGetCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiServicesGetCollection(requestParameters: ServicesApiApiServicesGetCollectionRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ApiServicesGetCollection200Response> {
            return localVarFp.apiServicesGetCollection(requestParameters.page, requestParameters.itemsPerPage, requestParameters.pagination, requestParameters.assignable, requestParameters.orderLibelle, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiServicesGetCollection operation in ServicesApi.
 * @export
 * @interface ServicesApiApiServicesGetCollectionRequest
 */
export interface ServicesApiApiServicesGetCollectionRequest {
    /**
     * The collection page number
     * @type {number}
     * @memberof ServicesApiApiServicesGetCollection
     */
    readonly page?: number

    /**
     * The number of items per page
     * @type {number}
     * @memberof ServicesApiApiServicesGetCollection
     */
    readonly itemsPerPage?: number

    /**
     * Enable or disable pagination
     * @type {boolean}
     * @memberof ServicesApiApiServicesGetCollection
     */
    readonly pagination?: boolean

    /**
     * dsv_id 0 and 999 filter
     * @type {boolean}
     * @memberof ServicesApiApiServicesGetCollection
     */
    readonly assignable?: boolean

    /**
     * 
     * @type {'asc' | 'desc'}
     * @memberof ServicesApiApiServicesGetCollection
     */
    readonly orderLibelle?: ApiServicesGetCollectionOrderLibelleEnum
}

/**
 * ServicesApi - object-oriented interface
 * @export
 * @class ServicesApi
 * @extends {BaseAPI}
 */
export class ServicesApi extends BaseAPI {
    /**
     * Returns all resources from Tbl_Def_Service
     * @summary Returns all resources from Tbl_Def_Service
     * @param {ServicesApiApiServicesGetCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServicesApi
     */
    public apiServicesGetCollection(requestParameters: ServicesApiApiServicesGetCollectionRequest = {}, options?: RawAxiosRequestConfig) {
        return ServicesApiFp(this.configuration).apiServicesGetCollection(requestParameters.page, requestParameters.itemsPerPage, requestParameters.pagination, requestParameters.assignable, requestParameters.orderLibelle, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ApiServicesGetCollectionOrderLibelleEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type ApiServicesGetCollectionOrderLibelleEnum = typeof ApiServicesGetCollectionOrderLibelleEnum[keyof typeof ApiServicesGetCollectionOrderLibelleEnum];


/**
 * UserApi - axios parameter creator
 * @export
 */
export const UserApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Updates the User resource.
         * @summary Updates the User resource.
         * @param {string} id User identifier
         * @param {UserUpdateUser} userUpdateUser The updated User resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiKeycloakUtilisateurIdPatch: async (id: string, userUpdateUser: UserUpdateUser, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiKeycloakUtilisateurIdPatch', 'id', id)
            // verify required parameter 'userUpdateUser' is not null or undefined
            assertParamExists('apiKeycloakUtilisateurIdPatch', 'userUpdateUser', userUpdateUser)
            const localVarPath = `/utilisateur/keycloak-utilisateur/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/merge-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userUpdateUser, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a User resource.
         * @summary Creates a User resource.
         * @param {UserCreateUserJsonld} userCreateUserJsonld The new User resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiKeycloakUtilisateurPost: async (userCreateUserJsonld: UserCreateUserJsonld, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userCreateUserJsonld' is not null or undefined
            assertParamExists('apiKeycloakUtilisateurPost', 'userCreateUserJsonld', userCreateUserJsonld)
            const localVarPath = `/utilisateur/keycloak-utilisateur`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userCreateUserJsonld, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a User resource.
         * @summary Retrieves a User resource.
         * @param {string} id User identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiKeycloakUtilisateursIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiKeycloakUtilisateursIdGet', 'id', id)
            const localVarPath = `/utilisateur/keycloak-utilisateurs/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a User resource.
         * @summary Retrieves a User resource.
         * @param {string} id User identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiKeycloakUtilisateursIdidentityGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiKeycloakUtilisateursIdidentityGet', 'id', id)
            const localVarPath = `/utilisateur/keycloak-utilisateurs/{id}/identity`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the synchronizable users collection
         * @summary Returns the synchronizable users collection
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiKeycloakUtilisateurssynchronizableGetCollection: async (page?: number, itemsPerPage?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/utilisateur/keycloak-utilisateurs/synchronizable`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserApi - functional programming interface
 * @export
 */
export const UserApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserApiAxiosParamCreator(configuration)
    return {
        /**
         * Updates the User resource.
         * @summary Updates the User resource.
         * @param {string} id User identifier
         * @param {UserUpdateUser} userUpdateUser The updated User resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiKeycloakUtilisateurIdPatch(id: string, userUpdateUser: UserUpdateUser, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserJsonld>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiKeycloakUtilisateurIdPatch(id, userUpdateUser, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.apiKeycloakUtilisateurIdPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates a User resource.
         * @summary Creates a User resource.
         * @param {UserCreateUserJsonld} userCreateUserJsonld The new User resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiKeycloakUtilisateurPost(userCreateUserJsonld: UserCreateUserJsonld, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserJsonld>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiKeycloakUtilisateurPost(userCreateUserJsonld, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.apiKeycloakUtilisateurPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves a User resource.
         * @summary Retrieves a User resource.
         * @param {string} id User identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiKeycloakUtilisateursIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserJsonld>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiKeycloakUtilisateursIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.apiKeycloakUtilisateursIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves a User resource.
         * @summary Retrieves a User resource.
         * @param {string} id User identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiKeycloakUtilisateursIdidentityGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserJsonldUserRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiKeycloakUtilisateursIdidentityGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.apiKeycloakUtilisateursIdidentityGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns the synchronizable users collection
         * @summary Returns the synchronizable users collection
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiKeycloakUtilisateurssynchronizableGetCollection(page?: number, itemsPerPage?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiKeycloakUtilisateurssynchronizableGetCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiKeycloakUtilisateurssynchronizableGetCollection(page, itemsPerPage, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.apiKeycloakUtilisateurssynchronizableGetCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UserApi - factory interface
 * @export
 */
export const UserApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserApiFp(configuration)
    return {
        /**
         * Updates the User resource.
         * @summary Updates the User resource.
         * @param {UserApiApiKeycloakUtilisateurIdPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiKeycloakUtilisateurIdPatch(requestParameters: UserApiApiKeycloakUtilisateurIdPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserJsonld> {
            return localVarFp.apiKeycloakUtilisateurIdPatch(requestParameters.id, requestParameters.userUpdateUser, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a User resource.
         * @summary Creates a User resource.
         * @param {UserApiApiKeycloakUtilisateurPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiKeycloakUtilisateurPost(requestParameters: UserApiApiKeycloakUtilisateurPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserJsonld> {
            return localVarFp.apiKeycloakUtilisateurPost(requestParameters.userCreateUserJsonld, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a User resource.
         * @summary Retrieves a User resource.
         * @param {UserApiApiKeycloakUtilisateursIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiKeycloakUtilisateursIdGet(requestParameters: UserApiApiKeycloakUtilisateursIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserJsonld> {
            return localVarFp.apiKeycloakUtilisateursIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a User resource.
         * @summary Retrieves a User resource.
         * @param {UserApiApiKeycloakUtilisateursIdidentityGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiKeycloakUtilisateursIdidentityGet(requestParameters: UserApiApiKeycloakUtilisateursIdidentityGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserJsonldUserRead> {
            return localVarFp.apiKeycloakUtilisateursIdidentityGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the synchronizable users collection
         * @summary Returns the synchronizable users collection
         * @param {UserApiApiKeycloakUtilisateurssynchronizableGetCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiKeycloakUtilisateurssynchronizableGetCollection(requestParameters: UserApiApiKeycloakUtilisateurssynchronizableGetCollectionRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ApiKeycloakUtilisateurssynchronizableGetCollection200Response> {
            return localVarFp.apiKeycloakUtilisateurssynchronizableGetCollection(requestParameters.page, requestParameters.itemsPerPage, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiKeycloakUtilisateurIdPatch operation in UserApi.
 * @export
 * @interface UserApiApiKeycloakUtilisateurIdPatchRequest
 */
export interface UserApiApiKeycloakUtilisateurIdPatchRequest {
    /**
     * User identifier
     * @type {string}
     * @memberof UserApiApiKeycloakUtilisateurIdPatch
     */
    readonly id: string

    /**
     * The updated User resource
     * @type {UserUpdateUser}
     * @memberof UserApiApiKeycloakUtilisateurIdPatch
     */
    readonly userUpdateUser: UserUpdateUser
}

/**
 * Request parameters for apiKeycloakUtilisateurPost operation in UserApi.
 * @export
 * @interface UserApiApiKeycloakUtilisateurPostRequest
 */
export interface UserApiApiKeycloakUtilisateurPostRequest {
    /**
     * The new User resource
     * @type {UserCreateUserJsonld}
     * @memberof UserApiApiKeycloakUtilisateurPost
     */
    readonly userCreateUserJsonld: UserCreateUserJsonld
}

/**
 * Request parameters for apiKeycloakUtilisateursIdGet operation in UserApi.
 * @export
 * @interface UserApiApiKeycloakUtilisateursIdGetRequest
 */
export interface UserApiApiKeycloakUtilisateursIdGetRequest {
    /**
     * User identifier
     * @type {string}
     * @memberof UserApiApiKeycloakUtilisateursIdGet
     */
    readonly id: string
}

/**
 * Request parameters for apiKeycloakUtilisateursIdidentityGet operation in UserApi.
 * @export
 * @interface UserApiApiKeycloakUtilisateursIdidentityGetRequest
 */
export interface UserApiApiKeycloakUtilisateursIdidentityGetRequest {
    /**
     * User identifier
     * @type {string}
     * @memberof UserApiApiKeycloakUtilisateursIdidentityGet
     */
    readonly id: string
}

/**
 * Request parameters for apiKeycloakUtilisateurssynchronizableGetCollection operation in UserApi.
 * @export
 * @interface UserApiApiKeycloakUtilisateurssynchronizableGetCollectionRequest
 */
export interface UserApiApiKeycloakUtilisateurssynchronizableGetCollectionRequest {
    /**
     * The collection page number
     * @type {number}
     * @memberof UserApiApiKeycloakUtilisateurssynchronizableGetCollection
     */
    readonly page?: number

    /**
     * The number of items per page
     * @type {number}
     * @memberof UserApiApiKeycloakUtilisateurssynchronizableGetCollection
     */
    readonly itemsPerPage?: number
}

/**
 * UserApi - object-oriented interface
 * @export
 * @class UserApi
 * @extends {BaseAPI}
 */
export class UserApi extends BaseAPI {
    /**
     * Updates the User resource.
     * @summary Updates the User resource.
     * @param {UserApiApiKeycloakUtilisateurIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public apiKeycloakUtilisateurIdPatch(requestParameters: UserApiApiKeycloakUtilisateurIdPatchRequest, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).apiKeycloakUtilisateurIdPatch(requestParameters.id, requestParameters.userUpdateUser, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a User resource.
     * @summary Creates a User resource.
     * @param {UserApiApiKeycloakUtilisateurPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public apiKeycloakUtilisateurPost(requestParameters: UserApiApiKeycloakUtilisateurPostRequest, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).apiKeycloakUtilisateurPost(requestParameters.userCreateUserJsonld, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a User resource.
     * @summary Retrieves a User resource.
     * @param {UserApiApiKeycloakUtilisateursIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public apiKeycloakUtilisateursIdGet(requestParameters: UserApiApiKeycloakUtilisateursIdGetRequest, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).apiKeycloakUtilisateursIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a User resource.
     * @summary Retrieves a User resource.
     * @param {UserApiApiKeycloakUtilisateursIdidentityGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public apiKeycloakUtilisateursIdidentityGet(requestParameters: UserApiApiKeycloakUtilisateursIdidentityGetRequest, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).apiKeycloakUtilisateursIdidentityGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the synchronizable users collection
     * @summary Returns the synchronizable users collection
     * @param {UserApiApiKeycloakUtilisateurssynchronizableGetCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public apiKeycloakUtilisateurssynchronizableGetCollection(requestParameters: UserApiApiKeycloakUtilisateurssynchronizableGetCollectionRequest = {}, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).apiKeycloakUtilisateurssynchronizableGetCollection(requestParameters.page, requestParameters.itemsPerPage, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UtilisateursApi - axios parameter creator
 * @export
 */
export const UtilisateursApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns the users collection
         * @summary Returns the users collection
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {boolean} [isDeleted] 
         * @param {boolean} [isFormalist] 
         * @param {boolean} [hasG3Access] 
         * @param {boolean} [hasComptaSoftware] 
         * @param {boolean} [hasAccessL2DF] 
         * @param {boolean} [isAdminApps] 
         * @param {string} [mail] 
         * @param {Array<string>} [mail2] 
         * @param {string} [user] 
         * @param {Array<string>} [user2] 
         * @param {number} [idSocieteEmployeur] 
         * @param {Array<number>} [idSocieteEmployeur2] 
         * @param {ApiUtilisateursGetCollectionOrderIdEnum} [orderId] 
         * @param {ApiUtilisateursGetCollectionOrderNomEnum} [orderNom] 
         * @param {ApiUtilisateursGetCollectionOrderUserEnum} [orderUser] 
         * @param {ApiUtilisateursGetCollectionOrderMailEnum} [orderMail] 
         * @param {ApiUtilisateursGetCollectionOrderPoleIdEnum} [orderPoleId] 
         * @param {ApiUtilisateursGetCollectionOrderIdSocieteEmployeurEnum} [orderIdSocieteEmployeur] 
         * @param {string} [multiFieldSearch] Partial search in chosen fields
         * @param {string} [libGroupeTravail] workgroup name partial filter
         * @param {boolean} [libGroupeTravailDeleteStatus] delete status workgroup filter with name partial filter
         * @param {number} [idGroupeTravail] workgroup id search filter
         * @param {boolean} [idInscriptionDeleteStatus] delete status inscription filter with workgroup id filter
         * @param {number} [iduserReferent] The manager\&#39;s ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUtilisateursGetCollection: async (page?: number, itemsPerPage?: number, isDeleted?: boolean, isFormalist?: boolean, hasG3Access?: boolean, hasComptaSoftware?: boolean, hasAccessL2DF?: boolean, isAdminApps?: boolean, mail?: string, mail2?: Array<string>, user?: string, user2?: Array<string>, idSocieteEmployeur?: number, idSocieteEmployeur2?: Array<number>, orderId?: ApiUtilisateursGetCollectionOrderIdEnum, orderNom?: ApiUtilisateursGetCollectionOrderNomEnum, orderUser?: ApiUtilisateursGetCollectionOrderUserEnum, orderMail?: ApiUtilisateursGetCollectionOrderMailEnum, orderPoleId?: ApiUtilisateursGetCollectionOrderPoleIdEnum, orderIdSocieteEmployeur?: ApiUtilisateursGetCollectionOrderIdSocieteEmployeurEnum, multiFieldSearch?: string, libGroupeTravail?: string, libGroupeTravailDeleteStatus?: boolean, idGroupeTravail?: number, idInscriptionDeleteStatus?: boolean, iduserReferent?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/utilisateur/utilisateurs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }

            if (isDeleted !== undefined) {
                localVarQueryParameter['isDeleted'] = isDeleted;
            }

            if (isFormalist !== undefined) {
                localVarQueryParameter['isFormalist'] = isFormalist;
            }

            if (hasG3Access !== undefined) {
                localVarQueryParameter['hasG3Access'] = hasG3Access;
            }

            if (hasComptaSoftware !== undefined) {
                localVarQueryParameter['hasComptaSoftware'] = hasComptaSoftware;
            }

            if (hasAccessL2DF !== undefined) {
                localVarQueryParameter['hasAccessL2DF'] = hasAccessL2DF;
            }

            if (isAdminApps !== undefined) {
                localVarQueryParameter['isAdminApps'] = isAdminApps;
            }

            if (mail !== undefined) {
                localVarQueryParameter['mail'] = mail;
            }

            if (mail2) {
                localVarQueryParameter['mail[]'] = mail2;
            }

            if (user !== undefined) {
                localVarQueryParameter['user'] = user;
            }

            if (user2) {
                localVarQueryParameter['user[]'] = user2;
            }

            if (idSocieteEmployeur !== undefined) {
                localVarQueryParameter['idSocieteEmployeur'] = idSocieteEmployeur;
            }

            if (idSocieteEmployeur2) {
                localVarQueryParameter['idSocieteEmployeur[]'] = idSocieteEmployeur2;
            }

            if (orderId !== undefined) {
                localVarQueryParameter['order[id]'] = orderId;
            }

            if (orderNom !== undefined) {
                localVarQueryParameter['order[nom]'] = orderNom;
            }

            if (orderUser !== undefined) {
                localVarQueryParameter['order[user]'] = orderUser;
            }

            if (orderMail !== undefined) {
                localVarQueryParameter['order[mail]'] = orderMail;
            }

            if (orderPoleId !== undefined) {
                localVarQueryParameter['order[pole.id]'] = orderPoleId;
            }

            if (orderIdSocieteEmployeur !== undefined) {
                localVarQueryParameter['order[idSocieteEmployeur]'] = orderIdSocieteEmployeur;
            }

            if (multiFieldSearch !== undefined) {
                localVarQueryParameter['MultiFieldSearch'] = multiFieldSearch;
            }

            if (libGroupeTravail !== undefined) {
                localVarQueryParameter['libGroupeTravail'] = libGroupeTravail;
            }

            if (libGroupeTravailDeleteStatus !== undefined) {
                localVarQueryParameter['libGroupeTravailDeleteStatus'] = libGroupeTravailDeleteStatus;
            }

            if (idGroupeTravail !== undefined) {
                localVarQueryParameter['idGroupeTravail'] = idGroupeTravail;
            }

            if (idInscriptionDeleteStatus !== undefined) {
                localVarQueryParameter['idInscriptionDeleteStatus'] = idInscriptionDeleteStatus;
            }

            if (iduserReferent !== undefined) {
                localVarQueryParameter['iduserReferent'] = iduserReferent;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete the user
         * @summary Delete the user
         * @param {string} id Utilisateurs identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUtilisateursIdDelete: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiUtilisateursIdDelete', 'id', id)
            const localVarPath = `/utilisateur/utilisateurs/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the selected user informations
         * @summary Returns the selected user informations
         * @param {string} id Utilisateurs identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUtilisateursIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiUtilisateursIdGet', 'id', id)
            const localVarPath = `/utilisateur/utilisateurs/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates only the selected informations of the current user
         * @summary Updates only the selected informations of the current user
         * @param {string} id Utilisateurs identifier
         * @param {UtilisateursUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur} utilisateursUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur The updated Utilisateurs resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUtilisateursIdPatch: async (id: string, utilisateursUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur: UtilisateursUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiUtilisateursIdPatch', 'id', id)
            // verify required parameter 'utilisateursUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur' is not null or undefined
            assertParamExists('apiUtilisateursIdPatch', 'utilisateursUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur', utilisateursUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur)
            const localVarPath = `/utilisateur/utilisateurs/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/merge-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(utilisateursUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates the selected user informations
         * @summary Updates the selected user informations
         * @param {string} id Utilisateurs identifier
         * @param {UtilisateursJsonldUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur} utilisateursJsonldUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur The updated Utilisateurs resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUtilisateursIdPut: async (id: string, utilisateursJsonldUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur: UtilisateursJsonldUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiUtilisateursIdPut', 'id', id)
            // verify required parameter 'utilisateursJsonldUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur' is not null or undefined
            assertParamExists('apiUtilisateursIdPut', 'utilisateursJsonldUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur', utilisateursJsonldUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur)
            const localVarPath = `/utilisateur/utilisateurs/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(utilisateursJsonldUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deactivate the user synchronization with keycloak
         * @summary Deactivate the user synchronization with keycloak
         * @param {string} id Utilisateurs identifier
         * @param {UtilisateursUtilisateurSyncUtilisateur} utilisateursUtilisateurSyncUtilisateur The updated Utilisateurs resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUtilisateursIddisableSyncPatch: async (id: string, utilisateursUtilisateurSyncUtilisateur: UtilisateursUtilisateurSyncUtilisateur, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiUtilisateursIddisableSyncPatch', 'id', id)
            // verify required parameter 'utilisateursUtilisateurSyncUtilisateur' is not null or undefined
            assertParamExists('apiUtilisateursIddisableSyncPatch', 'utilisateursUtilisateurSyncUtilisateur', utilisateursUtilisateurSyncUtilisateur)
            const localVarPath = `/utilisateur/utilisateurs/{id}/disable-sync`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/merge-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(utilisateursUtilisateurSyncUtilisateur, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Synchronize the user with his keycloak account
         * @summary Synchronize the user with his keycloak account
         * @param {string} id Utilisateurs identifier
         * @param {UtilisateursUtilisateurSyncUtilisateur} utilisateursUtilisateurSyncUtilisateur The updated Utilisateurs resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUtilisateursIdsyncPatch: async (id: string, utilisateursUtilisateurSyncUtilisateur: UtilisateursUtilisateurSyncUtilisateur, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiUtilisateursIdsyncPatch', 'id', id)
            // verify required parameter 'utilisateursUtilisateurSyncUtilisateur' is not null or undefined
            assertParamExists('apiUtilisateursIdsyncPatch', 'utilisateursUtilisateurSyncUtilisateur', utilisateursUtilisateurSyncUtilisateur)
            const localVarPath = `/utilisateur/utilisateurs/{id}/sync`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/merge-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(utilisateursUtilisateurSyncUtilisateur, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a user
         * @summary Create a user
         * @param {UtilisateursJsonldUtilisateurWrite} utilisateursJsonldUtilisateurWrite The new Utilisateurs resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUtilisateursPost: async (utilisateursJsonldUtilisateurWrite: UtilisateursJsonldUtilisateurWrite, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'utilisateursJsonldUtilisateurWrite' is not null or undefined
            assertParamExists('apiUtilisateursPost', 'utilisateursJsonldUtilisateurWrite', utilisateursJsonldUtilisateurWrite)
            const localVarPath = `/utilisateur/utilisateurs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(utilisateursJsonldUtilisateurWrite, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UtilisateursApi - functional programming interface
 * @export
 */
export const UtilisateursApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UtilisateursApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns the users collection
         * @summary Returns the users collection
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {boolean} [isDeleted] 
         * @param {boolean} [isFormalist] 
         * @param {boolean} [hasG3Access] 
         * @param {boolean} [hasComptaSoftware] 
         * @param {boolean} [hasAccessL2DF] 
         * @param {boolean} [isAdminApps] 
         * @param {string} [mail] 
         * @param {Array<string>} [mail2] 
         * @param {string} [user] 
         * @param {Array<string>} [user2] 
         * @param {number} [idSocieteEmployeur] 
         * @param {Array<number>} [idSocieteEmployeur2] 
         * @param {ApiUtilisateursGetCollectionOrderIdEnum} [orderId] 
         * @param {ApiUtilisateursGetCollectionOrderNomEnum} [orderNom] 
         * @param {ApiUtilisateursGetCollectionOrderUserEnum} [orderUser] 
         * @param {ApiUtilisateursGetCollectionOrderMailEnum} [orderMail] 
         * @param {ApiUtilisateursGetCollectionOrderPoleIdEnum} [orderPoleId] 
         * @param {ApiUtilisateursGetCollectionOrderIdSocieteEmployeurEnum} [orderIdSocieteEmployeur] 
         * @param {string} [multiFieldSearch] Partial search in chosen fields
         * @param {string} [libGroupeTravail] workgroup name partial filter
         * @param {boolean} [libGroupeTravailDeleteStatus] delete status workgroup filter with name partial filter
         * @param {number} [idGroupeTravail] workgroup id search filter
         * @param {boolean} [idInscriptionDeleteStatus] delete status inscription filter with workgroup id filter
         * @param {number} [iduserReferent] The manager\&#39;s ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUtilisateursGetCollection(page?: number, itemsPerPage?: number, isDeleted?: boolean, isFormalist?: boolean, hasG3Access?: boolean, hasComptaSoftware?: boolean, hasAccessL2DF?: boolean, isAdminApps?: boolean, mail?: string, mail2?: Array<string>, user?: string, user2?: Array<string>, idSocieteEmployeur?: number, idSocieteEmployeur2?: Array<number>, orderId?: ApiUtilisateursGetCollectionOrderIdEnum, orderNom?: ApiUtilisateursGetCollectionOrderNomEnum, orderUser?: ApiUtilisateursGetCollectionOrderUserEnum, orderMail?: ApiUtilisateursGetCollectionOrderMailEnum, orderPoleId?: ApiUtilisateursGetCollectionOrderPoleIdEnum, orderIdSocieteEmployeur?: ApiUtilisateursGetCollectionOrderIdSocieteEmployeurEnum, multiFieldSearch?: string, libGroupeTravail?: string, libGroupeTravailDeleteStatus?: boolean, idGroupeTravail?: number, idInscriptionDeleteStatus?: boolean, iduserReferent?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiUtilisateursGetCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUtilisateursGetCollection(page, itemsPerPage, isDeleted, isFormalist, hasG3Access, hasComptaSoftware, hasAccessL2DF, isAdminApps, mail, mail2, user, user2, idSocieteEmployeur, idSocieteEmployeur2, orderId, orderNom, orderUser, orderMail, orderPoleId, orderIdSocieteEmployeur, multiFieldSearch, libGroupeTravail, libGroupeTravailDeleteStatus, idGroupeTravail, idInscriptionDeleteStatus, iduserReferent, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UtilisateursApi.apiUtilisateursGetCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete the user
         * @summary Delete the user
         * @param {string} id Utilisateurs identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUtilisateursIdDelete(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUtilisateursIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UtilisateursApi.apiUtilisateursIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns the selected user informations
         * @summary Returns the selected user informations
         * @param {string} id Utilisateurs identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUtilisateursIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UtilisateursJsonldUtilisateurRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUtilisateursIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UtilisateursApi.apiUtilisateursIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates only the selected informations of the current user
         * @summary Updates only the selected informations of the current user
         * @param {string} id Utilisateurs identifier
         * @param {UtilisateursUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur} utilisateursUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur The updated Utilisateurs resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUtilisateursIdPatch(id: string, utilisateursUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur: UtilisateursUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UtilisateursJsonldUtilisateurPatchUtilisateur>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUtilisateursIdPatch(id, utilisateursUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UtilisateursApi.apiUtilisateursIdPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates the selected user informations
         * @summary Updates the selected user informations
         * @param {string} id Utilisateurs identifier
         * @param {UtilisateursJsonldUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur} utilisateursJsonldUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur The updated Utilisateurs resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUtilisateursIdPut(id: string, utilisateursJsonldUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur: UtilisateursJsonldUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UtilisateursJsonldUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUtilisateursIdPut(id, utilisateursJsonldUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UtilisateursApi.apiUtilisateursIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Deactivate the user synchronization with keycloak
         * @summary Deactivate the user synchronization with keycloak
         * @param {string} id Utilisateurs identifier
         * @param {UtilisateursUtilisateurSyncUtilisateur} utilisateursUtilisateurSyncUtilisateur The updated Utilisateurs resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUtilisateursIddisableSyncPatch(id: string, utilisateursUtilisateurSyncUtilisateur: UtilisateursUtilisateurSyncUtilisateur, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UtilisateursJsonldUtilisateurRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUtilisateursIddisableSyncPatch(id, utilisateursUtilisateurSyncUtilisateur, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UtilisateursApi.apiUtilisateursIddisableSyncPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Synchronize the user with his keycloak account
         * @summary Synchronize the user with his keycloak account
         * @param {string} id Utilisateurs identifier
         * @param {UtilisateursUtilisateurSyncUtilisateur} utilisateursUtilisateurSyncUtilisateur The updated Utilisateurs resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUtilisateursIdsyncPatch(id: string, utilisateursUtilisateurSyncUtilisateur: UtilisateursUtilisateurSyncUtilisateur, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UtilisateursJsonldUtilisateurRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUtilisateursIdsyncPatch(id, utilisateursUtilisateurSyncUtilisateur, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UtilisateursApi.apiUtilisateursIdsyncPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a user
         * @summary Create a user
         * @param {UtilisateursJsonldUtilisateurWrite} utilisateursJsonldUtilisateurWrite The new Utilisateurs resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUtilisateursPost(utilisateursJsonldUtilisateurWrite: UtilisateursJsonldUtilisateurWrite, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UtilisateursJsonldUtilisateurWriteUtilisateurPostUtilisateur>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUtilisateursPost(utilisateursJsonldUtilisateurWrite, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UtilisateursApi.apiUtilisateursPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UtilisateursApi - factory interface
 * @export
 */
export const UtilisateursApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UtilisateursApiFp(configuration)
    return {
        /**
         * Returns the users collection
         * @summary Returns the users collection
         * @param {UtilisateursApiApiUtilisateursGetCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUtilisateursGetCollection(requestParameters: UtilisateursApiApiUtilisateursGetCollectionRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ApiUtilisateursGetCollection200Response> {
            return localVarFp.apiUtilisateursGetCollection(requestParameters.page, requestParameters.itemsPerPage, requestParameters.isDeleted, requestParameters.isFormalist, requestParameters.hasG3Access, requestParameters.hasComptaSoftware, requestParameters.hasAccessL2DF, requestParameters.isAdminApps, requestParameters.mail, requestParameters.mail2, requestParameters.user, requestParameters.user2, requestParameters.idSocieteEmployeur, requestParameters.idSocieteEmployeur2, requestParameters.orderId, requestParameters.orderNom, requestParameters.orderUser, requestParameters.orderMail, requestParameters.orderPoleId, requestParameters.orderIdSocieteEmployeur, requestParameters.multiFieldSearch, requestParameters.libGroupeTravail, requestParameters.libGroupeTravailDeleteStatus, requestParameters.idGroupeTravail, requestParameters.idInscriptionDeleteStatus, requestParameters.iduserReferent, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete the user
         * @summary Delete the user
         * @param {UtilisateursApiApiUtilisateursIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUtilisateursIdDelete(requestParameters: UtilisateursApiApiUtilisateursIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiUtilisateursIdDelete(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the selected user informations
         * @summary Returns the selected user informations
         * @param {UtilisateursApiApiUtilisateursIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUtilisateursIdGet(requestParameters: UtilisateursApiApiUtilisateursIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<UtilisateursJsonldUtilisateurRead> {
            return localVarFp.apiUtilisateursIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates only the selected informations of the current user
         * @summary Updates only the selected informations of the current user
         * @param {UtilisateursApiApiUtilisateursIdPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUtilisateursIdPatch(requestParameters: UtilisateursApiApiUtilisateursIdPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<UtilisateursJsonldUtilisateurPatchUtilisateur> {
            return localVarFp.apiUtilisateursIdPatch(requestParameters.id, requestParameters.utilisateursUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates the selected user informations
         * @summary Updates the selected user informations
         * @param {UtilisateursApiApiUtilisateursIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUtilisateursIdPut(requestParameters: UtilisateursApiApiUtilisateursIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<UtilisateursJsonldUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur> {
            return localVarFp.apiUtilisateursIdPut(requestParameters.id, requestParameters.utilisateursJsonldUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur, options).then((request) => request(axios, basePath));
        },
        /**
         * Deactivate the user synchronization with keycloak
         * @summary Deactivate the user synchronization with keycloak
         * @param {UtilisateursApiApiUtilisateursIddisableSyncPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUtilisateursIddisableSyncPatch(requestParameters: UtilisateursApiApiUtilisateursIddisableSyncPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<UtilisateursJsonldUtilisateurRead> {
            return localVarFp.apiUtilisateursIddisableSyncPatch(requestParameters.id, requestParameters.utilisateursUtilisateurSyncUtilisateur, options).then((request) => request(axios, basePath));
        },
        /**
         * Synchronize the user with his keycloak account
         * @summary Synchronize the user with his keycloak account
         * @param {UtilisateursApiApiUtilisateursIdsyncPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUtilisateursIdsyncPatch(requestParameters: UtilisateursApiApiUtilisateursIdsyncPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<UtilisateursJsonldUtilisateurRead> {
            return localVarFp.apiUtilisateursIdsyncPatch(requestParameters.id, requestParameters.utilisateursUtilisateurSyncUtilisateur, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a user
         * @summary Create a user
         * @param {UtilisateursApiApiUtilisateursPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUtilisateursPost(requestParameters: UtilisateursApiApiUtilisateursPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<UtilisateursJsonldUtilisateurWriteUtilisateurPostUtilisateur> {
            return localVarFp.apiUtilisateursPost(requestParameters.utilisateursJsonldUtilisateurWrite, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiUtilisateursGetCollection operation in UtilisateursApi.
 * @export
 * @interface UtilisateursApiApiUtilisateursGetCollectionRequest
 */
export interface UtilisateursApiApiUtilisateursGetCollectionRequest {
    /**
     * The collection page number
     * @type {number}
     * @memberof UtilisateursApiApiUtilisateursGetCollection
     */
    readonly page?: number

    /**
     * The number of items per page
     * @type {number}
     * @memberof UtilisateursApiApiUtilisateursGetCollection
     */
    readonly itemsPerPage?: number

    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursApiApiUtilisateursGetCollection
     */
    readonly isDeleted?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursApiApiUtilisateursGetCollection
     */
    readonly isFormalist?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursApiApiUtilisateursGetCollection
     */
    readonly hasG3Access?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursApiApiUtilisateursGetCollection
     */
    readonly hasComptaSoftware?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursApiApiUtilisateursGetCollection
     */
    readonly hasAccessL2DF?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof UtilisateursApiApiUtilisateursGetCollection
     */
    readonly isAdminApps?: boolean

    /**
     * 
     * @type {string}
     * @memberof UtilisateursApiApiUtilisateursGetCollection
     */
    readonly mail?: string

    /**
     * 
     * @type {Array<string>}
     * @memberof UtilisateursApiApiUtilisateursGetCollection
     */
    readonly mail2?: Array<string>

    /**
     * 
     * @type {string}
     * @memberof UtilisateursApiApiUtilisateursGetCollection
     */
    readonly user?: string

    /**
     * 
     * @type {Array<string>}
     * @memberof UtilisateursApiApiUtilisateursGetCollection
     */
    readonly user2?: Array<string>

    /**
     * 
     * @type {number}
     * @memberof UtilisateursApiApiUtilisateursGetCollection
     */
    readonly idSocieteEmployeur?: number

    /**
     * 
     * @type {Array<number>}
     * @memberof UtilisateursApiApiUtilisateursGetCollection
     */
    readonly idSocieteEmployeur2?: Array<number>

    /**
     * 
     * @type {'asc' | 'desc'}
     * @memberof UtilisateursApiApiUtilisateursGetCollection
     */
    readonly orderId?: ApiUtilisateursGetCollectionOrderIdEnum

    /**
     * 
     * @type {'asc' | 'desc'}
     * @memberof UtilisateursApiApiUtilisateursGetCollection
     */
    readonly orderNom?: ApiUtilisateursGetCollectionOrderNomEnum

    /**
     * 
     * @type {'asc' | 'desc'}
     * @memberof UtilisateursApiApiUtilisateursGetCollection
     */
    readonly orderUser?: ApiUtilisateursGetCollectionOrderUserEnum

    /**
     * 
     * @type {'asc' | 'desc'}
     * @memberof UtilisateursApiApiUtilisateursGetCollection
     */
    readonly orderMail?: ApiUtilisateursGetCollectionOrderMailEnum

    /**
     * 
     * @type {'asc' | 'desc'}
     * @memberof UtilisateursApiApiUtilisateursGetCollection
     */
    readonly orderPoleId?: ApiUtilisateursGetCollectionOrderPoleIdEnum

    /**
     * 
     * @type {'asc' | 'desc'}
     * @memberof UtilisateursApiApiUtilisateursGetCollection
     */
    readonly orderIdSocieteEmployeur?: ApiUtilisateursGetCollectionOrderIdSocieteEmployeurEnum

    /**
     * Partial search in chosen fields
     * @type {string}
     * @memberof UtilisateursApiApiUtilisateursGetCollection
     */
    readonly multiFieldSearch?: string

    /**
     * workgroup name partial filter
     * @type {string}
     * @memberof UtilisateursApiApiUtilisateursGetCollection
     */
    readonly libGroupeTravail?: string

    /**
     * delete status workgroup filter with name partial filter
     * @type {boolean}
     * @memberof UtilisateursApiApiUtilisateursGetCollection
     */
    readonly libGroupeTravailDeleteStatus?: boolean

    /**
     * workgroup id search filter
     * @type {number}
     * @memberof UtilisateursApiApiUtilisateursGetCollection
     */
    readonly idGroupeTravail?: number

    /**
     * delete status inscription filter with workgroup id filter
     * @type {boolean}
     * @memberof UtilisateursApiApiUtilisateursGetCollection
     */
    readonly idInscriptionDeleteStatus?: boolean

    /**
     * The manager\&#39;s ID
     * @type {number}
     * @memberof UtilisateursApiApiUtilisateursGetCollection
     */
    readonly iduserReferent?: number
}

/**
 * Request parameters for apiUtilisateursIdDelete operation in UtilisateursApi.
 * @export
 * @interface UtilisateursApiApiUtilisateursIdDeleteRequest
 */
export interface UtilisateursApiApiUtilisateursIdDeleteRequest {
    /**
     * Utilisateurs identifier
     * @type {string}
     * @memberof UtilisateursApiApiUtilisateursIdDelete
     */
    readonly id: string
}

/**
 * Request parameters for apiUtilisateursIdGet operation in UtilisateursApi.
 * @export
 * @interface UtilisateursApiApiUtilisateursIdGetRequest
 */
export interface UtilisateursApiApiUtilisateursIdGetRequest {
    /**
     * Utilisateurs identifier
     * @type {string}
     * @memberof UtilisateursApiApiUtilisateursIdGet
     */
    readonly id: string
}

/**
 * Request parameters for apiUtilisateursIdPatch operation in UtilisateursApi.
 * @export
 * @interface UtilisateursApiApiUtilisateursIdPatchRequest
 */
export interface UtilisateursApiApiUtilisateursIdPatchRequest {
    /**
     * Utilisateurs identifier
     * @type {string}
     * @memberof UtilisateursApiApiUtilisateursIdPatch
     */
    readonly id: string

    /**
     * The updated Utilisateurs resource
     * @type {UtilisateursUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur}
     * @memberof UtilisateursApiApiUtilisateursIdPatch
     */
    readonly utilisateursUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur: UtilisateursUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
}

/**
 * Request parameters for apiUtilisateursIdPut operation in UtilisateursApi.
 * @export
 * @interface UtilisateursApiApiUtilisateursIdPutRequest
 */
export interface UtilisateursApiApiUtilisateursIdPutRequest {
    /**
     * Utilisateurs identifier
     * @type {string}
     * @memberof UtilisateursApiApiUtilisateursIdPut
     */
    readonly id: string

    /**
     * The updated Utilisateurs resource
     * @type {UtilisateursJsonldUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur}
     * @memberof UtilisateursApiApiUtilisateursIdPut
     */
    readonly utilisateursJsonldUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur: UtilisateursJsonldUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur
}

/**
 * Request parameters for apiUtilisateursIddisableSyncPatch operation in UtilisateursApi.
 * @export
 * @interface UtilisateursApiApiUtilisateursIddisableSyncPatchRequest
 */
export interface UtilisateursApiApiUtilisateursIddisableSyncPatchRequest {
    /**
     * Utilisateurs identifier
     * @type {string}
     * @memberof UtilisateursApiApiUtilisateursIddisableSyncPatch
     */
    readonly id: string

    /**
     * The updated Utilisateurs resource
     * @type {UtilisateursUtilisateurSyncUtilisateur}
     * @memberof UtilisateursApiApiUtilisateursIddisableSyncPatch
     */
    readonly utilisateursUtilisateurSyncUtilisateur: UtilisateursUtilisateurSyncUtilisateur
}

/**
 * Request parameters for apiUtilisateursIdsyncPatch operation in UtilisateursApi.
 * @export
 * @interface UtilisateursApiApiUtilisateursIdsyncPatchRequest
 */
export interface UtilisateursApiApiUtilisateursIdsyncPatchRequest {
    /**
     * Utilisateurs identifier
     * @type {string}
     * @memberof UtilisateursApiApiUtilisateursIdsyncPatch
     */
    readonly id: string

    /**
     * The updated Utilisateurs resource
     * @type {UtilisateursUtilisateurSyncUtilisateur}
     * @memberof UtilisateursApiApiUtilisateursIdsyncPatch
     */
    readonly utilisateursUtilisateurSyncUtilisateur: UtilisateursUtilisateurSyncUtilisateur
}

/**
 * Request parameters for apiUtilisateursPost operation in UtilisateursApi.
 * @export
 * @interface UtilisateursApiApiUtilisateursPostRequest
 */
export interface UtilisateursApiApiUtilisateursPostRequest {
    /**
     * The new Utilisateurs resource
     * @type {UtilisateursJsonldUtilisateurWrite}
     * @memberof UtilisateursApiApiUtilisateursPost
     */
    readonly utilisateursJsonldUtilisateurWrite: UtilisateursJsonldUtilisateurWrite
}

/**
 * UtilisateursApi - object-oriented interface
 * @export
 * @class UtilisateursApi
 * @extends {BaseAPI}
 */
export class UtilisateursApi extends BaseAPI {
    /**
     * Returns the users collection
     * @summary Returns the users collection
     * @param {UtilisateursApiApiUtilisateursGetCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilisateursApi
     */
    public apiUtilisateursGetCollection(requestParameters: UtilisateursApiApiUtilisateursGetCollectionRequest = {}, options?: RawAxiosRequestConfig) {
        return UtilisateursApiFp(this.configuration).apiUtilisateursGetCollection(requestParameters.page, requestParameters.itemsPerPage, requestParameters.isDeleted, requestParameters.isFormalist, requestParameters.hasG3Access, requestParameters.hasComptaSoftware, requestParameters.hasAccessL2DF, requestParameters.isAdminApps, requestParameters.mail, requestParameters.mail2, requestParameters.user, requestParameters.user2, requestParameters.idSocieteEmployeur, requestParameters.idSocieteEmployeur2, requestParameters.orderId, requestParameters.orderNom, requestParameters.orderUser, requestParameters.orderMail, requestParameters.orderPoleId, requestParameters.orderIdSocieteEmployeur, requestParameters.multiFieldSearch, requestParameters.libGroupeTravail, requestParameters.libGroupeTravailDeleteStatus, requestParameters.idGroupeTravail, requestParameters.idInscriptionDeleteStatus, requestParameters.iduserReferent, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete the user
     * @summary Delete the user
     * @param {UtilisateursApiApiUtilisateursIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilisateursApi
     */
    public apiUtilisateursIdDelete(requestParameters: UtilisateursApiApiUtilisateursIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return UtilisateursApiFp(this.configuration).apiUtilisateursIdDelete(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the selected user informations
     * @summary Returns the selected user informations
     * @param {UtilisateursApiApiUtilisateursIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilisateursApi
     */
    public apiUtilisateursIdGet(requestParameters: UtilisateursApiApiUtilisateursIdGetRequest, options?: RawAxiosRequestConfig) {
        return UtilisateursApiFp(this.configuration).apiUtilisateursIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates only the selected informations of the current user
     * @summary Updates only the selected informations of the current user
     * @param {UtilisateursApiApiUtilisateursIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilisateursApi
     */
    public apiUtilisateursIdPatch(requestParameters: UtilisateursApiApiUtilisateursIdPatchRequest, options?: RawAxiosRequestConfig) {
        return UtilisateursApiFp(this.configuration).apiUtilisateursIdPatch(requestParameters.id, requestParameters.utilisateursUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates the selected user informations
     * @summary Updates the selected user informations
     * @param {UtilisateursApiApiUtilisateursIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilisateursApi
     */
    public apiUtilisateursIdPut(requestParameters: UtilisateursApiApiUtilisateursIdPutRequest, options?: RawAxiosRequestConfig) {
        return UtilisateursApiFp(this.configuration).apiUtilisateursIdPut(requestParameters.id, requestParameters.utilisateursJsonldUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deactivate the user synchronization with keycloak
     * @summary Deactivate the user synchronization with keycloak
     * @param {UtilisateursApiApiUtilisateursIddisableSyncPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilisateursApi
     */
    public apiUtilisateursIddisableSyncPatch(requestParameters: UtilisateursApiApiUtilisateursIddisableSyncPatchRequest, options?: RawAxiosRequestConfig) {
        return UtilisateursApiFp(this.configuration).apiUtilisateursIddisableSyncPatch(requestParameters.id, requestParameters.utilisateursUtilisateurSyncUtilisateur, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Synchronize the user with his keycloak account
     * @summary Synchronize the user with his keycloak account
     * @param {UtilisateursApiApiUtilisateursIdsyncPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilisateursApi
     */
    public apiUtilisateursIdsyncPatch(requestParameters: UtilisateursApiApiUtilisateursIdsyncPatchRequest, options?: RawAxiosRequestConfig) {
        return UtilisateursApiFp(this.configuration).apiUtilisateursIdsyncPatch(requestParameters.id, requestParameters.utilisateursUtilisateurSyncUtilisateur, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a user
     * @summary Create a user
     * @param {UtilisateursApiApiUtilisateursPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilisateursApi
     */
    public apiUtilisateursPost(requestParameters: UtilisateursApiApiUtilisateursPostRequest, options?: RawAxiosRequestConfig) {
        return UtilisateursApiFp(this.configuration).apiUtilisateursPost(requestParameters.utilisateursJsonldUtilisateurWrite, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ApiUtilisateursGetCollectionOrderIdEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type ApiUtilisateursGetCollectionOrderIdEnum = typeof ApiUtilisateursGetCollectionOrderIdEnum[keyof typeof ApiUtilisateursGetCollectionOrderIdEnum];
/**
 * @export
 */
export const ApiUtilisateursGetCollectionOrderNomEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type ApiUtilisateursGetCollectionOrderNomEnum = typeof ApiUtilisateursGetCollectionOrderNomEnum[keyof typeof ApiUtilisateursGetCollectionOrderNomEnum];
/**
 * @export
 */
export const ApiUtilisateursGetCollectionOrderUserEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type ApiUtilisateursGetCollectionOrderUserEnum = typeof ApiUtilisateursGetCollectionOrderUserEnum[keyof typeof ApiUtilisateursGetCollectionOrderUserEnum];
/**
 * @export
 */
export const ApiUtilisateursGetCollectionOrderMailEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type ApiUtilisateursGetCollectionOrderMailEnum = typeof ApiUtilisateursGetCollectionOrderMailEnum[keyof typeof ApiUtilisateursGetCollectionOrderMailEnum];
/**
 * @export
 */
export const ApiUtilisateursGetCollectionOrderPoleIdEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type ApiUtilisateursGetCollectionOrderPoleIdEnum = typeof ApiUtilisateursGetCollectionOrderPoleIdEnum[keyof typeof ApiUtilisateursGetCollectionOrderPoleIdEnum];
/**
 * @export
 */
export const ApiUtilisateursGetCollectionOrderIdSocieteEmployeurEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type ApiUtilisateursGetCollectionOrderIdSocieteEmployeurEnum = typeof ApiUtilisateursGetCollectionOrderIdSocieteEmployeurEnum[keyof typeof ApiUtilisateursGetCollectionOrderIdSocieteEmployeurEnum];


